import { createContext, useContext, useState, useEffect, useMemo } from "react";

const TRANSLATIONS = {
  "pt-BR": {
    "checkout.unavailable_banner": "PAGAMENTOS TEMPORARIAMENTE INDISPONÍVEIS",
    "checkout.unavailable_label": "Estamos quase lá:",
    "checkout.unavailable_help": "O processamento de pagamentos será habilitado em breve. Por enquanto, entre em contato com a nossa equipe pelo e-mail trade@kaffaexchange.com para concluir sua reserva.",
    "checkout.error_payment_unavailable": "Pagamento indisponível no momento. Entraremos em contato em breve.",
    "checkout.errors.card_declined": "Cartão recusado. Tente outro.",
    "checkout.errors.card_invalid": "Número de cartão inválido.",
    "checkout.errors.card_invalid_exp": "Data de validade inválida (use MM/AA).",
    "checkout.errors.card_invalid_cvv": "CVV inválido.",
    "checkout.errors.card_expired": "Cartão vencido.",
    "checkout.errors.date_unavailable": "Data não está mais disponível.",
    "checkout.errors.no_seats": "Vagas insuficientes nessa data.",
    "tours.pay_and_book": "Pagar e reservar",
    "checkout.title": "Finalizar reserva",
    "checkout.subtitle": "Pagamento seguro. Sua reserva é confirmada na hora.",
    "checkout.demo_mode_banner": "MODO DEMO · NENHUMA COBRANÇA REAL SERÁ FEITA",
    "checkout.summary_label": "Resumo do pedido",
    "checkout.row_tour": "Rota",
    "checkout.row_date": "Data",
    "checkout.row_passengers": "Passageiros",
    "checkout.row_duration": "Duração",
    "checkout.row_per_person": "Por pessoa",
    "checkout.row_airport": "Aeroporto",
    "checkout.total": "Total",
    "checkout.security_note": "Os dados do cartão nunca são armazenados em texto puro. Apenas bandeira e últimos 4 dígitos ficam registrados.",
    "checkout.card_label": "Dados do cartão",
    "checkout.card_number": "Número do cartão",
    "checkout.card_name": "Nome impresso no cartão",
    "checkout.card_name_placeholder": "COMO NO CARTÃO",
    "checkout.card_exp": "Validade",
    "checkout.pay_button": "Pagar",
    "checkout.processing": "Processando pagamento…",
    "checkout.success_toast": "Pagamento aprovado",
    "checkout.error_invalid_card": "Verifique os dados do cartão.",
    "checkout.test_cards_label": "Cartões de teste:",
    "checkout.test_success": "aprovação simulada",
    "checkout.test_declined": "recusa simulada",
    "receipt.title": "Comprovante de pagamento",
    "receipt.paid_stamp": "PAGO",
    "receipt.tour": "Rota",
    "receipt.date": "Data",
    "receipt.passengers": "Passageiros",
    "receipt.airport": "Aeroporto",
    "receipt.card": "Cartão",
    "receipt.paid_at": "Pago em",
    "receipt.total_paid": "Total pago",
    "receipt.email_sent": "Comprovante enviado para {email}",
    "receipt.download_pdf": "Baixar PDF",
    "receipt.close": "Fechar",
    "receipt.admin_will_contact": "Nossa equipe entrará em contato em até 24h para confirmar os próximos passos.",
    "admin_tours.req_order": "Pedido",
    "admin_tours.req_payment": "Pagamento",
    "admin_tours.payment_paid": "Pago",
    "admin_tours.payment_unpaid": "Não pago",
    "pending.label": "EM ANÁLISE",
    "pending.title": "Cadastro em análise",
    "pending.subtitle": "Sua solicitação foi recebida e está em análise pela equipe Kaffa Exchange. Você receberá um e-mail assim que for revisada.",
    "pending.rejected_label": "CADASTRO REJEITADO",
    "pending.rejected_title": "Sua solicitação foi rejeitada",
    "pending.rejected_subtitle": "Seu cadastro não foi aprovado nesta análise. Você pode entrar em contato com nossa equipe para esclarecimentos ou enviar uma nova solicitação após corrigir os pontos mencionados.",
    "pending.rejection_reason_label": "Motivo da rejeição",
    "pending.contact_cta": "Falar com a equipe",
    "pending.email": "E-mail",
    "pending.company": "Empresa",
    "pending.country": "País",
    "pending.logout": "Sair",
    "admin.subtab_pending": "Pendentes",
    "admin.subtab_rejected": "Rejeitados",
    "admin.no_rejected": "Nenhum cadastro rejeitado.",
    "admin.col_rejection_reason": "Motivo",
    "admin.col_rejected_at": "Rejeitado em",
    "admin.restore": "Reverter",
    "admin.user_restored": "Cadastro reaberto para revisão",
    "admin.reject_dialog_title": "Rejeitar cadastro",
    "admin.reject_dialog_reason": "Motivo da rejeição",
    "admin.reject_dialog_placeholder": "Ex.: Documentação incompleta. Por favor reenviar com CNPJ ativo e comprovante de endereço.",
    "admin.reject_dialog_help": "O comprador verá esse motivo ao tentar acessar o sistema.",
    // NAV
    "nav.home": "Início",
    "nav.marketplace": "Marketplace",
    "nav.tours": "Visitas às Fazendas",
    "nav.about": "Sobre",
    "nav.login": "Entrar",
    "nav.register": "Cadastrar",
    "nav.dashboard": "Dashboard",
    "nav.logout": "Sair",

    // MISSION
    "mission.tagline": "Nossa Missão",
    "mission.title": "Democratizar o comércio de café trazendo mais dinheiro para o produtor.",
    "mission.subtitle": "Conectamos diretamente cooperativas, produtores e compradores globais — reduzindo intermediários, aumentando rastreabilidade e devolvendo valor justo a quem cultiva.",
    "mission.value1_title": "Justiça econômica",
    "mission.value1_desc": "Comércio direto que devolve margem maior ao produtor e elimina atravessadores.",
    "mission.value2_title": "Rastreabilidade total",
    "mission.value2_desc": "Cada lote tem origem, processo e história documentados.",
    "mission.value3_title": "Tecnologia ao agro",
    "mission.value3_desc": "Engine de precificação, indicadores globais e dashboards modernos.",
    "mission.value4_title": "Sustentabilidade",
    "mission.value4_desc": "Priorizamos cooperativas com certificações ambientais e sociais.",

    // TEAM
    "team.tagline": "Quem está por trás",
    "team.title": "O time da Kaffa Exchange",
    "team.subtitle": "Direito, tecnologia, estratégia e café. Quatro lideranças que conectam tradição centenária da cafeicultura à infraestrutura digital do comércio global.",
    "team.member1_name": "Guilherme Barbosa",
    "team.member1_role": "CEO · Direito do Agronegócio",
    "team.member1_bio": "Advogado formado na Faculdade de Direito da USP (Largo São Francisco), especialista em Direito do Agronegócio com seis anos de atuação na área, e em Direito Empresarial e Tributário. Além da experiência jurídica, tem envolvimento direto com a cafeicultura no negócio familiar — uma fazenda de café em Poços de Caldas dirigida por sua família desde 1939.",
    "team.member2_name": "Alex Philippe",
    "team.member2_role": "COO · Operações & Estratégia",
    "team.member2_bio": "Founder da Arcano Projetos de Tecnologia, startup que entregou projetos de inovação para grandes corporações como BRF, CBA e ArcelorMittal, e da Rent a Squad — outsourcing de tecnologia proprietária da metodologia Torke®. Conselheiro, mentor e avaliador em programas como SEED MG, SEED MS, Capital Empreendedor e Vumbora Startups.",
    "team.member3_name": "Célio Sales",
    "team.member3_role": "CTO · Tecnologia & Inovação",
    "team.member3_bio": "Consultor estratégico com passagem por multinacionais de renome como Alcoa. Lidera a operação da Kaffa Exchange com foco em excelência logística, processos escaláveis e governança corporativa.",
    "team.member4_name": "Valdeci Miguel",
    "team.member4_role": "CQO · Qualidade & Café",
    "team.member4_bio": "Administrador de empresas com mais de 30 anos no setor cafeeiro. Domina o processo de beneficiamento, exportação, controle de qualidade e gestão de clientes estratégicos — referência técnica do time.",

    // TOURS
    "tours.public_title": "Visite as origens. Feche contratos direto com o produtor.",
    "tours.public_subtitle": "Programas privados de visita técnica a fazendas premiadas, conduzidos pela Kaffa Exchange para compradores qualificados e importadores. Cupping, due diligence operacional, encontros com os produtores e fechamento de contratos no campo.",
    "tours.eyebrow": "Visitas técnicas · Programa B2B",
    "tours.benefit_cupping": "Mesa de cupping SCA com produtores",
    "tours.benefit_producers": "Audiência direta com cafeicultores",
    "tours.benefit_diligence": "Due diligence operacional + sample lab",
    "tours.benefit_logistics": "Hospedagem, transfer e tradutor inclusos",
    "tours.eligibility_note": "Programa exclusivo para compradores, importadores, head-buyers e empresas com volume mínimo qualificado. Cada itinerário é validado pelo nosso desk comercial.",
    "tours.passenger_info_title": "Passageiros",
    "tours.passenger_info_subtitle": "Nome completo e documento de cada passageiro — usado para reserva e check-in nas fazendas.",
    "tours.passenger_n": "Passageiro {n}",
    "tours.field_full_name": "Nome completo",
    "tours.field_doc_number": "Número do documento",
    "tours.field_doc_country": "País emissor (apenas passaporte)",
    "tours.doc_passport": "Passaporte",
    "tours.doc_cpf": "CPF",
    "tours.doc_rg": "RG",
    "tours.doc_other": "Outro",
    "tours.single_supplement_label": "Suplemento de viajante individual · +50%",
    "tours.single_supplement_note": "Reservas de 1 vaga têm acréscimo de 50% sobre o preço/pessoa, conforme prática de pacotes de viagem corporativos.",
    "tours.subtotal": "Preço base · 1 pax",
    "tours.supplement_line": "Suplemento single (+50%)",
    "tours.error_passenger_info": "Preencha nome e documento de todos os passageiros.",
    "tours.cta": "Explorar Rotas",
    "tours.duration": "Duração",
    "tours.from_price": "A partir de",
    "tours.per_person": "/ pessoa",
    "tours.region": "Região",
    "tours.farms": "Fazendas",
    "tours.farms_count": "fazendas",
    "tours.highlights": "Destaques",
    "tours.includes": "Está incluso",
    "tours.gallery": "Galeria",
    "tours.request_title": "Solicitar este tour",
    "tours.duration_days": "Duração do tour",
    "tours.days": "dias",
    "tours.airport": "Aeroporto de origem",
    "tours.airport_help": "Vamos buscá-lo no aeroporto escolhido (ida e volta).",
    "tours.passengers": "Pessoas",
    "tours.start_date": "Data preferencial",
    "tours.notes": "Observações",
    "tours.notes_placeholder": "Restrições alimentares, interesses específicos, datas alternativas...",
    "tours.estimate": "Estimativa de investimento",
    "tours.price_per_pax": "Por pessoa",
    "tours.total_price": "Total estimado",
    "tours.submit": "Solicitar Tour",
    "tours.success": "Solicitação enviada! Entraremos em contato em breve.",
    "tours.login_required": "Faça login para solicitar este tour",
    "tours.includes_title": "Tudo incluso no tour",
    "tours.see_route": "Ver Rota",
    "tours.best_season": "Melhor época",
    "tours.farms_visited": "Fazendas visitadas",
    "tours.altitude": "Altitude",
    "tours.specialty": "Especialidade",
    "tours.airports_supported": "Aeroportos atendidos",
    "tours.summary": "Resumo",

    // COMMON
    "common.bags": "sacas",
    "common.region": "Região",
    "common.process": "Processo",
    "common.search": "Buscar lotes, fazendas, regiões...",
    "common.all": "Todos",
    "common.cancel": "Cancelar",
    "common.confirm": "Confirmar",
    "common.save": "Salvar",
    "common.loading": "Carregando...",
    "common.send": "Enviar",
    "common.edit": "Editar",
    "common.delete": "Remover",
    "common.create": "Criar",
    "common.actions": "Ações",
    "common.status": "Status",
    "common.date": "Data",
    "common.optional": "opcional",
    "common.back": "Voltar",
    "common.demo_creds": "Credenciais de demonstração",

    // HERO
    "hero.tagline": "KAFFA EXCHANGE · COMMODITY TRADING",
    "hero.title": "O mercado global do café, digitalizado.",
    "hero.subtitle": "Plataforma B2B de negociação e exportação que conecta cooperativas produtoras a compradores internacionais.",
    "hero.cta_explore": "Explorar Lotes",
    "hero.cta_register": "Cadastrar Empresa",
    "hero.stat_bags": "Sacas/mês",
    "hero.stat_coops": "Cooperativas",
    "hero.stat_countries": "Países",
    "hero.live_market": "Live Market",

    // TICKER
    "ticker.label": "MERCADO GLOBAL",

    // PILLARS
    "pillar.verify.title": "Verificação Completa",
    "pillar.verify.desc": "Todo comprador passa por aprovação manual do backoffice.",
    "pillar.export.title": "Exportação Global",
    "pillar.export.desc": "FOB Santos pronto. Logística internacional integrada.",
    "pillar.pricing.title": "Pricing Dinâmico",
    "pillar.pricing.desc": "Engine recalcula preços via indicadores globais em tempo real.",
    "pillar.trace.title": "Rastreabilidade",
    "pillar.trace.desc": "Do produtor à xícara: fazenda, altitude, processo, SCA.",

    // LOTS PUBLIC
    "lots.public_title": "Lotes Disponíveis",
    "lots.public_subtitle": "Catálogo público — preços e detalhes completos liberados após aprovação do cadastro.",
    "lots.active": "lotes ativos",
    "lots.locked": "Faça login para ver preços e detalhes completos",
    "lots.available": "Disponível",
    "lots.price_label": "Saca 60kg",
    "lots.empty": "Nenhum lote encontrado com os filtros aplicados.",
    "lots.filter_type": "Tipos",
    "lots.filter_process": "Processos",
    "lots.filter_region": "Regiões",

    // AUTH
    "auth.login_title": "Entrar na Kaffa Exchange",
    "auth.register_title": "Criar Conta Empresarial",
    "auth.email": "E-mail",
    "auth.password": "Senha",
    "auth.razao_social": "Razão Social",
    "auth.cnpj": "CNPJ / Tax ID",
    "auth.address": "Endereço Completo",
    "auth.phone": "Telefone",
    "auth.country": "País",
    "auth.commercial": "Responsável Comercial",
    "auth.submit_login": "Entrar",
    "auth.submit_register": "Solicitar Cadastro",
    "auth.no_account": "Ainda não tem conta?",
    "auth.has_account": "Já possui conta?",
    "auth.request_signup": "Solicitar cadastro",
    "auth.signin": "Entrar",

    // LOGIN BANNER
    "login.tagline": "Trading Desk · Kaffa Exchange",
    "login.banner_title": "Acesso restrito a operadores aprovados.",
    "login.banner_subtitle": "Cooperativas, compradores e administradores acessam o mercado por aqui.",
    "login.signin_label": "Sign In",

    // REGISTER
    "register.tagline": "Onboarding · B2B",
    "register.intro": "O cadastro é destinado a empresas importadoras e operadores comerciais. Após o envio, nossa equipe valida os dados antes de liberar o acesso completo ao mercado.",
    "register.verification": "Verificação compliance",
    "register.verification_desc": "KYC empresarial em até 48h. Após aprovação, você visualiza preços, scores SCA, certificações e pode enviar propostas.",
    "register.success": "Cadastro enviado para análise",
    "register.placeholder_razao": "Müller Global Coffee Imports GmbH",
    "register.placeholder_cnpj": "00.000.000/0001-00",
    "register.placeholder_country": "Brasil / Alemanha / USA...",
    "register.placeholder_address": "Rua, número, bairro, cidade, CEP, país",
    "register.placeholder_phone": "+55 11 99999-0000",
    "register.placeholder_contact": "Nome do responsável",
    "register.placeholder_email": "contato@empresa.com",
    "register.placeholder_password": "Mínimo 6 caracteres",
    "register.submitting": "Enviando...",

    // PENDING
    "pending.tagline": "Status · Análise",
    "pending.message": "Seu cadastro foi recebido e está sob análise pela equipe Kaffa. Você receberá um e-mail assim que aprovado.",
    "pending.submitted_data": "Dados enviados",
    "pending.step1": "Cadastro recebido",
    "pending.step2": "Em análise pelo backoffice (até 48h)",
    "pending.step3": "Aprovação e liberação de acesso",
    "pending.view_market": "Ver Marketplace",

    // ALERTS
    "alerts.label": "Alertas",
    "alerts.new": "novos",
    "alerts.mark_read": "Marcar lidos",
    "alerts.empty": "Sem alertas no momento.",

    // FOOTER
    "footer.subtitle": "Plataforma B2B de comercialização e exportação de café. Conectando cooperativas produtoras a compradores internacionais com rastreabilidade e tecnologia.",
    "footer.platform": "Plataforma",
    "footer.contact": "Contato",

    // LOT DETAIL
    "lot.tab_details": "Detalhes",
    "lot.tab_certs": "Certificações",
    "lot.tab_docs": "Documentos",
    "lot.tab_history": "Histórico de preço",
    "lot.origin": "Origem",
    "lot.cooperative": "Cooperativa",
    "lot.notes": "Notas sensoriais",
    "lot.altitude": "Altitude",
    "lot.sieve": "Peneira",
    "lot.crop": "Safra",
    "lot.humidity": "Umidade",
    "lot.blend": "Blend",
    "lot.fob": "FOB",
    "lot.demo_interest": "Demonstrar Interesse",
    "lot.demo_interest_short": "Interesse",
    "lot.propose": "Fazer Proposta",
    "lot.propose_short": "Proposta",
    "lot.propose_title": "Enviar proposta",
    "lot.interest_title": "Demonstrar interesse",
    "lot.bags_qty": "Quantidade (sacas)",
    "lot.price_label": "Preço/saca",
    "lot.message_label": "Mensagem",
    "lot.message_placeholder": "Termos de entrega, datas, observações...",
    "lot.send_proposal": "Enviar proposta",
    "lot.send_interest": "Enviar interesse",
    "lot.not_found": "Lote não encontrado",
    "lot.no_certs": "Sem certificações registradas.",
    "lot.no_docs": "Nenhum documento anexado.",
    "lot.no_history": "Sem histórico de variação registrado. Ative auto-pricing para registrar mudanças automáticas.",
    "lot.proposal_sent": "Proposta enviada à cooperativa",
    "lot.interest_sent": "Interesse registrado",
    "lot.auto_priced": "AUTO-PRICED · Margem",
    "lot.total_volume": "Volume total",
    "lot.available_qty": "Disponível",
    "lot.bag_price": "Saca 60kg",

    // BUYER DASHBOARD
    "buyer.desk": "Buyer Desk",
    "buyer.title": "Painel do Comprador",
    "buyer.subtitle": "Marketplace completo, suas propostas e interesses.",
    "buyer.tab_market": "Mercado",
    "buyer.tab_proposals": "Minhas Propostas",
    "buyer.tab_interests": "Interesses",
    "buyer.col_lot": "Lote",
    "buyer.col_proposed_price": "Preço Proposto",
    "buyer.col_bags": "Sacas",
    "buyer.col_counter": "Contra-proposta",
    "buyer.no_proposals": "Nenhuma proposta enviada.",
    "buyer.no_interests": "Nenhum interesse registrado.",

    // COOP DASHBOARD
    "coop.desk": "Cooperative Desk",
    "coop.title": "Gestão de Lotes",
    "coop.new_lot": "Novo Lote",
    "coop.kpi_active": "Lotes ativos",
    "coop.kpi_bags": "Total sacas",
    "coop.kpi_pending_props": "Propostas pendentes",
    "coop.kpi_interests": "Interesses",
    "coop.tab_lots": "Lotes",
    "coop.tab_proposals": "Propostas",
    "coop.tab_interests": "Interesses",
    "coop.col_lot": "Lote",
    "coop.col_type": "Tipo",
    "coop.col_bags": "Sacas",
    "coop.col_price": "Preço",
    "coop.col_auto": "Auto",
    "coop.col_buyer": "Comprador",
    "coop.no_proposals": "Nenhuma proposta recebida.",
    "coop.no_interests": "Nenhum interesse.",
    "coop.accept": "Aceitar",
    "coop.reject": "Rejeitar",
    "coop.delete_confirm": "Remover este lote?",
    "coop.lot_removed": "Lote removido",
    "coop.lot_updated": "Status atualizado",
    "coop.price_recalc": "Preço recalculado",
    "coop.lot_published": "Lote publicado",
    "coop.lot_edited": "Lote atualizado",
    "coop.response_sent": "Resposta enviada",
    "coop.edit_lot": "Editar Lote",
    "coop.create_lot": "Novo Lote",
    "coop.update": "Atualizar",
    "coop.publish": "Publicar lote",
    "coop.field_name": "Nome do lote",
    "coop.field_quality": "Qualidade",
    "coop.field_currency": "Moeda",
    "coop.field_sca": "SCA Score",
    "coop.field_farm": "Fazenda",
    "coop.field_city": "Cidade",
    "coop.field_state": "Estado",
    "coop.field_port": "Porto FOB",
    "coop.field_images": "URL Imagem (separadas por vírgula)",
    "coop.field_certs": "Certificações (separadas por vírgula)",
    "coop.field_notes": "Observações",
    "coop.auto_title": "Atualização Automática de Preço",
    "coop.auto_desc": "A engine recalcula o preço usando indicadores globais (NY Futures, USD/BRL, FOB, demanda).",
    "coop.margin": "Margem própria (%)",

    // ADMIN
    "admin.desk": "Backoffice · Admin Control Room",
    "admin.title": "Dashboard Administrativo",
    "admin.kpi_active_lots": "Lotes ativos",
    "admin.kpi_bags": "Sacas/Mercado",
    "admin.kpi_buyers": "Compradores ativos",
    "admin.kpi_pending": "Pendentes",
    "admin.kpi_coops": "Cooperativas",
    "admin.kpi_props": "Propostas",
    "admin.chart_region": "Volume por região (sacas)",
    "admin.chart_types": "Mix de tipos de café",
    "admin.tab_approvals": "Aprovações",
    "admin.tab_users": "Usuários",
    "admin.tab_coops": "Cooperativas",
    "admin.tab_lots": "Lotes",
    "admin.tab_proposals": "Negociações",
    "admin.tab_indicators": "Indicadores",
    "admin.col_company": "Empresa",
    "admin.col_name": "Nome",
    "admin.col_role": "Role",
    "admin.no_pending": "Nenhuma aprovação pendente.",
    "admin.approve": "Aprovar",
    "admin.reject": "Rejeitar",
    "admin.user_approved": "Comprador aprovado",
    "admin.user_rejected": "Comprador rejeitado",
    "admin.coop_created": "Cooperativa criada",
    "admin.coop_user_created": "Usuário cooperativa criado",
    "admin.indicator_updated": "Indicador atualizado",
    "admin.new_coop": "Nova Cooperativa",
    "admin.new_coop_user": "Novo Usuário Cooperativa",
    "admin.coop_descr_label": "Descrição",
    "admin.indicators_help": "Os indicadores alimentam o motor de auto-pricing. Edite os valores para simular cenários de mercado.",
    "admin.select_coop": "Selecione...",

    // STATUS BADGES
    "status.pending": "Pendente",
    "status.approved": "Aprovado",
    "status.rejected": "Rejeitada",
    "status.accepted": "Aceita",
    "status.counter": "Contraproposta",
    "status.closed": "Encerrada",
    "status.new": "Novo",
    "status.contacted": "Em contato",
    "status.published": "Publicado",
    "status.paused": "Pausado",
    "status.draft": "Rascunho",
    "status.sold": "Vendido",
    "status.expired": "Expirado",
    "status.active": "Ativo",

    // LOGIN WELCOME
    "login.welcome": "Bem-vindo",

    // COFFEE DATA (translated values for filters & lot fields)
    "data.coffee.arabica": "Arábica",
    "data.coffee.conilon": "Conilon",
    "data.coffee.robusta": "Robusta",
    "data.coffee.especial": "Especial",
    "data.coffee.microlote": "Microlote",
    "data.coffee.gourmet": "Gourmet",
    "data.process.natural": "Natural",
    "data.process.washed": "Lavado",
    "data.process.honey": "Honey",
    "data.process.pulped_natural": "Cereja Descascada",
    "data.process.anaerobic": "Anaeróbico",
    "data.process.fermentado": "Fermentado",
    "data.quality.commercial": "Comercial",
    "data.quality.premium": "Premium",
    "data.quality.specialty": "Especial",
    "data.quality.microlot": "Microlote",
    "data.region.sul_de_minas": "Sul de Minas",
    "data.region.cerrado_mineiro": "Cerrado Mineiro",
    "data.region.alta_mogiana": "Alta Mogiana",
    "data.region.chapada_diamantina": "Chapada Diamantina",
    "data.region.espirito_santo": "Espírito Santo",

    // HERO / HOME extras
    "hero.live_arabica": "Arábica",
    "hero.live_ny_futures": "NY Futures",
    "home.experiences_label": "KAFFA EXPERIENCES · ROTAS DE ORIGEM",
    "home.airport_pickup": "Transfer aeroporto",
    "home.translator": "Tradutor (PT/EN/ES)",
    "home.sca_cupping": "Cupping SCA",

    // TEAM extras
    "team.leadership": "KAFFA · LIDERANÇA",
    "team.photo_soon": "Foto · em breve",

    // TOURS extras
    "tours.not_found": "Tour não encontrado",
    "tours.contact_disclaimer": "A Kaffa Exchange entrará em contato para confirmar disponibilidade, datas e ajustes finais.",
    "tours.pax_short": "pax",

    // ADMIN extras
    "admin.live_label": "AO VIVO · Alpha Vantage",
    "admin.refresh_indicators": "Atualizar indicadores",
    "admin.refresh_done": "Indicadores atualizados",
    "admin.refresh_partial": "Atualização parcial — alguns indicadores podem estar usando valores anteriores",
    "admin.refresh_failed": "Falha ao atualizar indicadores",

    // COOP toasts
    "coop.toast.lot_updated": "Lote atualizado",
    "coop.toast.lot_published": "Lote publicado",
    "coop.toast.lot_removed": "Lote removido",
    "coop.toast.status_updated": "Status atualizado",
    "coop.toast.price_recalc": "Preço recalculado",
    "coop.toast.response_sent": "Resposta enviada",
    "coop.confirm_delete": "Remover este lote?",
    "coop.no_proposals_received": "Nenhuma proposta recebida.",
    "coop.accept_btn": "Aceitar",
    "coop.reject_btn": "Rejeitar",

    // LOT extras
    "lot.interest_default_msg": "Solicito amostras e ficha técnica completa.",
    "sample.request_btn": "Solicitar amostra",
    "sample.dialog_title": "Solicitar amostra física",
    "sample.dialog_subtitle": "Receba amostras do lote em seu endereço para avaliação sensorial.",
    "sample.shipping_title": "Endereço de entrega",
    "sample.use_profile_address": "Usar endereço cadastrado",
    "sample.use_new_address": "Informar novo endereço",
    "sample.field_recipient": "Destinatário",
    "sample.field_address": "Endereço",
    "sample.field_address_placeholder": "Rua, número, complemento",
    "sample.field_city": "Cidade",
    "sample.field_state": "Estado / Província",
    "sample.field_country": "País",
    "sample.field_postal": "CEP / ZIP",
    "sample.field_phone": "Telefone para contato",
    "sample.field_notes": "Observações para a cooperativa",
    "sample.field_notes_placeholder": "Ex.: prioridade, ficha técnica desejada, prazo...",
    "sample.send_btn": "Enviar solicitação",
    "sample.error_bags": "Informe a quantidade de sacas.",
    "sample.error_address": "Preencha endereço, cidade e país.",
    "sample.success_toast": "Solicitação de amostra enviada",
    "sample.success_description": "A cooperativa receberá um alerta e iniciará a preparação. Você poderá acompanhar o rastreio por aqui.",
    "samples.col_lot": "Lote",
    "samples.col_buyer": "Comprador",
    "samples.col_bags": "Sacas",
    "samples.col_shipping": "Entrega",
    "samples.col_tracking": "Rastreio",
    "samples.col_status": "Status",
    "samples.col_date": "Data",
    "samples.address_profile": "Endereço do cadastro",
    "samples.tracking_pending": "Aguardando",
    "samples.status_new": "Nova",
    "samples.status_preparing": "Preparando",
    "samples.status_shipped": "Enviada",
    "samples.status_delivered": "Entregue",
    "samples.status_unavailable": "Indisponível",
    "samples.manage_btn": "Gerenciar",
    "samples.manage_title": "Gerenciar amostra",
    "samples.manage_subtitle": "Atualize status, número de rastreio e transportadora.",
    "samples.field_status": "Status",
    "samples.field_tracking_number": "Número de rastreio",
    "samples.field_tracking_carrier": "Transportadora",
    "samples.field_tracking_url": "URL de rastreio",
    "samples.field_internal_notes": "Notas internas",
    "samples.save_btn": "Salvar",
    "samples.toast_updated": "Amostra atualizada",
    "samples.no_samples": "Nenhuma amostra registrada.",
    "buyer.tab_samples": "Amostras",
    "buyer.no_samples": "Nenhuma amostra solicitada.",
    "coop.tab_samples": "Amostras",
    "coop.no_samples": "Nenhuma solicitação de amostra.",
    "admin.tab_samples": "Amostras",
    "admin.no_samples": "Nenhuma solicitação de amostra registrada.",
    "lot.bags_unit": "kg total",

    // FOOTER extras
    "footer.version": "v1.0 · Plataforma B2B de Café",
    "footer.location": "São Paulo · Brasil",
    "footer.copyright": "© 2026 KAFFA EXCHANGE",

    "indicator.arabica_ny": "Arábica NY",
    "indicator.conilon_es": "Conilon ES",
    "indicator.usd_brl": "USD / BRL",
    "indicator.usd_eur": "USD / EUR",
    "indicator.fob_santos": "FOB Santos",
    "indicator.export_br": "Exportação Brasil",
    "indicator.infl_br": "Inflação Brasil",
    "indicator.demand_global": "Demanda Global",
    "settings.theme": "Tema",

    "pwa.tagline": "KAFFA · APP",
    "pwa.install_title": "Instale o app Kaffa",
    "pwa.install_subtitle": "Acesso rápido a lotes, preços e visitas direto da tela inicial.",
    "pwa.install_cta": "Instalar",
    "pwa.dismiss": "Agora não",

    "admin.tab_visits": "Visitas",
    "status.archived": "Arquivado",
    "status.confirmed": "Confirmado",
    "status.cancelled": "Cancelado",
    "status.completed": "Concluído",
    "status.preparing": "Preparando",
    "status.shipped": "Enviada",
    "status.delivered": "Entregue",
    "status.unavailable": "Indisponível",

    "admin_tours.subtab_packages": "Pacotes",
    "admin_tours.subtab_requests": "Pedidos",
    "admin_tours.packages_help": "Crie e gerencie os pacotes de visita às fazendas exibidos publicamente em /tours.",
    "admin_tours.requests_help": "Pedidos recebidos via /tours. Confirme, cancele ou marque como concluído.",
    "admin_tours.new_btn": "Novo pacote",
    "admin_tours.empty": "Nenhum pacote cadastrado.",
    "admin_tours.req_empty": "Nenhum pedido recebido.",
    "admin_tours.col_name": "Nome",
    "admin_tours.col_base_price": "Preço base",
    "admin_tours.col_status": "Status",
    "admin_tours.farms_count": "fazendas",
    "admin_tours.publish": "Publicar",
    "admin_tours.draft": "Rascunho",
    "admin_tours.dialog_new": "Novo pacote de visita",
    "admin_tours.dialog_edit": "Editar pacote",
    "admin_tours.form_required": "Preencha nome, região e resumo (PT).",
    "admin_tours.field_name": "Nome",
    "admin_tours.field_country": "País",
    "admin_tours.field_hero_image": "Imagem de capa (URL)",
    "admin_tours.field_gallery": "Galeria (URLs)",
    "admin_tours.field_summary": "Resumo",
    "admin_tours.field_highlights": "Destaques",
    "admin_tours.field_farms": "Fazendas",
    "admin_tours.field_includes": "O que está incluso",
    "admin_tours.field_airports": "Aeroportos suportados",
    "admin_tours.field_seasons": "Melhores épocas",
    "admin_tours.field_durations": "Durações (dias)",
    "admin_tours.hint_one_per_line": "Um item por linha.",
    "admin_tours.hint_farms": "Um por linha: Nome | Cidade | Altitude | Especialidade",
    "admin_tours.hint_durations": "Lista separada por vírgula (ex.: 7, 10, 15).",
    "admin_tours.status_draft": "Rascunho",
    "admin_tours.status_published": "Publicado",
    "admin_tours.status_archived": "Arquivado",
    "admin_tours.toast_created": "Pacote criado",
    "admin_tours.toast_updated": "Pacote atualizado",
    "admin_tours.toast_status": "Status atualizado",
    "admin_tours.toast_removed": "Pacote removido",
    "admin_tours.req_toast_updated": "Pedido atualizado",
    "admin_tours.confirm_delete": "Remover este pacote?",
    "admin_tours.save_btn": "Salvar",
    "admin_tours.create_btn": "Criar",
    "admin_tours.req_buyer": "Comprador",
    "admin_tours.req_tour": "Pacote",
    "admin_tours.req_total": "Total",
    "admin_tours.req_when": "Quando",
    "admin_tours.req_pending": "Pendentes",
    "admin_tours.req_confirmed": "Confirmados",
    "admin_tours.req_cancelled": "Cancelados",
    "admin_tours.req_completed": "Concluídos",
    "admin_tours.confirm": "Confirmar",
    "admin_tours.cancel": "Cancelar",
    "admin_tours.complete": "Concluir",

    "admin_tours.col_days": "Dias",
    "admin_tours.col_seats": "Vagas",
    "admin_tours.section_image": "Foto de capa",
    "admin_tours.section_basic": "Informações básicas",
    "admin_tours.section_pricing": "Preço & disponibilidade",
    "admin_tours.section_content": "Conteúdo",
    "admin_tours.section_extras": "Extras",
    "admin_tours.hero_replace_help": "Você pode trocar a foto (JPG / PNG / WebP).",
    "admin_tours.replace_image": "Trocar imagem",
    "admin_tours.remove_image": "Remover",
    "admin_tours.image_uploading": "Enviando…",
    "admin_tours.image_upload_cta": "Enviar imagem",
    "admin_tours.image_hint": "JPG / PNG / WebP · até {mb} MB",
    "admin_tours.field_duration_days": "Duração (dias)",
    "admin_tours.duration_hint": "Número fixo de dias por rota (ex.: 7, 10, 15).",
    "admin_tours.field_price_per_person": "Preço por pessoa (USD)",
    "admin_tours.price_hint": "Preço fixo por pacote. Não há cálculo proporcional.",
    "admin_tours.field_dates_seats": "Datas de saída & vagas",
    "admin_tours.pick_dates": "Escolher datas",
    "admin_tours.dates_empty": "Nenhuma data ainda. Clique em \"Escolher datas\".",
    "admin_tours.seats_label": "Vagas",
    "admin_tours.field_description": "Descrição detalhada",
    "admin_tours.description_hint": "Suporta texto longo em múltiplos parágrafos.",
    "admin_tours.summary_hint": "Resumo curto exibido em listas e busca.",
    "admin_tours.err_not_image": "O arquivo selecionado não é uma imagem.",
    "admin_tours.err_image_too_big": "Imagem grande demais. Máx {mb} MB.",
    "admin_tours.err_image_read": "Não foi possível ler a imagem.",
    "tours.choose_date": "Escolha a data de saída",
    "tours.seats_left": "vagas restantes",
    "tours.pick_date_first": "Escolha uma data primeiro.",
    "tours.not_enough_seats": "Vagas insuficientes nessa data.",
    "tours.about_label": "Sobre esta rota",
  },

  "en": {
    "checkout.unavailable_banner": "PAYMENTS TEMPORARILY UNAVAILABLE",
    "checkout.unavailable_label": "Almost there:",
    "checkout.unavailable_help": "Card processing will be enabled shortly. In the meantime, please contact our team at trade@kaffaexchange.com to finalize your booking.",
    "checkout.error_payment_unavailable": "Payments are unavailable right now. We'll be in touch shortly.",
    "checkout.errors.card_declined": "Card declined. Please try another card.",
    "checkout.errors.card_invalid": "Invalid card number.",
    "checkout.errors.card_invalid_exp": "Invalid expiry (use MM/YY).",
    "checkout.errors.card_invalid_cvv": "Invalid CVV.",
    "checkout.errors.card_expired": "Card expired.",
    "checkout.errors.date_unavailable": "Date no longer available.",
    "checkout.errors.no_seats": "Not enough seats on that date.",
    "tours.pay_and_book": "Pay & book",
    "checkout.title": "Complete your booking",
    "checkout.subtitle": "Secure checkout. Your booking is confirmed instantly.",
    "checkout.demo_mode_banner": "DEMO MODE · NO REAL CHARGE WILL BE MADE",
    "checkout.summary_label": "Order summary",
    "checkout.row_tour": "Tour",
    "checkout.row_date": "Date",
    "checkout.row_passengers": "Passengers",
    "checkout.row_duration": "Duration",
    "checkout.row_per_person": "Per person",
    "checkout.row_airport": "Airport",
    "checkout.total": "Total",
    "checkout.security_note": "Card data is never stored in cleartext — only brand + last 4 digits are kept on file.",
    "checkout.card_label": "Card details",
    "checkout.card_number": "Card number",
    "checkout.card_name": "Name on card",
    "checkout.card_name_placeholder": "AS ON CARD",
    "checkout.card_exp": "Expiry",
    "checkout.pay_button": "Pay",
    "checkout.processing": "Processing payment…",
    "checkout.success_toast": "Payment approved",
    "checkout.error_invalid_card": "Please check the card details.",
    "checkout.test_cards_label": "Test cards:",
    "checkout.test_success": "simulated success",
    "checkout.test_declined": "simulated decline",
    "receipt.title": "Payment receipt",
    "receipt.paid_stamp": "PAID",
    "receipt.tour": "Tour",
    "receipt.date": "Date",
    "receipt.passengers": "Passengers",
    "receipt.airport": "Airport",
    "receipt.card": "Card",
    "receipt.paid_at": "Paid at",
    "receipt.total_paid": "Total paid",
    "receipt.email_sent": "Receipt emailed to {email}",
    "receipt.download_pdf": "Download PDF",
    "receipt.close": "Close",
    "receipt.admin_will_contact": "Our team will reach out within 24h to confirm next steps.",
    "admin_tours.req_order": "Order",
    "admin_tours.req_payment": "Payment",
    "admin_tours.payment_paid": "Paid",
    "admin_tours.payment_unpaid": "Unpaid",
    "pending.label": "UNDER REVIEW",
    "pending.title": "Application under review",
    "pending.subtitle": "Your application has been received and is being reviewed by the Kaffa Exchange team. You'll receive an email once it's processed.",
    "pending.rejected_label": "APPLICATION REJECTED",
    "pending.rejected_title": "Your application was rejected",
    "pending.rejected_subtitle": "Your registration was not approved in this review. You can contact our team for clarification or submit a new application after addressing the points listed below.",
    "pending.rejection_reason_label": "Rejection reason",
    "pending.contact_cta": "Contact the team",
    "pending.email": "Email",
    "pending.company": "Company",
    "pending.country": "Country",
    "pending.logout": "Sign out",
    "admin.subtab_pending": "Pending",
    "admin.subtab_rejected": "Rejected",
    "admin.no_rejected": "No rejected registrations.",
    "admin.col_rejection_reason": "Reason",
    "admin.col_rejected_at": "Rejected at",
    "admin.restore": "Restore",
    "admin.user_restored": "Registration reopened for review",
    "admin.reject_dialog_title": "Reject registration",
    "admin.reject_dialog_reason": "Rejection reason",
    "admin.reject_dialog_placeholder": "E.g.: Incomplete documentation. Please resubmit with active Tax ID and proof of address.",
    "admin.reject_dialog_help": "The buyer will see this reason when trying to access the system.",
    "nav.home": "Home",
    "nav.marketplace": "Marketplace",
    "nav.tours": "Farm Visits",
    "nav.about": "About",
    "nav.login": "Sign in",
    "nav.register": "Register",
    "nav.dashboard": "Dashboard",
    "nav.logout": "Log out",

    "mission.tagline": "Our Mission",
    "mission.title": "Democratize coffee trade by bringing more money back to the producer.",
    "mission.subtitle": "We directly connect cooperatives, producers and global buyers — cutting middlemen, increasing traceability and returning fair value to those who cultivate.",
    "mission.value1_title": "Economic fairness",
    "mission.value1_desc": "Direct trade that returns greater margin to producers and removes intermediaries.",
    "mission.value2_title": "Full traceability",
    "mission.value2_desc": "Every lot has documented origin, process and story.",
    "mission.value3_title": "Tech for agro",
    "mission.value3_desc": "Pricing engine, global indicators and modern dashboards.",
    "mission.value4_title": "Sustainability",
    "mission.value4_desc": "We prioritize cooperatives with environmental and social certifications.",

    "team.tagline": "Behind the platform",
    "team.title": "The Kaffa Exchange team",
    "team.subtitle": "Law, technology, strategy and coffee. Four leaders connecting century-old coffee tradition to the digital infrastructure of global trade.",
    "team.member1_name": "Guilherme Barbosa",
    "team.member1_role": "CEO · Agribusiness Law",
    "team.member1_bio": "Attorney from USP Law School (Largo São Francisco), specialist in Agribusiness Law with six years of practice in the field, plus Corporate and Tax Law. Beyond the legal experience, he has direct involvement with coffee farming through the family business — a coffee farm in Poços de Caldas run by his family since 1939.",
    "team.member2_name": "Alex Philippe",
    "team.member2_role": "COO · Operations & Strategy",
    "team.member2_bio": "Founder of Arcano Projetos de Tecnologia, a startup that delivered innovation projects for corporations like BRF, CBA and ArcelorMittal, and of Rent a Squad — a tech outsourcing firm owning the Torke® development methodology. Board member, mentor and evaluator at programs such as SEED MG, SEED MS, Capital Empreendedor and Vumbora Startups.",
    "team.member3_name": "Célio Sales",
    "team.member3_role": "CTO · Technology & Innovation",
    "team.member3_bio": "Strategic consultant with experience at renowned multinationals like Alcoa. Leads Kaffa Exchange operations with a focus on logistics excellence, scalable processes and corporate governance.",
    "team.member4_name": "Valdeci Miguel",
    "team.member4_role": "CQO · Quality & Coffee",
    "team.member4_bio": "Business administrator with over 30 years in the coffee sector. Masters the beneficiation process, export, quality control and strategic client management — the team's technical reference.",

    "tours.public_title": "Visit the origin. Close contracts directly with the producer.",
    "tours.public_subtitle": "Private technical visits to award-winning farms, curated by Kaffa Exchange for qualified buyers and importers. SCA cupping, operational due diligence, direct meetings with growers and on-site contract closing.",
    "tours.eyebrow": "Technical visits · B2B program",
    "tours.benefit_cupping": "SCA cupping table with producers",
    "tours.benefit_producers": "Face-to-face with the growers",
    "tours.benefit_diligence": "Operational due diligence + sample lab",
    "tours.benefit_logistics": "Lodging, transfer and translator included",
    "tours.eligibility_note": "Exclusive program for buyers, importers, head-buyers and companies with qualified volume. Each itinerary is validated by our trading desk.",
    "tours.passenger_info_title": "Passengers",
    "tours.passenger_info_subtitle": "Full name and document for each traveler — used for reservation and farm check-in.",
    "tours.passenger_n": "Passenger {n}",
    "tours.field_full_name": "Full name",
    "tours.field_doc_number": "Document number",
    "tours.field_doc_country": "Issuing country (passport only)",
    "tours.doc_passport": "Passport",
    "tours.doc_cpf": "CPF (BR)",
    "tours.doc_rg": "RG (BR)",
    "tours.doc_other": "Other",
    "tours.single_supplement_label": "Single-traveler supplement · +50%",
    "tours.single_supplement_note": "Solo bookings carry a 50% surcharge on top of the per-person rate, in line with corporate-travel single-supplement practice.",
    "tours.subtotal": "Base rate · 1 pax",
    "tours.supplement_line": "Single supplement (+50%)",
    "tours.error_passenger_info": "Please provide name and document for every passenger.",
    "tours.cta": "Explore Routes",
    "tours.duration": "Duration",
    "tours.from_price": "From",
    "tours.per_person": "/ person",
    "tours.region": "Region",
    "tours.farms": "Farms",
    "tours.farms_count": "farms",
    "tours.highlights": "Highlights",
    "tours.includes": "Included",
    "tours.gallery": "Gallery",
    "tours.request_title": "Request this tour",
    "tours.duration_days": "Tour duration",
    "tours.days": "days",
    "tours.airport": "Origin airport",
    "tours.airport_help": "We will pick you up at your chosen airport (round-trip).",
    "tours.passengers": "Passengers",
    "tours.start_date": "Preferred start date",
    "tours.notes": "Notes",
    "tours.notes_placeholder": "Dietary restrictions, specific interests, alternative dates...",
    "tours.estimate": "Investment estimate",
    "tours.price_per_pax": "Per person",
    "tours.total_price": "Estimated total",
    "tours.submit": "Request Tour",
    "tours.success": "Request submitted! We'll contact you soon.",
    "tours.login_required": "Sign in to request this tour",
    "tours.includes_title": "Everything included in the tour",
    "tours.see_route": "View Route",
    "tours.best_season": "Best season",
    "tours.farms_visited": "Farms visited",
    "tours.altitude": "Altitude",
    "tours.specialty": "Specialty",
    "tours.airports_supported": "Supported airports",
    "tours.summary": "Summary",

    "common.bags": "bags",
    "common.region": "Region",
    "common.process": "Process",
    "common.search": "Search lots, farms, regions...",
    "common.all": "All",
    "common.cancel": "Cancel",
    "common.confirm": "Confirm",
    "common.save": "Save",
    "common.loading": "Loading...",
    "common.send": "Send",
    "common.edit": "Edit",
    "common.delete": "Delete",
    "common.create": "Create",
    "common.actions": "Actions",
    "common.status": "Status",
    "common.date": "Date",
    "common.optional": "optional",
    "common.back": "Back",
    "common.demo_creds": "Demo credentials",

    "hero.tagline": "KAFFA EXCHANGE · COMMODITY TRADING",
    "hero.title": "The global coffee market, digitized.",
    "hero.subtitle": "B2B trading and export platform connecting producing cooperatives with international buyers.",
    "hero.cta_explore": "Explore Lots",
    "hero.cta_register": "Register Company",
    "hero.stat_bags": "Bags/month",
    "hero.stat_coops": "Cooperatives",
    "hero.stat_countries": "Countries",
    "hero.live_market": "Live Market",

    "ticker.label": "GLOBAL MARKET",

    "pillar.verify.title": "Full Verification",
    "pillar.verify.desc": "Every buyer goes through manual backoffice approval.",
    "pillar.export.title": "Global Export",
    "pillar.export.desc": "FOB Santos ready. Integrated international logistics.",
    "pillar.pricing.title": "Dynamic Pricing",
    "pillar.pricing.desc": "Engine recomputes prices via global indicators in real-time.",
    "pillar.trace.title": "Traceability",
    "pillar.trace.desc": "From producer to cup: farm, altitude, process, SCA.",

    "lots.public_title": "Available Lots",
    "lots.public_subtitle": "Public catalog — prices and full details unlocked after account approval.",
    "lots.active": "active lots",
    "lots.locked": "Sign in to see prices and full details",
    "lots.available": "Available",
    "lots.price_label": "Bag 60kg",
    "lots.empty": "No lots match the current filters.",
    "lots.filter_type": "Types",
    "lots.filter_process": "Processes",
    "lots.filter_region": "Regions",

    "auth.login_title": "Sign in to Kaffa Exchange",
    "auth.register_title": "Create Business Account",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.razao_social": "Legal Name",
    "auth.cnpj": "CNPJ / Tax ID",
    "auth.address": "Full Address",
    "auth.phone": "Phone",
    "auth.country": "Country",
    "auth.commercial": "Commercial Contact",
    "auth.submit_login": "Sign in",
    "auth.submit_register": "Request Access",
    "auth.no_account": "Don't have an account yet?",
    "auth.has_account": "Already have an account?",
    "auth.request_signup": "Request access",
    "auth.signin": "Sign in",

    "login.tagline": "Trading Desk · Kaffa Exchange",
    "login.banner_title": "Restricted access — approved operators only.",
    "login.banner_subtitle": "Cooperatives, buyers and administrators enter the marketplace from here.",
    "login.signin_label": "Sign In",

    "register.tagline": "Onboarding · B2B",
    "register.intro": "Registration is intended for importing companies and commercial operators. After submission, our team validates the data before releasing full market access.",
    "register.verification": "Compliance verification",
    "register.verification_desc": "Corporate KYC in up to 48h. Once approved, you see prices, SCA scores, certifications and can submit proposals.",
    "register.success": "Registration submitted for review",
    "register.placeholder_razao": "Müller Global Coffee Imports GmbH",
    "register.placeholder_cnpj": "00.000.000/0001-00",
    "register.placeholder_country": "Brazil / Germany / USA...",
    "register.placeholder_address": "Street, number, district, city, ZIP, country",
    "register.placeholder_phone": "+55 11 99999-0000",
    "register.placeholder_contact": "Contact full name",
    "register.placeholder_email": "contact@company.com",
    "register.placeholder_password": "Minimum 6 characters",
    "register.submitting": "Sending...",

    "pending.tagline": "Status · Under review",
    "pending.message": "Your registration has been received and is under review by the Kaffa team. You will be notified by email once approved.",
    "pending.submitted_data": "Submitted data",
    "pending.step1": "Registration received",
    "pending.step2": "Under backoffice review (up to 48h)",
    "pending.step3": "Approval and access release",
    "pending.view_market": "View Marketplace",

    "alerts.label": "Alerts",
    "alerts.new": "new",
    "alerts.mark_read": "Mark read",
    "alerts.empty": "No alerts at the moment.",

    "footer.subtitle": "B2B coffee trading & export platform. Connecting producing cooperatives with international buyers with traceability and technology.",
    "footer.platform": "Platform",
    "footer.contact": "Contact",

    "lot.tab_details": "Details",
    "lot.tab_certs": "Certifications",
    "lot.tab_docs": "Documents",
    "lot.tab_history": "Price history",
    "lot.origin": "Origin",
    "lot.cooperative": "Cooperative",
    "lot.notes": "Sensory notes",
    "lot.altitude": "Altitude",
    "lot.sieve": "Screen",
    "lot.crop": "Crop",
    "lot.humidity": "Humidity",
    "lot.blend": "Blend",
    "lot.fob": "FOB",
    "lot.demo_interest": "Express Interest",
    "lot.demo_interest_short": "Interest",
    "lot.propose": "Make Proposal",
    "lot.propose_short": "Proposal",
    "lot.propose_title": "Send proposal",
    "lot.interest_title": "Express interest",
    "lot.bags_qty": "Quantity (bags)",
    "lot.price_label": "Price/bag",
    "lot.message_label": "Message",
    "lot.message_placeholder": "Delivery terms, dates, notes...",
    "lot.send_proposal": "Send proposal",
    "lot.send_interest": "Send interest",
    "lot.not_found": "Lot not found",
    "lot.no_certs": "No certifications registered.",
    "lot.no_docs": "No documents attached.",
    "lot.no_history": "No price history recorded. Enable auto-pricing to track automatic changes.",
    "lot.proposal_sent": "Proposal sent to cooperative",
    "lot.interest_sent": "Interest registered",
    "lot.auto_priced": "AUTO-PRICED · Margin",
    "lot.total_volume": "Total volume",
    "lot.available_qty": "Available",
    "lot.bag_price": "Bag 60kg",

    "buyer.desk": "Buyer Desk",
    "buyer.title": "Buyer Dashboard",
    "buyer.subtitle": "Full marketplace, your proposals and interests.",
    "buyer.tab_market": "Market",
    "buyer.tab_proposals": "My Proposals",
    "buyer.tab_interests": "Interests",
    "buyer.col_lot": "Lot",
    "buyer.col_proposed_price": "Proposed Price",
    "buyer.col_bags": "Bags",
    "buyer.col_counter": "Counter-offer",
    "buyer.no_proposals": "No proposals sent.",
    "buyer.no_interests": "No interests registered.",

    "coop.desk": "Cooperative Desk",
    "coop.title": "Lot Management",
    "coop.new_lot": "New Lot",
    "coop.kpi_active": "Active lots",
    "coop.kpi_bags": "Total bags",
    "coop.kpi_pending_props": "Pending proposals",
    "coop.kpi_interests": "Interests",
    "coop.tab_lots": "Lots",
    "coop.tab_proposals": "Proposals",
    "coop.tab_interests": "Interests",
    "coop.col_lot": "Lot",
    "coop.col_type": "Type",
    "coop.col_bags": "Bags",
    "coop.col_price": "Price",
    "coop.col_auto": "Auto",
    "coop.col_buyer": "Buyer",
    "coop.no_proposals": "No proposals received.",
    "coop.no_interests": "No interests.",
    "coop.accept": "Accept",
    "coop.reject": "Reject",
    "coop.delete_confirm": "Delete this lot?",
    "coop.lot_removed": "Lot deleted",
    "coop.lot_updated": "Status updated",
    "coop.price_recalc": "Price recomputed",
    "coop.lot_published": "Lot published",
    "coop.lot_edited": "Lot updated",
    "coop.response_sent": "Response sent",
    "coop.edit_lot": "Edit Lot",
    "coop.create_lot": "New Lot",
    "coop.update": "Update",
    "coop.publish": "Publish lot",
    "coop.field_name": "Lot name",
    "coop.field_quality": "Quality",
    "coop.field_currency": "Currency",
    "coop.field_sca": "SCA Score",
    "coop.field_farm": "Farm",
    "coop.field_city": "City",
    "coop.field_state": "State",
    "coop.field_port": "FOB Port",
    "coop.field_images": "Image URL (comma separated)",
    "coop.field_certs": "Certifications (comma separated)",
    "coop.field_notes": "Notes",
    "coop.auto_title": "Automatic Price Updates",
    "coop.auto_desc": "The engine recomputes the price using global indicators (NY Futures, USD/BRL, FOB, demand).",
    "coop.margin": "Own margin (%)",

    "admin.desk": "Backoffice · Admin Control Room",
    "admin.title": "Admin Dashboard",
    "admin.kpi_active_lots": "Active lots",
    "admin.kpi_bags": "Market bags",
    "admin.kpi_buyers": "Active buyers",
    "admin.kpi_pending": "Pending",
    "admin.kpi_coops": "Cooperatives",
    "admin.kpi_props": "Proposals",
    "admin.chart_region": "Volume by region (bags)",
    "admin.chart_types": "Coffee type mix",
    "admin.tab_approvals": "Approvals",
    "admin.tab_users": "Users",
    "admin.tab_coops": "Cooperatives",
    "admin.tab_lots": "Lots",
    "admin.tab_proposals": "Negotiations",
    "admin.tab_indicators": "Indicators",
    "admin.col_company": "Company",
    "admin.col_name": "Name",
    "admin.col_role": "Role",
    "admin.no_pending": "No pending approvals.",
    "admin.approve": "Approve",
    "admin.reject": "Reject",
    "admin.user_approved": "Buyer approved",
    "admin.user_rejected": "Buyer rejected",
    "admin.coop_created": "Cooperative created",
    "admin.coop_user_created": "Cooperative user created",
    "admin.indicator_updated": "Indicator updated",
    "admin.new_coop": "New Cooperative",
    "admin.new_coop_user": "New Cooperative User",
    "admin.coop_descr_label": "Description",
    "admin.indicators_help": "Indicators feed the auto-pricing engine. Edit values to simulate market scenarios.",
    "admin.select_coop": "Select...",

    "status.pending": "Pending",
    "status.approved": "Approved",
    "status.rejected": "Rejected",
    "status.accepted": "Accepted",
    "status.counter": "Counter-offer",
    "status.closed": "Closed",
    "status.new": "New",
    "status.contacted": "Contacted",
    "status.published": "Published",
    "status.paused": "Paused",
    "status.draft": "Draft",
    "status.sold": "Sold",
    "status.expired": "Expired",
    "status.active": "Active",

    "login.welcome": "Welcome",

    "data.coffee.arabica": "Arabica",
    "data.coffee.conilon": "Conilon",
    "data.coffee.robusta": "Robusta",
    "data.coffee.especial": "Specialty",
    "data.coffee.microlote": "Microlot",
    "data.coffee.gourmet": "Gourmet",
    "data.process.natural": "Natural",
    "data.process.washed": "Washed",
    "data.process.honey": "Honey",
    "data.process.pulped_natural": "Pulped Natural",
    "data.process.anaerobic": "Anaerobic",
    "data.process.fermentado": "Fermented",
    "data.quality.commercial": "Commercial",
    "data.quality.premium": "Premium",
    "data.quality.specialty": "Specialty",
    "data.quality.microlot": "Microlot",
    "data.region.sul_de_minas": "South of Minas",
    "data.region.cerrado_mineiro": "Cerrado Mineiro",
    "data.region.alta_mogiana": "Alta Mogiana",
    "data.region.chapada_diamantina": "Chapada Diamantina",
    "data.region.espirito_santo": "Espírito Santo",

    "hero.live_arabica": "Arabica",
    "hero.live_ny_futures": "NY Futures",
    "home.experiences_label": "KAFFA EXPERIENCES · ORIGIN TOURS",
    "home.airport_pickup": "Airport pickup",
    "home.translator": "Translator (PT/EN/ES)",
    "home.sca_cupping": "SCA cupping",

    "team.leadership": "KAFFA · LEADERSHIP",
    "team.photo_soon": "Photo · soon",

    "tours.not_found": "Tour not found",
    "tours.contact_disclaimer": "Kaffa Exchange will contact you to confirm availability, dates and final adjustments.",
    "tours.pax_short": "pax",

    "admin.live_label": "LIVE · Alpha Vantage",
    "admin.refresh_indicators": "Refresh indicators",
    "admin.refresh_done": "Indicators updated",
    "admin.refresh_partial": "Partial update — some indicators may still be using previous values",
    "admin.refresh_failed": "Failed to refresh indicators",

    "coop.toast.lot_updated": "Lot updated",
    "coop.toast.lot_published": "Lot published",
    "coop.toast.lot_removed": "Lot removed",
    "coop.toast.status_updated": "Status updated",
    "coop.toast.price_recalc": "Price recomputed",
    "coop.toast.response_sent": "Response sent",
    "coop.confirm_delete": "Delete this lot?",
    "coop.no_proposals_received": "No proposals received.",
    "coop.accept_btn": "Accept",
    "coop.reject_btn": "Reject",

    "lot.interest_default_msg": "Please send samples and a complete tech sheet.",
    "sample.request_btn": "Request sample",
    "sample.dialog_title": "Request a physical sample",
    "sample.dialog_subtitle": "Receive samples of this lot at your address for sensory evaluation.",
    "sample.shipping_title": "Shipping address",
    "sample.use_profile_address": "Use my registered address",
    "sample.use_new_address": "Use a different address",
    "sample.field_recipient": "Recipient",
    "sample.field_address": "Street address",
    "sample.field_address_placeholder": "Street, number, suite",
    "sample.field_city": "City",
    "sample.field_state": "State / Province",
    "sample.field_country": "Country",
    "sample.field_postal": "Postal code / ZIP",
    "sample.field_phone": "Contact phone",
    "sample.field_notes": "Notes for the cooperative",
    "sample.field_notes_placeholder": "e.g. priority, desired tech sheet, deadline...",
    "sample.send_btn": "Send request",
    "sample.error_bags": "Please enter the number of bags.",
    "sample.error_address": "Fill in address, city and country.",
    "sample.success_toast": "Sample request sent",
    "sample.success_description": "The cooperative will be alerted and start preparation. You can track the shipment here.",
    "samples.col_lot": "Lot",
    "samples.col_buyer": "Buyer",
    "samples.col_bags": "Bags",
    "samples.col_shipping": "Shipping",
    "samples.col_tracking": "Tracking",
    "samples.col_status": "Status",
    "samples.col_date": "Date",
    "samples.address_profile": "Registered address",
    "samples.tracking_pending": "Pending",
    "samples.status_new": "New",
    "samples.status_preparing": "Preparing",
    "samples.status_shipped": "Shipped",
    "samples.status_delivered": "Delivered",
    "samples.status_unavailable": "Unavailable",
    "samples.manage_btn": "Manage",
    "samples.manage_title": "Manage sample",
    "samples.manage_subtitle": "Update status, tracking number and carrier.",
    "samples.field_status": "Status",
    "samples.field_tracking_number": "Tracking number",
    "samples.field_tracking_carrier": "Carrier",
    "samples.field_tracking_url": "Tracking URL",
    "samples.field_internal_notes": "Internal notes",
    "samples.save_btn": "Save",
    "samples.toast_updated": "Sample updated",
    "samples.no_samples": "No samples registered.",
    "buyer.tab_samples": "Samples",
    "buyer.no_samples": "No samples requested yet.",
    "coop.tab_samples": "Samples",
    "coop.no_samples": "No sample requests.",
    "admin.tab_samples": "Samples",
    "admin.no_samples": "No sample requests registered.",
    "lot.bags_unit": "kg total",

    "footer.version": "v1.0 · B2B Coffee Trading",
    "footer.location": "São Paulo · Brazil",
    "footer.copyright": "© 2026 KAFFA EXCHANGE",

    "indicator.arabica_ny": "Arabica NY",
    "indicator.conilon_es": "Conilon ES",
    "indicator.usd_brl": "USD / BRL",
    "indicator.usd_eur": "USD / EUR",
    "indicator.fob_santos": "FOB Santos",
    "indicator.export_br": "Brazil Exports",
    "indicator.infl_br": "Brazil Inflation",
    "indicator.demand_global": "Global Demand",
    "settings.theme": "Theme",

    "pwa.tagline": "KAFFA · APP",
    "pwa.install_title": "Install the Kaffa app",
    "pwa.install_subtitle": "Quick access to lots, prices and farm visits from your home screen.",
    "pwa.install_cta": "Install",
    "pwa.dismiss": "Not now",

    "admin.tab_visits": "Visits",
    "status.archived": "Archived",
    "status.confirmed": "Confirmed",
    "status.cancelled": "Cancelled",
    "status.completed": "Completed",
    "status.preparing": "Preparing",
    "status.shipped": "Shipped",
    "status.delivered": "Delivered",
    "status.unavailable": "Unavailable",

    "admin_tours.subtab_packages": "Packages",
    "admin_tours.subtab_requests": "Requests",
    "admin_tours.packages_help": "Create and manage the farm-visit packages shown publicly at /tours.",
    "admin_tours.requests_help": "Requests received via /tours. Confirm, cancel or mark as completed.",
    "admin_tours.new_btn": "New package",
    "admin_tours.empty": "No packages yet.",
    "admin_tours.req_empty": "No requests yet.",
    "admin_tours.col_name": "Name",
    "admin_tours.col_base_price": "Base price",
    "admin_tours.col_status": "Status",
    "admin_tours.farms_count": "farms",
    "admin_tours.publish": "Publish",
    "admin_tours.draft": "Draft",
    "admin_tours.dialog_new": "New visit package",
    "admin_tours.dialog_edit": "Edit package",
    "admin_tours.form_required": "Please fill name, region and summary (PT).",
    "admin_tours.field_name": "Name",
    "admin_tours.field_country": "Country",
    "admin_tours.field_hero_image": "Hero image (URL)",
    "admin_tours.field_gallery": "Gallery (URLs)",
    "admin_tours.field_summary": "Summary",
    "admin_tours.field_highlights": "Highlights",
    "admin_tours.field_farms": "Farms",
    "admin_tours.field_includes": "What's included",
    "admin_tours.field_airports": "Supported airports",
    "admin_tours.field_seasons": "Best seasons",
    "admin_tours.field_durations": "Durations (days)",
    "admin_tours.hint_one_per_line": "One item per line.",
    "admin_tours.hint_farms": "One per line: Name | City | Altitude | Specialty",
    "admin_tours.hint_durations": "Comma-separated list (e.g., 7, 10, 15).",
    "admin_tours.status_draft": "Draft",
    "admin_tours.status_published": "Published",
    "admin_tours.status_archived": "Archived",
    "admin_tours.toast_created": "Package created",
    "admin_tours.toast_updated": "Package updated",
    "admin_tours.toast_status": "Status updated",
    "admin_tours.toast_removed": "Package removed",
    "admin_tours.req_toast_updated": "Request updated",
    "admin_tours.confirm_delete": "Delete this package?",
    "admin_tours.save_btn": "Save",
    "admin_tours.create_btn": "Create",
    "admin_tours.req_buyer": "Buyer",
    "admin_tours.req_tour": "Package",
    "admin_tours.req_total": "Total",
    "admin_tours.req_when": "When",
    "admin_tours.req_pending": "Pending",
    "admin_tours.req_confirmed": "Confirmed",
    "admin_tours.req_cancelled": "Cancelled",
    "admin_tours.req_completed": "Completed",
    "admin_tours.confirm": "Confirm",
    "admin_tours.cancel": "Cancel",
    "admin_tours.complete": "Complete",

    "admin_tours.col_days": "Days",
    "admin_tours.col_seats": "Seats",
    "admin_tours.section_image": "Hero image",
    "admin_tours.section_basic": "Basic info",
    "admin_tours.section_pricing": "Price & availability",
    "admin_tours.section_content": "Content",
    "admin_tours.section_extras": "Extras",
    "admin_tours.hero_replace_help": "Upload a replacement image (JPG / PNG / WebP).",
    "admin_tours.replace_image": "Replace image",
    "admin_tours.remove_image": "Remove",
    "admin_tours.image_uploading": "Uploading…",
    "admin_tours.image_upload_cta": "Upload image",
    "admin_tours.image_hint": "JPG / PNG / WebP · up to {mb} MB",
    "admin_tours.field_duration_days": "Duration (days)",
    "admin_tours.duration_hint": "Fixed number of days per package (e.g., 7, 10, 15).",
    "admin_tours.field_price_per_person": "Price per person (USD)",
    "admin_tours.price_hint": "Fixed price per package. No proportional scaling.",
    "admin_tours.field_dates_seats": "Departure dates & seats",
    "admin_tours.pick_dates": "Pick dates",
    "admin_tours.dates_empty": "No dates selected yet. Click \"Pick dates\" to choose.",
    "admin_tours.seats_label": "Seats",
    "admin_tours.field_description": "Detailed description",
    "admin_tours.description_hint": "Supports multi-paragraph rich description.",
    "admin_tours.summary_hint": "Short summary shown in listings and search results.",
    "admin_tours.err_not_image": "The selected file is not an image.",
    "admin_tours.err_image_too_big": "Image too large. Max {mb} MB.",
    "admin_tours.err_image_read": "Could not read the image.",
    "tours.choose_date": "Choose your departure",
    "tours.seats_left": "seats left",
    "tours.pick_date_first": "Pick a date first.",
    "tours.not_enough_seats": "Not enough seats on that date.",
    "tours.about_label": "About this route",
  },

  "es": {
    "checkout.unavailable_banner": "PAGOS TEMPORALMENTE NO DISPONIBLES",
    "checkout.unavailable_label": "Estamos casi listos:",
    "checkout.unavailable_help": "El procesamiento de tarjetas se habilitará en breve. Mientras tanto, contacta a nuestro equipo en trade@kaffaexchange.com para concluir tu reserva.",
    "checkout.error_payment_unavailable": "Los pagos no están disponibles. Te contactaremos pronto.",
    "checkout.errors.card_declined": "Tarjeta rechazada. Intenta con otra.",
    "checkout.errors.card_invalid": "Número de tarjeta inválido.",
    "checkout.errors.card_invalid_exp": "Vencimiento inválido (usa MM/AA).",
    "checkout.errors.card_invalid_cvv": "CVV inválido.",
    "checkout.errors.card_expired": "Tarjeta vencida.",
    "checkout.errors.date_unavailable": "Fecha ya no disponible.",
    "checkout.errors.no_seats": "Plazas insuficientes en esa fecha.",
    "tours.pay_and_book": "Pagar y reservar",
    "checkout.title": "Finalizar reserva",
    "checkout.subtitle": "Pago seguro. Tu reserva se confirma al instante.",
    "checkout.demo_mode_banner": "MODO DEMO · NO SE REALIZA NINGÚN COBRO REAL",
    "checkout.summary_label": "Resumen del pedido",
    "checkout.row_tour": "Ruta",
    "checkout.row_date": "Fecha",
    "checkout.row_passengers": "Pasajeros",
    "checkout.row_duration": "Duración",
    "checkout.row_per_person": "Por persona",
    "checkout.row_airport": "Aeropuerto",
    "checkout.total": "Total",
    "checkout.security_note": "Los datos del tarjeta no se almacenan en texto plano. Solo guardamos marca y últimos 4 dígitos.",
    "checkout.card_label": "Datos de la tarjeta",
    "checkout.card_number": "Número de tarjeta",
    "checkout.card_name": "Nombre en la tarjeta",
    "checkout.card_name_placeholder": "COMO EN LA TARJETA",
    "checkout.card_exp": "Vencimiento",
    "checkout.pay_button": "Pagar",
    "checkout.processing": "Procesando pago…",
    "checkout.success_toast": "Pago aprobado",
    "checkout.error_invalid_card": "Verifica los datos de la tarjeta.",
    "checkout.test_cards_label": "Tarjetas de prueba:",
    "checkout.test_success": "aprobación simulada",
    "checkout.test_declined": "rechazo simulado",
    "receipt.title": "Comprobante de pago",
    "receipt.paid_stamp": "PAGADO",
    "receipt.tour": "Ruta",
    "receipt.date": "Fecha",
    "receipt.passengers": "Pasajeros",
    "receipt.airport": "Aeropuerto",
    "receipt.card": "Tarjeta",
    "receipt.paid_at": "Pagado el",
    "receipt.total_paid": "Total pagado",
    "receipt.email_sent": "Comprobante enviado a {email}",
    "receipt.download_pdf": "Descargar PDF",
    "receipt.close": "Cerrar",
    "receipt.admin_will_contact": "Nuestro equipo te contactará en 24h para confirmar los próximos pasos.",
    "admin_tours.req_order": "Pedido",
    "admin_tours.req_payment": "Pago",
    "admin_tours.payment_paid": "Pagado",
    "admin_tours.payment_unpaid": "Sin pagar",
    "pending.label": "EN REVISIÓN",
    "pending.title": "Solicitud en revisión",
    "pending.subtitle": "Tu solicitud fue recibida y está siendo revisada por el equipo Kaffa Exchange. Recibirás un email cuando sea procesada.",
    "pending.rejected_label": "SOLICITUD RECHAZADA",
    "pending.rejected_title": "Tu solicitud fue rechazada",
    "pending.rejected_subtitle": "Tu registro no fue aprobado en esta revisión. Puedes contactar a nuestro equipo o enviar una nueva solicitud después de corregir los puntos mencionados.",
    "pending.rejection_reason_label": "Motivo del rechazo",
    "pending.contact_cta": "Contactar al equipo",
    "pending.email": "Email",
    "pending.company": "Empresa",
    "pending.country": "País",
    "pending.logout": "Cerrar sesión",
    "admin.subtab_pending": "Pendientes",
    "admin.subtab_rejected": "Rechazados",
    "admin.no_rejected": "Sin registros rechazados.",
    "admin.col_rejection_reason": "Motivo",
    "admin.col_rejected_at": "Rechazado el",
    "admin.restore": "Restaurar",
    "admin.user_restored": "Registro reabierto para revisión",
    "admin.reject_dialog_title": "Rechazar registro",
    "admin.reject_dialog_reason": "Motivo del rechazo",
    "admin.reject_dialog_placeholder": "Ej.: Documentación incompleta. Reenvía con Tax ID activo y comprobante de domicilio.",
    "admin.reject_dialog_help": "El comprador verá este motivo al intentar acceder.",
    "nav.home": "Inicio",
    "nav.marketplace": "Marketplace",
    "nav.tours": "Visitas a las Fincas",
    "nav.about": "Acerca de",
    "nav.login": "Iniciar sesión",
    "nav.register": "Registrarse",
    "nav.dashboard": "Panel",
    "nav.logout": "Cerrar sesión",

    "mission.tagline": "Nuestra Misión",
    "mission.title": "Democratizar el comercio del café devolviendo más dinero al productor.",
    "mission.subtitle": "Conectamos directamente cooperativas, productores y compradores globales — reduciendo intermediarios, aumentando trazabilidad y devolviendo valor justo a quien cultiva.",
    "mission.value1_title": "Justicia económica",
    "mission.value1_desc": "Comercio directo que devuelve mayor margen al productor y elimina intermediarios.",
    "mission.value2_title": "Trazabilidad total",
    "mission.value2_desc": "Cada lote tiene origen, proceso e historia documentados.",
    "mission.value3_title": "Tecnología al agro",
    "mission.value3_desc": "Motor de precios, indicadores globales y dashboards modernos.",
    "mission.value4_title": "Sostenibilidad",
    "mission.value4_desc": "Priorizamos cooperativas con certificaciones ambientales y sociales.",

    "team.tagline": "Detrás de la plataforma",
    "team.title": "El equipo de Kaffa Exchange",
    "team.subtitle": "Derecho, tecnología, estrategia y café. Cuatro líderes conectando la tradición centenaria del cultivo con la infraestructura digital del comercio global.",
    "team.member1_name": "Guilherme Barbosa",
    "team.member1_role": "CEO · Derecho del Agronegocio",
    "team.member1_bio": "Abogado por la Facultad de Derecho de USP (Largo São Francisco), especialista en Derecho del Agronegocio con seis años de actuación, además de Derecho Empresarial y Tributario. Más allá de la experiencia jurídica, tiene vínculo directo con la caficultura a través del negocio familiar — una finca de café en Poços de Caldas dirigida por su familia desde 1939.",
    "team.member2_name": "Alex Philippe",
    "team.member2_role": "COO · Operaciones y Estrategia",
    "team.member2_bio": "Fundador de Arcano Projetos de Tecnologia, startup que ha entregado proyectos de innovación para grandes corporaciones como BRF, CBA y ArcelorMittal, y de Rent a Squad — outsourcing tecnológico propietario de la metodología Torke®. Consejero, mentor y evaluador en programas como SEED MG, SEED MS, Capital Empreendedor y Vumbora Startups.",
    "team.member3_name": "Célio Sales",
    "team.member3_role": "CTO · Tecnología e Innovación",
    "team.member3_bio": "Consultor estratégico con paso por multinacionales reconocidas como Alcoa. Lidera la operación de Kaffa Exchange con foco en excelencia logística, procesos escalables y gobernanza corporativa.",
    "team.member4_name": "Valdeci Miguel",
    "team.member4_role": "CQO · Calidad y Café",
    "team.member4_bio": "Administrador de empresas con más de 30 años en el sector del café. Dominio en beneficio, exportación, control de calidad y gestión de clientes estratégicos — referente técnico del equipo.",

    "tours.public_title": "Visite el origen. Cierre contratos directo con el productor.",
    "tours.public_subtitle": "Visitas técnicas privadas a fincas premiadas, conducidas por Kaffa Exchange para compradores e importadores calificados. Cupping SCA, due diligence operativo, reuniones con productores y cierre de contratos en campo.",
    "tours.eyebrow": "Visitas técnicas · Programa B2B",
    "tours.benefit_cupping": "Mesa de cupping SCA con productores",
    "tours.benefit_producers": "Audiencia directa con los caficultores",
    "tours.benefit_diligence": "Due diligence operativo + sample lab",
    "tours.benefit_logistics": "Alojamiento, transfer y traductor incluidos",
    "tours.eligibility_note": "Programa exclusivo para compradores, importadores, head-buyers y empresas con volumen calificado. Cada itinerario es validado por nuestra mesa comercial.",
    "tours.passenger_info_title": "Pasajeros",
    "tours.passenger_info_subtitle": "Nombre completo y documento de cada pasajero — usado para reserva y check-in en las fincas.",
    "tours.passenger_n": "Pasajero {n}",
    "tours.field_full_name": "Nombre completo",
    "tours.field_doc_number": "Número de documento",
    "tours.field_doc_country": "País emisor (sólo pasaporte)",
    "tours.doc_passport": "Pasaporte",
    "tours.doc_cpf": "CPF (BR)",
    "tours.doc_rg": "RG (BR)",
    "tours.doc_other": "Otro",
    "tours.single_supplement_label": "Suplemento single · +50%",
    "tours.single_supplement_note": "Reservas individuales tienen un recargo del 50% sobre el precio/persona, conforme la práctica de paquetes corporativos.",
    "tours.subtotal": "Tarifa base · 1 pax",
    "tours.supplement_line": "Suplemento single (+50%)",
    "tours.error_passenger_info": "Complete nombre y documento de todos los pasajeros.",
    "tours.cta": "Explorar Rutas",
    "tours.duration": "Duración",
    "tours.from_price": "Desde",
    "tours.per_person": "/ persona",
    "tours.region": "Región",
    "tours.farms": "Fincas",
    "tours.farms_count": "fincas",
    "tours.highlights": "Destacados",
    "tours.includes": "Incluido",
    "tours.gallery": "Galería",
    "tours.request_title": "Solicitar este tour",
    "tours.duration_days": "Duración del tour",
    "tours.days": "días",
    "tours.airport": "Aeropuerto de origen",
    "tours.airport_help": "Lo recogeremos en el aeropuerto elegido (ida y vuelta).",
    "tours.passengers": "Pasajeros",
    "tours.start_date": "Fecha preferida",
    "tours.notes": "Observaciones",
    "tours.notes_placeholder": "Restricciones alimentarias, intereses específicos, fechas alternativas...",
    "tours.estimate": "Estimación de inversión",
    "tours.price_per_pax": "Por persona",
    "tours.total_price": "Total estimado",
    "tours.submit": "Solicitar Tour",
    "tours.success": "¡Solicitud enviada! Le contactaremos pronto.",
    "tours.login_required": "Inicie sesión para solicitar este tour",
    "tours.includes_title": "Todo incluido en el tour",
    "tours.see_route": "Ver Ruta",
    "tours.best_season": "Mejor temporada",
    "tours.farms_visited": "Fincas visitadas",
    "tours.altitude": "Altitud",
    "tours.specialty": "Especialidad",
    "tours.airports_supported": "Aeropuertos atendidos",
    "tours.summary": "Resumen",

    "common.bags": "sacos",
    "common.region": "Región",
    "common.process": "Proceso",
    "common.search": "Buscar lotes, fincas, regiones...",
    "common.all": "Todos",
    "common.cancel": "Cancelar",
    "common.confirm": "Confirmar",
    "common.save": "Guardar",
    "common.loading": "Cargando...",
    "common.send": "Enviar",
    "common.edit": "Editar",
    "common.delete": "Eliminar",
    "common.create": "Crear",
    "common.actions": "Acciones",
    "common.status": "Estado",
    "common.date": "Fecha",
    "common.optional": "opcional",
    "common.back": "Volver",
    "common.demo_creds": "Credenciales demo",

    "hero.tagline": "KAFFA EXCHANGE · COMMODITY TRADING",
    "hero.title": "El mercado global del café, digitalizado.",
    "hero.subtitle": "Plataforma B2B de negociación y exportación que conecta cooperativas productoras con compradores internacionales.",
    "hero.cta_explore": "Explorar Lotes",
    "hero.cta_register": "Registrar Empresa",
    "hero.stat_bags": "Sacos/mes",
    "hero.stat_coops": "Cooperativas",
    "hero.stat_countries": "Países",
    "hero.live_market": "Mercado en vivo",

    "ticker.label": "MERCADO GLOBAL",

    "pillar.verify.title": "Verificación Completa",
    "pillar.verify.desc": "Cada comprador pasa por aprobación manual del backoffice.",
    "pillar.export.title": "Exportación Global",
    "pillar.export.desc": "FOB Santos listo. Logística internacional integrada.",
    "pillar.pricing.title": "Precios Dinámicos",
    "pillar.pricing.desc": "El motor recalcula precios con indicadores globales en tiempo real.",
    "pillar.trace.title": "Trazabilidad",
    "pillar.trace.desc": "Del productor a la taza: finca, altitud, proceso, SCA.",

    "lots.public_title": "Lotes Disponibles",
    "lots.public_subtitle": "Catálogo público — precios y detalles tras aprobación de la cuenta.",
    "lots.active": "lotes activos",
    "lots.locked": "Inicie sesión para ver precios y detalles completos",
    "lots.available": "Disponible",
    "lots.price_label": "Saco 60kg",
    "lots.empty": "Ningún lote cumple los filtros.",
    "lots.filter_type": "Tipos",
    "lots.filter_process": "Procesos",
    "lots.filter_region": "Regiones",

    "auth.login_title": "Iniciar sesión en Kaffa Exchange",
    "auth.register_title": "Crear cuenta empresarial",
    "auth.email": "Correo electrónico",
    "auth.password": "Contraseña",
    "auth.razao_social": "Razón social",
    "auth.cnpj": "CNPJ / Tax ID",
    "auth.address": "Dirección completa",
    "auth.phone": "Teléfono",
    "auth.country": "País",
    "auth.commercial": "Responsable comercial",
    "auth.submit_login": "Iniciar sesión",
    "auth.submit_register": "Solicitar acceso",
    "auth.no_account": "¿Aún no tienes cuenta?",
    "auth.has_account": "¿Ya tienes cuenta?",
    "auth.request_signup": "Solicitar acceso",
    "auth.signin": "Iniciar sesión",

    "login.tagline": "Trading Desk · Kaffa Exchange",
    "login.banner_title": "Acceso restringido a operadores aprobados.",
    "login.banner_subtitle": "Cooperativas, compradores y administradores acceden al mercado desde aquí.",
    "login.signin_label": "Sign In",

    "register.tagline": "Onboarding · B2B",
    "register.intro": "El registro está destinado a empresas importadoras y operadores comerciales. Tras el envío, nuestro equipo valida los datos antes de liberar el acceso completo al mercado.",
    "register.verification": "Verificación de cumplimiento",
    "register.verification_desc": "KYC empresarial en hasta 48h. Una vez aprobado, verá precios, puntuaciones SCA, certificaciones y podrá enviar propuestas.",
    "register.success": "Registro enviado para revisión",
    "register.placeholder_razao": "Müller Global Coffee Imports GmbH",
    "register.placeholder_cnpj": "00.000.000/0001-00",
    "register.placeholder_country": "Brasil / Alemania / EE. UU...",
    "register.placeholder_address": "Calle, número, barrio, ciudad, CP, país",
    "register.placeholder_phone": "+55 11 99999-0000",
    "register.placeholder_contact": "Nombre del responsable",
    "register.placeholder_email": "contacto@empresa.com",
    "register.placeholder_password": "Mínimo 6 caracteres",
    "register.submitting": "Enviando...",

    "pending.tagline": "Estado · En revisión",
    "pending.message": "Su registro está siendo revisado por el equipo de Kaffa. Recibirá un correo cuando sea aprobado.",
    "pending.submitted_data": "Datos enviados",
    "pending.step1": "Registro recibido",
    "pending.step2": "En revisión por el backoffice (hasta 48h)",
    "pending.step3": "Aprobación y liberación de acceso",
    "pending.view_market": "Ver Marketplace",

    "alerts.label": "Alertas",
    "alerts.new": "nuevas",
    "alerts.mark_read": "Marcar leídas",
    "alerts.empty": "Sin alertas por el momento.",

    "footer.subtitle": "Plataforma B2B de comercialización y exportación de café. Conectando cooperativas productoras con compradores internacionales con trazabilidad y tecnología.",
    "footer.platform": "Plataforma",
    "footer.contact": "Contacto",

    "lot.tab_details": "Detalles",
    "lot.tab_certs": "Certificaciones",
    "lot.tab_docs": "Documentos",
    "lot.tab_history": "Historial de precio",
    "lot.origin": "Origen",
    "lot.cooperative": "Cooperativa",
    "lot.notes": "Notas sensoriales",
    "lot.altitude": "Altitud",
    "lot.sieve": "Tamiz",
    "lot.crop": "Cosecha",
    "lot.humidity": "Humedad",
    "lot.blend": "Blend",
    "lot.fob": "FOB",
    "lot.demo_interest": "Mostrar Interés",
    "lot.demo_interest_short": "Interés",
    "lot.propose": "Enviar Propuesta",
    "lot.propose_short": "Propuesta",
    "lot.propose_title": "Enviar propuesta",
    "lot.interest_title": "Mostrar interés",
    "lot.bags_qty": "Cantidad (sacos)",
    "lot.price_label": "Precio/saco",
    "lot.message_label": "Mensaje",
    "lot.message_placeholder": "Términos de entrega, fechas, observaciones...",
    "lot.send_proposal": "Enviar propuesta",
    "lot.send_interest": "Enviar interés",
    "lot.not_found": "Lote no encontrado",
    "lot.no_certs": "Sin certificaciones registradas.",
    "lot.no_docs": "Sin documentos adjuntos.",
    "lot.no_history": "Sin historial de variación registrado. Active auto-pricing para rastrear cambios automáticos.",
    "lot.proposal_sent": "Propuesta enviada a la cooperativa",
    "lot.interest_sent": "Interés registrado",
    "lot.auto_priced": "AUTO-PRICED · Margen",
    "lot.total_volume": "Volumen total",
    "lot.available_qty": "Disponible",
    "lot.bag_price": "Saco 60kg",

    "buyer.desk": "Buyer Desk",
    "buyer.title": "Panel del Comprador",
    "buyer.subtitle": "Marketplace completo, sus propuestas e intereses.",
    "buyer.tab_market": "Mercado",
    "buyer.tab_proposals": "Mis Propuestas",
    "buyer.tab_interests": "Intereses",
    "buyer.col_lot": "Lote",
    "buyer.col_proposed_price": "Precio Propuesto",
    "buyer.col_bags": "Sacos",
    "buyer.col_counter": "Contrapropuesta",
    "buyer.no_proposals": "Sin propuestas enviadas.",
    "buyer.no_interests": "Sin intereses registrados.",

    "coop.desk": "Cooperative Desk",
    "coop.title": "Gestión de Lotes",
    "coop.new_lot": "Nuevo Lote",
    "coop.kpi_active": "Lotes activos",
    "coop.kpi_bags": "Total sacos",
    "coop.kpi_pending_props": "Propuestas pendientes",
    "coop.kpi_interests": "Intereses",
    "coop.tab_lots": "Lotes",
    "coop.tab_proposals": "Propuestas",
    "coop.tab_interests": "Intereses",
    "coop.col_lot": "Lote",
    "coop.col_type": "Tipo",
    "coop.col_bags": "Sacos",
    "coop.col_price": "Precio",
    "coop.col_auto": "Auto",
    "coop.col_buyer": "Comprador",
    "coop.no_proposals": "Sin propuestas recibidas.",
    "coop.no_interests": "Sin intereses.",
    "coop.accept": "Aceptar",
    "coop.reject": "Rechazar",
    "coop.delete_confirm": "¿Eliminar este lote?",
    "coop.lot_removed": "Lote eliminado",
    "coop.lot_updated": "Estado actualizado",
    "coop.price_recalc": "Precio recalculado",
    "coop.lot_published": "Lote publicado",
    "coop.lot_edited": "Lote actualizado",
    "coop.response_sent": "Respuesta enviada",
    "coop.edit_lot": "Editar Lote",
    "coop.create_lot": "Nuevo Lote",
    "coop.update": "Actualizar",
    "coop.publish": "Publicar lote",
    "coop.field_name": "Nombre del lote",
    "coop.field_quality": "Calidad",
    "coop.field_currency": "Moneda",
    "coop.field_sca": "Puntuación SCA",
    "coop.field_farm": "Finca",
    "coop.field_city": "Ciudad",
    "coop.field_state": "Estado",
    "coop.field_port": "Puerto FOB",
    "coop.field_images": "URL Imagen (separadas por coma)",
    "coop.field_certs": "Certificaciones (separadas por coma)",
    "coop.field_notes": "Observaciones",
    "coop.auto_title": "Actualización Automática de Precio",
    "coop.auto_desc": "El motor recalcula el precio usando indicadores globales (NY Futures, USD/BRL, FOB, demanda).",
    "coop.margin": "Margen propio (%)",

    "admin.desk": "Backoffice · Admin Control Room",
    "admin.title": "Panel Administrativo",
    "admin.kpi_active_lots": "Lotes activos",
    "admin.kpi_bags": "Sacos/Mercado",
    "admin.kpi_buyers": "Compradores activos",
    "admin.kpi_pending": "Pendientes",
    "admin.kpi_coops": "Cooperativas",
    "admin.kpi_props": "Propuestas",
    "admin.chart_region": "Volumen por región (sacos)",
    "admin.chart_types": "Mix de tipos de café",
    "admin.tab_approvals": "Aprobaciones",
    "admin.tab_users": "Usuarios",
    "admin.tab_coops": "Cooperativas",
    "admin.tab_lots": "Lotes",
    "admin.tab_proposals": "Negociaciones",
    "admin.tab_indicators": "Indicadores",
    "admin.col_company": "Empresa",
    "admin.col_name": "Nombre",
    "admin.col_role": "Rol",
    "admin.no_pending": "Sin aprobaciones pendientes.",
    "admin.approve": "Aprobar",
    "admin.reject": "Rechazar",
    "admin.user_approved": "Comprador aprobado",
    "admin.user_rejected": "Comprador rechazado",
    "admin.coop_created": "Cooperativa creada",
    "admin.coop_user_created": "Usuario cooperativa creado",
    "admin.indicator_updated": "Indicador actualizado",
    "admin.new_coop": "Nueva Cooperativa",
    "admin.new_coop_user": "Nuevo Usuario Cooperativa",
    "admin.coop_descr_label": "Descripción",
    "admin.indicators_help": "Los indicadores alimentan el motor de auto-pricing. Edite los valores para simular escenarios de mercado.",
    "admin.select_coop": "Seleccione...",

    "status.pending": "Pendiente",
    "status.approved": "Aprobado",
    "status.rejected": "Rechazada",
    "status.accepted": "Aceptada",
    "status.counter": "Contrapropuesta",
    "status.closed": "Cerrada",
    "status.new": "Nuevo",
    "status.contacted": "Contactado",
    "status.published": "Publicado",
    "status.paused": "Pausado",
    "status.draft": "Borrador",
    "status.sold": "Vendido",
    "status.expired": "Expirado",
    "status.active": "Activo",

    "login.welcome": "Bienvenido",

    "data.coffee.arabica": "Arábica",
    "data.coffee.conilon": "Conilón",
    "data.coffee.robusta": "Robusta",
    "data.coffee.especial": "Especial",
    "data.coffee.microlote": "Microlote",
    "data.coffee.gourmet": "Gourmet",
    "data.process.natural": "Natural",
    "data.process.washed": "Lavado",
    "data.process.honey": "Honey",
    "data.process.pulped_natural": "Despulpado natural",
    "data.process.anaerobic": "Anaeróbico",
    "data.process.fermentado": "Fermentado",
    "data.quality.commercial": "Comercial",
    "data.quality.premium": "Premium",
    "data.quality.specialty": "Especial",
    "data.quality.microlot": "Microlote",
    "data.region.sul_de_minas": "Sur de Minas",
    "data.region.cerrado_mineiro": "Cerrado Mineiro",
    "data.region.alta_mogiana": "Alta Mogiana",
    "data.region.chapada_diamantina": "Chapada Diamantina",
    "data.region.espirito_santo": "Espírito Santo",

    "hero.live_arabica": "Arábica",
    "hero.live_ny_futures": "NY Futures",
    "home.experiences_label": "KAFFA EXPERIENCES · RUTAS DE ORIGEN",
    "home.airport_pickup": "Traslado al aeropuerto",
    "home.translator": "Traductor (PT/EN/ES)",
    "home.sca_cupping": "Cata SCA",

    "team.leadership": "KAFFA · LIDERAZGO",
    "team.photo_soon": "Foto · próximamente",

    "tours.not_found": "Tour no encontrado",
    "tours.contact_disclaimer": "Kaffa Exchange se pondrá en contacto para confirmar disponibilidad, fechas y ajustes finales.",
    "tours.pax_short": "pax",

    "admin.live_label": "EN VIVO · Alpha Vantage",
    "admin.refresh_indicators": "Actualizar indicadores",
    "admin.refresh_done": "Indicadores actualizados",
    "admin.refresh_partial": "Actualización parcial — algunos indicadores pueden seguir usando valores anteriores",
    "admin.refresh_failed": "Error al actualizar indicadores",

    "coop.toast.lot_updated": "Lote actualizado",
    "coop.toast.lot_published": "Lote publicado",
    "coop.toast.lot_removed": "Lote eliminado",
    "coop.toast.status_updated": "Estado actualizado",
    "coop.toast.price_recalc": "Precio recalculado",
    "coop.toast.response_sent": "Respuesta enviada",
    "coop.confirm_delete": "¿Eliminar este lote?",
    "coop.no_proposals_received": "Sin propuestas recibidas.",
    "coop.accept_btn": "Aceptar",
    "coop.reject_btn": "Rechazar",

    "lot.interest_default_msg": "Solicito muestras y ficha técnica completa.",
    "lot.bags_unit": "kg total",

    "footer.version": "v1.0 · Plataforma B2B de Café",
    "footer.location": "São Paulo · Brasil",
    "footer.copyright": "© 2026 KAFFA EXCHANGE",

    "indicator.arabica_ny": "Arábica NY",
    "indicator.conilon_es": "Conilón ES",
    "indicator.usd_brl": "USD / BRL",
    "indicator.usd_eur": "USD / EUR",

    "admin_tours.col_days": "Días",
    "admin_tours.col_seats": "Plazas",
    "admin_tours.section_image": "Imagen de portada",
    "admin_tours.section_basic": "Información básica",
    "admin_tours.section_pricing": "Precio y disponibilidad",
    "admin_tours.section_content": "Contenido",
    "admin_tours.section_extras": "Extras",
    "admin_tours.hero_replace_help": "Puedes subir otra imagen (JPG / PNG / WebP).",
    "admin_tours.replace_image": "Reemplazar imagen",
    "admin_tours.remove_image": "Eliminar",
    "admin_tours.image_uploading": "Subiendo…",
    "admin_tours.image_upload_cta": "Subir imagen",
    "admin_tours.image_hint": "JPG / PNG / WebP · máx {mb} MB",
    "admin_tours.field_duration_days": "Duración (días)",
    "admin_tours.duration_hint": "Número de días fijo por paquete (ej.: 7, 10, 15).",
    "admin_tours.field_price_per_person": "Precio por persona (USD)",
    "admin_tours.price_hint": "Precio fijo por paquete. Sin cálculo proporcional.",
    "admin_tours.field_dates_seats": "Fechas de salida y plazas",
    "admin_tours.pick_dates": "Elegir fechas",
    "admin_tours.dates_empty": "Sin fechas elegidas. Pulsa \"Elegir fechas\".",
    "admin_tours.seats_label": "Plazas",
    "admin_tours.field_description": "Descripción detallada",
    "admin_tours.description_hint": "Admite descripción multi-párrafo.",
    "admin_tours.summary_hint": "Resumen corto que aparece en listas y resultados.",
    "admin_tours.err_not_image": "El archivo no es una imagen.",
    "admin_tours.err_image_too_big": "Imagen demasiado grande. Máx {mb} MB.",
    "admin_tours.err_image_read": "Falló la lectura de la imagen.",
    "tours.choose_date": "Elige la fecha de salida",
    "tours.seats_left": "plazas restantes",
    "tours.pick_date_first": "Elige una fecha primero.",
    "tours.not_enough_seats": "Plazas insuficientes en esta fecha.",
    "tours.about_label": "Sobre esta ruta",
    "indicator.fob_santos": "FOB Santos",
    "indicator.export_br": "Exportaciones Brasil",
    "indicator.infl_br": "Inflación Brasil",
    "indicator.demand_global": "Demanda Global",
    "settings.theme": "Tema",

    "pwa.tagline": "KAFFA · APP",
    "pwa.install_title": "Instala la app Kaffa",
    "pwa.install_subtitle": "Acceso rápido a lotes, precios y visitas desde la pantalla de inicio.",
    "pwa.install_cta": "Instalar",
    "pwa.dismiss": "Ahora no",

    "admin.tab_visits": "Visitas",
    "status.archived": "Archivado",
    "status.confirmed": "Confirmado",
    "status.cancelled": "Cancelado",
    "status.completed": "Completado",
    "status.preparing": "Preparando",
    "status.shipped": "Enviada",
    "status.delivered": "Entregada",
    "status.unavailable": "No disponible",

    "admin_tours.subtab_packages": "Paquetes",
    "admin_tours.subtab_requests": "Pedidos",
    "admin_tours.packages_help": "Crea y gestiona los paquetes de visita a fincas mostrados en /tours.",
    "admin_tours.requests_help": "Pedidos recibidos por /tours. Confirma, cancela o marca como completado.",
    "admin_tours.new_btn": "Nuevo paquete",
    "admin_tours.empty": "Sin paquetes.",
    "admin_tours.req_empty": "Sin pedidos.",
    "admin_tours.col_name": "Nombre",
    "admin_tours.col_base_price": "Precio base",
    "admin_tours.col_status": "Estado",
    "admin_tours.farms_count": "fincas",
    "admin_tours.publish": "Publicar",
    "admin_tours.draft": "Borrador",
    "admin_tours.dialog_new": "Nuevo paquete de visita",
    "admin_tours.dialog_edit": "Editar paquete",
    "admin_tours.form_required": "Completa nombre, región y resumen (PT).",
    "admin_tours.field_name": "Nombre",
    "admin_tours.field_country": "País",
    "admin_tours.field_hero_image": "Imagen de portada (URL)",
    "admin_tours.field_gallery": "Galería (URLs)",
    "admin_tours.field_summary": "Resumen",
    "admin_tours.field_highlights": "Destacados",
    "admin_tours.field_farms": "Fincas",
    "admin_tours.field_includes": "Lo incluido",
    "admin_tours.field_airports": "Aeropuertos compatibles",
    "admin_tours.field_seasons": "Mejores épocas",
    "admin_tours.field_durations": "Duraciones (días)",
    "admin_tours.hint_one_per_line": "Un ítem por línea.",
    "admin_tours.hint_farms": "Uno por línea: Nombre | Ciudad | Altitud | Especialidad",
    "admin_tours.hint_durations": "Lista separada por comas (ej.: 7, 10, 15).",
    "admin_tours.status_draft": "Borrador",
    "admin_tours.status_published": "Publicado",
    "admin_tours.status_archived": "Archivado",
    "admin_tours.toast_created": "Paquete creado",
    "admin_tours.toast_updated": "Paquete actualizado",
    "admin_tours.toast_status": "Estado actualizado",
    "admin_tours.toast_removed": "Paquete eliminado",
    "admin_tours.req_toast_updated": "Pedido actualizado",
    "admin_tours.confirm_delete": "¿Eliminar este paquete?",
    "admin_tours.save_btn": "Guardar",
    "admin_tours.create_btn": "Crear",
    "admin_tours.req_buyer": "Comprador",
    "admin_tours.req_tour": "Paquete",
    "admin_tours.req_total": "Total",
    "admin_tours.req_when": "Cuándo",
    "admin_tours.req_pending": "Pendientes",
    "admin_tours.req_confirmed": "Confirmados",
    "admin_tours.req_cancelled": "Cancelados",
    "admin_tours.req_completed": "Completados",
    "admin_tours.confirm": "Confirmar",
    "admin_tours.cancel": "Cancelar",
    "admin_tours.complete": "Completar",
  },

  "fr": {
    "checkout.unavailable_banner": "PAIEMENTS TEMPORAIREMENT INDISPONIBLES",
    "checkout.unavailable_label": "Presque prêts :",
    "checkout.unavailable_help": "Le traitement par carte sera bientôt activé. Pour finaliser votre réservation, contactez notre équipe à trade@kaffaexchange.com.",
    "checkout.error_payment_unavailable": "Paiements indisponibles pour le moment. Nous vous contacterons bientôt.",
    "checkout.errors.card_declined": "Carte refusée. Essayez une autre carte.",
    "checkout.errors.card_invalid": "Numéro de carte invalide.",
    "checkout.errors.card_invalid_exp": "Date d'expiration invalide (MM/AA).",
    "checkout.errors.card_invalid_cvv": "CVV invalide.",
    "checkout.errors.card_expired": "Carte expirée.",
    "checkout.errors.date_unavailable": "Date plus disponible.",
    "checkout.errors.no_seats": "Places insuffisantes à cette date.",
    "tours.pay_and_book": "Payer et réserver",
    "checkout.title": "Finaliser la réservation",
    "checkout.subtitle": "Paiement sécurisé. Votre réservation est confirmée immédiatement.",
    "checkout.demo_mode_banner": "MODE DÉMO · AUCUN PAIEMENT RÉEL NE SERA EFFECTUÉ",
    "checkout.summary_label": "Résumé de la commande",
    "checkout.row_tour": "Tour",
    "checkout.row_date": "Date",
    "checkout.row_passengers": "Passagers",
    "checkout.row_duration": "Durée",
    "checkout.row_per_person": "Par personne",
    "checkout.row_airport": "Aéroport",
    "checkout.total": "Total",
    "checkout.security_note": "Les données carte ne sont jamais stockées en clair. Seuls la marque et les 4 derniers chiffres sont conservés.",
    "checkout.card_label": "Détails de la carte",
    "checkout.card_number": "Numéro de carte",
    "checkout.card_name": "Nom sur la carte",
    "checkout.card_name_placeholder": "COMME SUR LA CARTE",
    "checkout.card_exp": "Expiration",
    "checkout.pay_button": "Payer",
    "checkout.processing": "Traitement du paiement…",
    "checkout.success_toast": "Paiement approuvé",
    "checkout.error_invalid_card": "Vérifiez les données de la carte.",
    "checkout.test_cards_label": "Cartes de test :",
    "checkout.test_success": "succès simulé",
    "checkout.test_declined": "refus simulé",
    "receipt.title": "Reçu de paiement",
    "receipt.paid_stamp": "PAYÉ",
    "receipt.tour": "Tour",
    "receipt.date": "Date",
    "receipt.passengers": "Passagers",
    "receipt.airport": "Aéroport",
    "receipt.card": "Carte",
    "receipt.paid_at": "Payé le",
    "receipt.total_paid": "Total payé",
    "receipt.email_sent": "Reçu envoyé à {email}",
    "receipt.download_pdf": "Télécharger le PDF",
    "receipt.close": "Fermer",
    "receipt.admin_will_contact": "Notre équipe vous contactera sous 24h pour confirmer les prochaines étapes.",
    "admin_tours.req_order": "Commande",
    "admin_tours.req_payment": "Paiement",
    "admin_tours.payment_paid": "Payé",
    "admin_tours.payment_unpaid": "Non payé",
    "pending.label": "EN COURS D'EXAMEN",
    "pending.title": "Demande en cours d'examen",
    "pending.subtitle": "Votre demande a été reçue et est en cours d'examen par l'équipe Kaffa Exchange. Vous recevrez un email dès qu'elle sera traitée.",
    "pending.rejected_label": "DEMANDE REFUSÉE",
    "pending.rejected_title": "Votre demande a été refusée",
    "pending.rejected_subtitle": "Votre inscription n'a pas été approuvée. Vous pouvez contacter notre équipe ou soumettre une nouvelle demande après avoir corrigé les points indiqués.",
    "pending.rejection_reason_label": "Motif du refus",
    "pending.contact_cta": "Contacter l'équipe",
    "pending.email": "E-mail",
    "pending.company": "Entreprise",
    "pending.country": "Pays",
    "pending.logout": "Se déconnecter",
    "admin.subtab_pending": "En attente",
    "admin.subtab_rejected": "Refusées",
    "admin.no_rejected": "Aucune inscription refusée.",
    "admin.col_rejection_reason": "Motif",
    "admin.col_rejected_at": "Refusée le",
    "admin.restore": "Rouvrir",
    "admin.user_restored": "Inscription rouverte pour examen",
    "admin.reject_dialog_title": "Refuser l'inscription",
    "admin.reject_dialog_reason": "Motif du refus",
    "admin.reject_dialog_placeholder": "Ex. : Documentation incomplète. Veuillez renvoyer avec Tax ID actif.",
    "admin.reject_dialog_help": "L'acheteur verra ce motif lors de la prochaine connexion.",
    "nav.home": "Accueil",
    "nav.marketplace": "Marketplace",
    "nav.tours": "Visites de Fermes",
    "nav.about": "À propos",
    "nav.login": "Se connecter",
    "nav.register": "S'inscrire",
    "nav.dashboard": "Tableau de bord",
    "nav.logout": "Déconnexion",

    "common.bags": "sacs",
    "common.region": "Région",
    "common.process": "Procédé",
    "common.search": "Rechercher lots, fermes, régions...",
    "common.all": "Tous",
    "common.cancel": "Annuler",
    "common.confirm": "Confirmer",
    "common.save": "Enregistrer",
    "common.loading": "Chargement...",
    "common.send": "Envoyer",
    "common.edit": "Modifier",
    "common.delete": "Supprimer",
    "common.create": "Créer",
    "common.actions": "Actions",
    "common.status": "Statut",
    "common.date": "Date",
    "common.optional": "facultatif",
    "common.back": "Retour",
    "common.demo_creds": "Identifiants démo",

    "hero.tagline": "KAFFA EXCHANGE · TRADING DE MATIÈRES PREMIÈRES",
    "hero.title": "Le marché mondial du café, numérisé.",
    "hero.subtitle": "Plateforme B2B de négociation et d'exportation reliant les coopératives productrices aux acheteurs internationaux.",
    "hero.cta_explore": "Explorer les lots",
    "hero.cta_register": "Inscrire mon entreprise",
    "hero.stat_bags": "Sacs/mois",
    "hero.stat_coops": "Coopératives",
    "hero.stat_countries": "Pays",
    "hero.live_market": "Marché en direct",

    "ticker.label": "MARCHÉ MONDIAL",

    "pillar.verify.title": "Vérification complète",
    "pillar.verify.desc": "Chaque acheteur est validé manuellement par le back-office.",
    "pillar.export.title": "Exportation mondiale",
    "pillar.export.desc": "FOB Santos prêt. Logistique internationale intégrée.",
    "pillar.pricing.title": "Tarification dynamique",
    "pillar.pricing.desc": "Le moteur recalcule les prix via les indicateurs mondiaux en temps réel.",
    "pillar.trace.title": "Traçabilité",
    "pillar.trace.desc": "Du producteur à la tasse : ferme, altitude, procédé, SCA.",

    "mission.tagline": "Notre mission",
    "mission.title": "Démocratiser le commerce du café en restituant plus de revenus au producteur.",
    "mission.subtitle": "Nous relions directement coopératives, producteurs et acheteurs mondiaux — en supprimant les intermédiaires, en accroissant la traçabilité et en restituant une juste valeur à celles et ceux qui cultivent.",
    "mission.value1_title": "Équité économique",
    "mission.value1_desc": "Commerce direct restituant une plus grande marge aux producteurs.",
    "mission.value2_title": "Traçabilité totale",
    "mission.value2_desc": "Chaque lot a une origine, un procédé et une histoire documentés.",
    "mission.value3_title": "Tech au service de l'agro",
    "mission.value3_desc": "Moteur de tarification, indicateurs mondiaux et tableaux de bord modernes.",
    "mission.value4_title": "Durabilité",
    "mission.value4_desc": "Nous privilégions les coopératives certifiées environnementalement et socialement.",

    "team.tagline": "Derrière la plateforme",
    "team.title": "L'équipe de Kaffa Exchange",
    "team.subtitle": "Droit, technologie, stratégie et café. Quatre leaders reliant la tradition centenaire de la caféiculture à l'infrastructure numérique du commerce mondial.",
    "team.member1_name": "Guilherme Barbosa",
    "team.member1_role": "CEO · Droit de l'agro-industrie",
    "team.member1_bio": "Avocat diplômé de la Faculté de Droit de l'USP (Largo São Francisco), spécialiste en Droit de l'agro-industrie avec six ans d'expérience dans le domaine, ainsi qu'en Droit des affaires et fiscal. Au-delà de l'expérience juridique, il s'implique directement dans la caféiculture via l'entreprise familiale — une ferme de café à Poços de Caldas dirigée par sa famille depuis 1939.",
    "team.member2_name": "Alex Philippe",
    "team.member2_role": "COO · Opérations & Stratégie",
    "team.member2_bio": "Fondateur d'Arcano Projetos de Tecnologia, une startup ayant livré des projets d'innovation pour de grands groupes comme BRF, CBA et ArcelorMittal, et de Rent a Squad — outsourcing technologique propriétaire de la méthodologie Torke®. Conseiller, mentor et évaluateur dans des programmes comme SEED MG, SEED MS, Capital Empreendedor et Vumbora Startups.",
    "team.member3_name": "Célio Sales",
    "team.member3_role": "CTO · Technologie & Innovation",
    "team.member3_bio": "Consultant stratégique avec un parcours dans des multinationales renommées comme Alcoa. Pilote les opérations de Kaffa Exchange avec un focus sur l'excellence logistique, les processus scalables et la gouvernance d'entreprise.",
    "team.member4_name": "Valdeci Miguel",
    "team.member4_role": "CQO · Qualité & Café",
    "team.member4_bio": "Administrateur d'entreprises avec plus de 30 ans dans le secteur du café. Expert en bénéficiage, exportation, contrôle qualité et gestion de clients stratégiques — la référence technique de l'équipe.",

    "lots.public_title": "Lots disponibles",
    "lots.public_subtitle": "Catalogue public — prix et détails complets accessibles après validation du compte.",
    "lots.active": "lots actifs",
    "lots.locked": "Connectez-vous pour voir les prix et les détails complets",
    "lots.available": "Disponible",
    "lots.price_label": "Sac 60kg",
    "lots.empty": "Aucun lot ne correspond aux filtres.",
    "lots.filter_type": "Types",
    "lots.filter_process": "Procédés",
    "lots.filter_region": "Régions",

    "auth.login_title": "Se connecter à Kaffa Exchange",
    "auth.register_title": "Créer un compte entreprise",
    "auth.email": "E-mail",
    "auth.password": "Mot de passe",
    "auth.razao_social": "Raison sociale",
    "auth.cnpj": "SIRET / Tax ID",
    "auth.address": "Adresse complète",
    "auth.phone": "Téléphone",
    "auth.country": "Pays",
    "auth.commercial": "Contact commercial",
    "auth.submit_login": "Se connecter",
    "auth.submit_register": "Demander un accès",
    "auth.no_account": "Pas encore de compte ?",
    "auth.has_account": "Déjà un compte ?",
    "auth.request_signup": "Demander un accès",
    "auth.signin": "Se connecter",

    "login.tagline": "Trading Desk · Kaffa Exchange",
    "login.banner_title": "Accès restreint aux opérateurs validés.",
    "login.banner_subtitle": "Les coopératives, acheteurs et administrateurs accèdent au marché depuis ici.",
    "login.signin_label": "Sign In",

    "register.tagline": "Onboarding · B2B",
    "register.intro": "L'inscription est destinée aux entreprises importatrices et aux opérateurs commerciaux. Après envoi, notre équipe valide les données avant d'ouvrir un accès complet au marché.",
    "register.verification": "Vérification de conformité",
    "register.verification_desc": "KYC entreprise sous 48h. Une fois validé, vous voyez les prix, les scores SCA, les certifications et pouvez envoyer des propositions.",
    "register.success": "Inscription envoyée pour examen",
    "register.placeholder_razao": "Müller Global Coffee Imports GmbH",
    "register.placeholder_cnpj": "00.000.000/0001-00",
    "register.placeholder_country": "France / Allemagne / USA...",
    "register.placeholder_address": "Rue, numéro, arrondissement, ville, CP, pays",
    "register.placeholder_phone": "+33 1 99 99 00 00",
    "register.placeholder_contact": "Nom du responsable",
    "register.placeholder_email": "contact@entreprise.com",
    "register.placeholder_password": "Minimum 6 caractères",
    "register.submitting": "Envoi en cours...",

    "pending.tagline": "Statut · En examen",
    "pending.message": "Votre inscription a été reçue et est en cours d'examen par l'équipe Kaffa. Vous recevrez un e-mail une fois validée.",
    "pending.submitted_data": "Données envoyées",
    "pending.step1": "Inscription reçue",
    "pending.step2": "En cours d'examen par le back-office (jusqu'à 48h)",
    "pending.step3": "Validation et ouverture de l'accès",
    "pending.view_market": "Voir la Marketplace",

    "alerts.label": "Alertes",
    "alerts.new": "nouvelles",
    "alerts.mark_read": "Tout marquer lu",
    "alerts.empty": "Aucune alerte pour le moment.",

    "footer.subtitle": "Plateforme B2B de négociation et d'exportation de café. Reliant coopératives productrices et acheteurs internationaux avec traçabilité et technologie.",
    "footer.platform": "Plateforme",
    "footer.contact": "Contact",

    "lot.tab_details": "Détails",
    "lot.tab_certs": "Certifications",
    "lot.tab_docs": "Documents",
    "lot.tab_history": "Historique des prix",
    "lot.origin": "Origine",
    "lot.cooperative": "Coopérative",
    "lot.notes": "Notes sensorielles",
    "lot.altitude": "Altitude",
    "lot.sieve": "Tamis",
    "lot.crop": "Récolte",
    "lot.humidity": "Humidité",
    "lot.blend": "Blend",
    "lot.fob": "FOB",
    "lot.demo_interest": "Manifester un intérêt",
    "lot.demo_interest_short": "Intérêt",
    "lot.propose": "Faire une proposition",
    "lot.propose_short": "Proposition",
    "lot.propose_title": "Envoyer une proposition",
    "lot.interest_title": "Manifester un intérêt",
    "lot.bags_qty": "Quantité (sacs)",
    "lot.price_label": "Prix/sac",
    "lot.message_label": "Message",
    "lot.message_placeholder": "Conditions de livraison, dates, observations...",
    "lot.send_proposal": "Envoyer la proposition",
    "lot.send_interest": "Envoyer l'intérêt",
    "lot.not_found": "Lot introuvable",
    "lot.no_certs": "Aucune certification enregistrée.",
    "lot.no_docs": "Aucun document joint.",
    "lot.no_history": "Aucun historique de prix. Activez la tarification automatique pour suivre les changements.",
    "lot.proposal_sent": "Proposition envoyée à la coopérative",
    "lot.interest_sent": "Intérêt enregistré",
    "lot.auto_priced": "AUTO-PRICED · Marge",
    "lot.total_volume": "Volume total",
    "lot.available_qty": "Disponible",
    "lot.bag_price": "Sac 60kg",

    "buyer.desk": "Bureau Acheteur",
    "buyer.title": "Tableau de l'Acheteur",
    "buyer.subtitle": "Marketplace complet, vos propositions et intérêts.",
    "buyer.tab_market": "Marché",
    "buyer.tab_proposals": "Mes propositions",
    "buyer.tab_interests": "Intérêts",
    "buyer.col_lot": "Lot",
    "buyer.col_proposed_price": "Prix proposé",
    "buyer.col_bags": "Sacs",
    "buyer.col_counter": "Contre-proposition",
    "buyer.no_proposals": "Aucune proposition envoyée.",
    "buyer.no_interests": "Aucun intérêt enregistré.",

    "coop.desk": "Bureau Coopérative",
    "coop.title": "Gestion des lots",
    "coop.new_lot": "Nouveau lot",
    "coop.kpi_active": "Lots actifs",
    "coop.kpi_bags": "Total sacs",
    "coop.kpi_pending_props": "Propositions en attente",
    "coop.kpi_interests": "Intérêts",
    "coop.tab_lots": "Lots",
    "coop.tab_proposals": "Propositions",
    "coop.tab_interests": "Intérêts",
    "coop.col_lot": "Lot",
    "coop.col_type": "Type",
    "coop.col_bags": "Sacs",
    "coop.col_price": "Prix",
    "coop.col_auto": "Auto",
    "coop.col_buyer": "Acheteur",
    "coop.no_proposals": "Aucune proposition reçue.",
    "coop.no_interests": "Aucun intérêt.",
    "coop.accept": "Accepter",
    "coop.reject": "Refuser",
    "coop.delete_confirm": "Supprimer ce lot ?",
    "coop.lot_removed": "Lot supprimé",
    "coop.lot_updated": "Statut mis à jour",
    "coop.price_recalc": "Prix recalculé",
    "coop.lot_published": "Lot publié",
    "coop.lot_edited": "Lot mis à jour",
    "coop.response_sent": "Réponse envoyée",
    "coop.edit_lot": "Modifier le lot",
    "coop.create_lot": "Nouveau lot",
    "coop.update": "Mettre à jour",
    "coop.publish": "Publier le lot",
    "coop.field_name": "Nom du lot",
    "coop.field_quality": "Qualité",
    "coop.field_currency": "Devise",
    "coop.field_sca": "Score SCA",
    "coop.field_farm": "Ferme",
    "coop.field_city": "Ville",
    "coop.field_state": "État/Région",
    "coop.field_port": "Port FOB",
    "coop.field_images": "URL Image (séparées par virgule)",
    "coop.field_certs": "Certifications (séparées par virgule)",
    "coop.field_notes": "Notes",
    "coop.auto_title": "Mise à jour automatique du prix",
    "coop.auto_desc": "Le moteur recalcule le prix via les indicateurs mondiaux (NY Futures, USD/BRL, FOB, demande).",
    "coop.margin": "Marge propre (%)",

    "admin.desk": "Backoffice · Centre de contrôle Admin",
    "admin.title": "Tableau de bord Admin",
    "admin.kpi_active_lots": "Lots actifs",
    "admin.kpi_bags": "Sacs/Marché",
    "admin.kpi_buyers": "Acheteurs actifs",
    "admin.kpi_pending": "En attente",
    "admin.kpi_coops": "Coopératives",
    "admin.kpi_props": "Propositions",
    "admin.chart_region": "Volume par région (sacs)",
    "admin.chart_types": "Mix des types de café",
    "admin.tab_approvals": "Validations",
    "admin.tab_users": "Utilisateurs",
    "admin.tab_coops": "Coopératives",
    "admin.tab_lots": "Lots",
    "admin.tab_proposals": "Négociations",
    "admin.tab_indicators": "Indicateurs",
    "admin.col_company": "Entreprise",
    "admin.col_name": "Nom",
    "admin.col_role": "Rôle",
    "admin.no_pending": "Aucune validation en attente.",
    "admin.approve": "Valider",
    "admin.reject": "Refuser",
    "admin.user_approved": "Acheteur validé",
    "admin.user_rejected": "Acheteur refusé",
    "admin.coop_created": "Coopérative créée",
    "admin.coop_user_created": "Utilisateur coopérative créé",
    "admin.indicator_updated": "Indicateur mis à jour",
    "admin.new_coop": "Nouvelle coopérative",
    "admin.new_coop_user": "Nouvel utilisateur coop",
    "admin.coop_descr_label": "Description",
    "admin.indicators_help": "Les indicateurs alimentent le moteur d'auto-pricing. Modifiez les valeurs pour simuler des scénarios.",
    "admin.select_coop": "Sélectionner...",

    "status.pending": "En attente",
    "status.approved": "Validé",
    "status.rejected": "Refusée",
    "status.accepted": "Acceptée",
    "status.counter": "Contre-proposition",
    "status.closed": "Clôturée",
    "status.new": "Nouveau",
    "status.contacted": "Contacté",
    "status.published": "Publié",
    "status.paused": "En pause",
    "status.draft": "Brouillon",
    "status.sold": "Vendu",
    "status.expired": "Expiré",
    "status.active": "Actif",

    "login.welcome": "Bienvenue",

    "tours.public_title": "Visitez l'origine. Concluez vos contrats directement avec le producteur.",
    "tours.public_subtitle": "Visites techniques privées de fermes primées, organisées par Kaffa Exchange pour les acheteurs et importateurs qualifiés. Cupping SCA, due diligence opérationnelle, rencontres avec les producteurs et signature de contrats sur place.",
    "tours.eyebrow": "Visites techniques · Programme B2B",
    "tours.benefit_cupping": "Table de cupping SCA avec les producteurs",
    "tours.benefit_producers": "Échanges directs avec les caféiculteurs",
    "tours.benefit_diligence": "Due diligence opérationnelle + sample lab",
    "tours.benefit_logistics": "Hébergement, transfert et traducteur inclus",
    "tours.eligibility_note": "Programme exclusif réservé aux acheteurs, importateurs, head-buyers et entreprises au volume qualifié. Chaque itinéraire est validé par notre trading desk.",
    "tours.passenger_info_title": "Passagers",
    "tours.passenger_info_subtitle": "Nom complet et document de chaque passager — utilisé pour la réservation et le check-in en ferme.",
    "tours.passenger_n": "Passager {n}",
    "tours.field_full_name": "Nom complet",
    "tours.field_doc_number": "Numéro du document",
    "tours.field_doc_country": "Pays émetteur (passeport uniquement)",
    "tours.doc_passport": "Passeport",
    "tours.doc_cpf": "CPF (BR)",
    "tours.doc_rg": "RG (BR)",
    "tours.doc_other": "Autre",
    "tours.single_supplement_label": "Supplément voyageur seul · +50%",
    "tours.single_supplement_note": "Les réservations solo sont majorées de 50% sur le tarif par personne, conformément à la pratique des voyages corporate.",
    "tours.subtotal": "Tarif de base · 1 pax",
    "tours.supplement_line": "Supplément single (+50%)",
    "tours.error_passenger_info": "Renseignez le nom et le document de chaque passager.",
    "tours.cta": "Explorer les routes",
    "tours.duration": "Durée",
    "tours.from_price": "À partir de",
    "tours.per_person": "/ personne",
    "tours.region": "Région",
    "tours.farms": "Fermes",
    "tours.farms_count": "fermes",
    "tours.highlights": "Points forts",
    "tours.includes": "Inclus",
    "tours.gallery": "Galerie",
    "tours.request_title": "Réserver ce tour",
    "tours.duration_days": "Durée du tour",
    "tours.days": "jours",
    "tours.airport": "Aéroport d'origine",
    "tours.airport_help": "Nous vous accueillons à l'aéroport choisi (aller-retour).",
    "tours.passengers": "Personnes",
    "tours.start_date": "Date préférée",
    "tours.notes": "Observations",
    "tours.notes_placeholder": "Restrictions alimentaires, intérêts spécifiques, dates alternatives...",
    "tours.estimate": "Estimation",
    "tours.price_per_pax": "Par personne",
    "tours.total_price": "Total estimé",
    "tours.submit": "Réserver le tour",
    "tours.success": "Demande envoyée ! Nous vous recontacterons rapidement.",
    "tours.login_required": "Connectez-vous pour réserver ce tour",
    "tours.includes_title": "Tout est inclus dans le tour",
    "tours.see_route": "Voir la route",
    "tours.best_season": "Meilleure saison",
    "tours.farms_visited": "Fermes visitées",
    "tours.altitude": "Altitude",
    "tours.specialty": "Spécialité",
    "tours.airports_supported": "Aéroports desservis",
    "tours.summary": "Résumé",

    "data.coffee.arabica": "Arabica",
    "data.coffee.conilon": "Conilon",
    "data.coffee.robusta": "Robusta",
    "data.coffee.especial": "Spécialité",
    "data.coffee.microlote": "Microlot",
    "data.coffee.gourmet": "Gourmet",
    "data.process.natural": "Nature",
    "data.process.washed": "Lavé",
    "data.process.honey": "Honey",
    "data.process.pulped_natural": "Dépulpé naturel",
    "data.process.anaerobic": "Anaérobie",
    "data.process.fermentado": "Fermenté",
    "data.quality.commercial": "Commercial",
    "data.quality.premium": "Premium",
    "data.quality.specialty": "Spécialité",
    "data.quality.microlot": "Microlot",
    "data.region.sul_de_minas": "Sud du Minas",
    "data.region.cerrado_mineiro": "Cerrado du Minas",
    "data.region.alta_mogiana": "Alta Mogiana",
    "data.region.chapada_diamantina": "Chapada Diamantina",
    "data.region.espirito_santo": "Espírito Santo",

    "hero.live_arabica": "Arabica",
    "hero.live_ny_futures": "NY Futures",
    "home.experiences_label": "KAFFA EXPERIENCES · ROUTES D'ORIGINE",
    "home.airport_pickup": "Transfert aéroport",
    "home.translator": "Traducteur (PT/EN/ES)",
    "home.sca_cupping": "Cupping SCA",

    "team.leadership": "KAFFA · LEADERSHIP",
    "team.photo_soon": "Photo · bientôt",

    "tours.not_found": "Tour introuvable",
    "tours.contact_disclaimer": "Kaffa Exchange vous contactera pour confirmer les disponibilités, les dates et les ajustements finaux.",
    "tours.pax_short": "pax",

    "admin.live_label": "EN DIRECT · Alpha Vantage",
    "admin.refresh_indicators": "Actualiser les indicateurs",
    "admin.refresh_done": "Indicateurs actualisés",
    "admin.refresh_partial": "Mise à jour partielle — certains indicateurs gardent les valeurs précédentes",
    "admin.refresh_failed": "Échec de l'actualisation des indicateurs",

    "coop.toast.lot_updated": "Lot mis à jour",
    "coop.toast.lot_published": "Lot publié",
    "coop.toast.lot_removed": "Lot supprimé",
    "coop.toast.status_updated": "Statut mis à jour",
    "coop.toast.price_recalc": "Prix recalculé",
    "coop.toast.response_sent": "Réponse envoyée",
    "coop.confirm_delete": "Supprimer ce lot ?",
    "coop.no_proposals_received": "Aucune proposition reçue.",
    "coop.accept_btn": "Accepter",
    "coop.reject_btn": "Refuser",

    "lot.interest_default_msg": "Merci d'envoyer des échantillons et la fiche technique complète.",
    "sample.request_btn": "Demander un échantillon",
    "sample.dialog_title": "Demander un échantillon physique",
    "sample.dialog_subtitle": "Recevez des échantillons du lot à votre adresse pour évaluation sensorielle.",
    "sample.shipping_title": "Adresse d'expédition",
    "sample.use_profile_address": "Utiliser mon adresse enregistrée",
    "sample.use_new_address": "Saisir une nouvelle adresse",
    "sample.field_recipient": "Destinataire",
    "sample.field_address": "Adresse",
    "sample.field_address_placeholder": "Rue, numéro, complément",
    "sample.field_city": "Ville",
    "sample.field_state": "État / Région",
    "sample.field_country": "Pays",
    "sample.field_postal": "Code postal",
    "sample.field_phone": "Téléphone de contact",
    "sample.field_notes": "Notes pour la coopérative",
    "sample.field_notes_placeholder": "Ex. : priorité, fiche technique souhaitée, délai...",
    "sample.send_btn": "Envoyer la demande",
    "sample.error_bags": "Veuillez indiquer la quantité de sacs.",
    "sample.error_address": "Renseignez adresse, ville et pays.",
    "sample.success_toast": "Demande d'échantillon envoyée",
    "sample.success_description": "La coopérative sera alertée et commencera la préparation. Vous pourrez suivre l'expédition ici.",
    "samples.col_lot": "Lot",
    "samples.col_buyer": "Acheteur",
    "samples.col_bags": "Sacs",
    "samples.col_shipping": "Expédition",
    "samples.col_tracking": "Suivi",
    "samples.col_status": "Statut",
    "samples.col_date": "Date",
    "samples.address_profile": "Adresse enregistrée",
    "samples.tracking_pending": "En attente",
    "samples.status_new": "Nouvelle",
    "samples.status_preparing": "En préparation",
    "samples.status_shipped": "Expédiée",
    "samples.status_delivered": "Livrée",
    "samples.status_unavailable": "Indisponible",
    "samples.manage_btn": "Gérer",
    "samples.manage_title": "Gérer l'échantillon",
    "samples.manage_subtitle": "Mettez à jour le statut, le numéro de suivi et le transporteur.",
    "samples.field_status": "Statut",
    "samples.field_tracking_number": "Numéro de suivi",
    "samples.field_tracking_carrier": "Transporteur",
    "samples.field_tracking_url": "URL de suivi",
    "samples.field_internal_notes": "Notes internes",
    "samples.save_btn": "Enregistrer",
    "samples.toast_updated": "Échantillon mis à jour",
    "samples.no_samples": "Aucun échantillon enregistré.",
    "buyer.tab_samples": "Échantillons",
    "buyer.no_samples": "Aucun échantillon demandé.",
    "coop.tab_samples": "Échantillons",
    "coop.no_samples": "Aucune demande d'échantillon.",
    "admin.tab_samples": "Échantillons",
    "admin.no_samples": "Aucune demande d'échantillon enregistrée.",
    "lot.bags_unit": "kg total",

    "footer.version": "v1.0 · Plateforme B2B de Café",
    "footer.location": "São Paulo · Brésil",
    "footer.copyright": "© 2026 KAFFA EXCHANGE",

    "indicator.arabica_ny": "Arabica NY",
    "indicator.conilon_es": "Conilon ES",
    "indicator.usd_brl": "USD / BRL",
    "indicator.usd_eur": "USD / EUR",
    "indicator.fob_santos": "FOB Santos",
    "indicator.export_br": "Exportations Brésil",
    "indicator.infl_br": "Inflation Brésil",
    "indicator.demand_global": "Demande mondiale",
    "settings.theme": "Thème",

    "pwa.tagline": "KAFFA · APP",
    "pwa.install_title": "Installer l'app Kaffa",
    "pwa.install_subtitle": "Accès rapide aux lots, prix et visites depuis votre écran d'accueil.",
    "pwa.install_cta": "Installer",
    "pwa.dismiss": "Plus tard",

    "admin.tab_visits": "Visites",
    "status.archived": "Archivé",
    "status.confirmed": "Confirmé",
    "status.cancelled": "Annulé",
    "status.completed": "Terminé",
    "status.preparing": "En préparation",
    "status.shipped": "Expédiée",
    "status.delivered": "Livrée",
    "status.unavailable": "Indisponible",

    "admin_tours.subtab_packages": "Forfaits",
    "admin_tours.subtab_requests": "Demandes",
    "admin_tours.packages_help": "Créez et gérez les forfaits de visite affichés publiquement sur /tours.",
    "admin_tours.requests_help": "Demandes reçues via /tours. Confirmez, annulez ou marquez comme terminé.",
    "admin_tours.new_btn": "Nouveau forfait",
    "admin_tours.empty": "Aucun forfait.",
    "admin_tours.req_empty": "Aucune demande.",
    "admin_tours.col_name": "Nom",
    "admin_tours.col_base_price": "Prix de base",
    "admin_tours.col_status": "Statut",
    "admin_tours.farms_count": "fermes",
    "admin_tours.publish": "Publier",
    "admin_tours.draft": "Brouillon",
    "admin_tours.dialog_new": "Nouveau forfait de visite",
    "admin_tours.dialog_edit": "Modifier le forfait",
    "admin_tours.form_required": "Veuillez renseigner nom, région et résumé (PT).",
    "admin_tours.field_name": "Nom",
    "admin_tours.field_country": "Pays",
    "admin_tours.field_hero_image": "Image principale (URL)",
    "admin_tours.field_gallery": "Galerie (URLs)",
    "admin_tours.field_summary": "Résumé",
    "admin_tours.field_highlights": "Points forts",
    "admin_tours.field_farms": "Fermes",
    "admin_tours.field_includes": "Ce qui est inclus",
    "admin_tours.field_airports": "Aéroports pris en charge",
    "admin_tours.field_seasons": "Meilleures saisons",
    "admin_tours.field_durations": "Durées (jours)",
    "admin_tours.hint_one_per_line": "Un élément par ligne.",
    "admin_tours.hint_farms": "Une ligne: Nom | Ville | Altitude | Spécialité",
    "admin_tours.hint_durations": "Liste séparée par des virgules (ex.: 7, 10, 15).",
    "admin_tours.status_draft": "Brouillon",
    "admin_tours.status_published": "Publié",
    "admin_tours.status_archived": "Archivé",
    "admin_tours.toast_created": "Forfait créé",
    "admin_tours.toast_updated": "Forfait mis à jour",
    "admin_tours.toast_status": "Statut mis à jour",
    "admin_tours.toast_removed": "Forfait supprimé",
    "admin_tours.req_toast_updated": "Demande mise à jour",
    "admin_tours.confirm_delete": "Supprimer ce forfait ?",
    "admin_tours.save_btn": "Enregistrer",
    "admin_tours.create_btn": "Créer",
    "admin_tours.req_buyer": "Acheteur",
    "admin_tours.req_tour": "Forfait",
    "admin_tours.req_total": "Total",
    "admin_tours.req_when": "Quand",
    "admin_tours.req_pending": "En attente",
    "admin_tours.req_confirmed": "Confirmées",
    "admin_tours.req_cancelled": "Annulées",
    "admin_tours.req_completed": "Terminées",
    "admin_tours.confirm": "Confirmer",
    "admin_tours.cancel": "Annuler",
    "admin_tours.complete": "Terminer",

    "admin_tours.col_days": "Jours",
    "admin_tours.col_seats": "Places",
    "admin_tours.section_image": "Image principale",
    "admin_tours.section_basic": "Informations de base",
    "admin_tours.section_pricing": "Tarif & disponibilités",
    "admin_tours.section_content": "Contenu",
    "admin_tours.section_extras": "Extras",
    "admin_tours.hero_replace_help": "Vous pouvez téléverser une autre image (JPG / PNG / WebP).",
    "admin_tours.replace_image": "Remplacer l'image",
    "admin_tours.remove_image": "Supprimer",
    "admin_tours.image_uploading": "Téléversement…",
    "admin_tours.image_upload_cta": "Téléverser une image",
    "admin_tours.image_hint": "JPG / PNG / WebP · max {mb} Mo",
    "admin_tours.field_duration_days": "Durée (jours)",
    "admin_tours.duration_hint": "Nombre de jours fixe par forfait (ex.: 7, 10, 15).",
    "admin_tours.field_price_per_person": "Prix par personne (USD)",
    "admin_tours.price_hint": "Prix fixe par forfait. Plus de calcul proportionnel.",
    "admin_tours.field_dates_seats": "Dates de départ & places",
    "admin_tours.pick_dates": "Choisir les dates",
    "admin_tours.dates_empty": "Aucune date sélectionnée. Cliquez « Choisir les dates ».",
    "admin_tours.seats_label": "Places",
    "admin_tours.field_description": "Description détaillée",
    "admin_tours.description_hint": "Texte multi-paragraphes pris en charge.",
    "admin_tours.summary_hint": "Résumé court affiché dans les listes et résultats.",
    "admin_tours.err_not_image": "Le fichier sélectionné n'est pas une image.",
    "admin_tours.err_image_too_big": "Image trop volumineuse. Max {mb} Mo.",
    "admin_tours.err_image_read": "Impossible de lire l'image.",
    "tours.choose_date": "Choisir la date de départ",
    "tours.seats_left": "places restantes",
    "tours.pick_date_first": "Choisissez d'abord une date.",
    "tours.not_enough_seats": "Places insuffisantes pour cette date.",
    "tours.about_label": "À propos de cette route",
  },

  "pl": {
    "checkout.unavailable_banner": "PŁATNOŚCI TYMCZASOWO NIEDOSTĘPNE",
    "checkout.unavailable_label": "Już prawie:",
    "checkout.unavailable_help": "Płatności kartą zostaną wkrótce uruchomione. Tymczasem skontaktuj się z nami na trade@kaffaexchange.com, aby sfinalizować rezerwację.",
    "checkout.error_payment_unavailable": "Płatności są obecnie niedostępne. Skontaktujemy się wkrótce.",
    "checkout.errors.card_declined": "Karta odrzucona. Spróbuj inną.",
    "checkout.errors.card_invalid": "Nieprawidłowy numer karty.",
    "checkout.errors.card_invalid_exp": "Nieprawidłowa data ważności (MM/RR).",
    "checkout.errors.card_invalid_cvv": "Nieprawidłowy CVV.",
    "checkout.errors.card_expired": "Karta wygasła.",
    "checkout.errors.date_unavailable": "Data jest już niedostępna.",
    "checkout.errors.no_seats": "Brak wystarczających miejsc.",
    "tours.pay_and_book": "Zapłać i zarezerwuj",
    "checkout.title": "Sfinalizuj rezerwację",
    "checkout.subtitle": "Bezpieczna płatność. Rezerwacja potwierdzona natychmiast.",
    "checkout.demo_mode_banner": "TRYB DEMO · ŻADNA RZECZYWISTA PŁATNOŚĆ NIE ZOSTANIE POBRANA",
    "checkout.summary_label": "Podsumowanie zamówienia",
    "checkout.row_tour": "Trasa",
    "checkout.row_date": "Data",
    "checkout.row_passengers": "Pasażerowie",
    "checkout.row_duration": "Czas trwania",
    "checkout.row_per_person": "Za osobę",
    "checkout.row_airport": "Lotnisko",
    "checkout.total": "Razem",
    "checkout.security_note": "Dane karty nigdy nie są przechowywane jawnie — zapamiętujemy tylko markę i 4 ostatnie cyfry.",
    "checkout.card_label": "Dane karty",
    "checkout.card_number": "Numer karty",
    "checkout.card_name": "Imię i nazwisko",
    "checkout.card_name_placeholder": "JAK NA KARCIE",
    "checkout.card_exp": "Ważność",
    "checkout.pay_button": "Zapłać",
    "checkout.processing": "Przetwarzanie płatności…",
    "checkout.success_toast": "Płatność zatwierdzona",
    "checkout.error_invalid_card": "Sprawdź dane karty.",
    "checkout.test_cards_label": "Karty testowe:",
    "checkout.test_success": "symulowany sukces",
    "checkout.test_declined": "symulowane odrzucenie",
    "receipt.title": "Potwierdzenie płatności",
    "receipt.paid_stamp": "ZAPŁACONE",
    "receipt.tour": "Trasa",
    "receipt.date": "Data",
    "receipt.passengers": "Pasażerowie",
    "receipt.airport": "Lotnisko",
    "receipt.card": "Karta",
    "receipt.paid_at": "Opłacone",
    "receipt.total_paid": "Razem opłacone",
    "receipt.email_sent": "Potwierdzenie wysłane na {email}",
    "receipt.download_pdf": "Pobierz PDF",
    "receipt.close": "Zamknij",
    "receipt.admin_will_contact": "Nasz zespół skontaktuje się w 24h, aby potwierdzić kolejne kroki.",
    "admin_tours.req_order": "Zamówienie",
    "admin_tours.req_payment": "Płatność",
    "admin_tours.payment_paid": "Opłacone",
    "admin_tours.payment_unpaid": "Nieopłacone",
    "pending.label": "W TRAKCIE WERYFIKACJI",
    "pending.title": "Wniosek w weryfikacji",
    "pending.subtitle": "Twój wniosek został odebrany i jest weryfikowany przez zespół Kaffa Exchange. Otrzymasz e-mail po zakończeniu.",
    "pending.rejected_label": "WNIOSEK ODRZUCONY",
    "pending.rejected_title": "Twój wniosek został odrzucony",
    "pending.rejected_subtitle": "Twoja rejestracja nie została zatwierdzona. Możesz skontaktować się z naszym zespołem lub złożyć nowy wniosek po poprawieniu wskazanych punktów.",
    "pending.rejection_reason_label": "Powód odrzucenia",
    "pending.contact_cta": "Skontaktuj się z zespołem",
    "pending.email": "E-mail",
    "pending.company": "Firma",
    "pending.country": "Kraj",
    "pending.logout": "Wyloguj się",
    "admin.subtab_pending": "Oczekujące",
    "admin.subtab_rejected": "Odrzucone",
    "admin.no_rejected": "Brak odrzuconych rejestracji.",
    "admin.col_rejection_reason": "Powód",
    "admin.col_rejected_at": "Odrzucone",
    "admin.restore": "Przywróć",
    "admin.user_restored": "Rejestracja otwarta do ponownej weryfikacji",
    "admin.reject_dialog_title": "Odrzuć rejestrację",
    "admin.reject_dialog_reason": "Powód odrzucenia",
    "admin.reject_dialog_placeholder": "Np.: Niekompletna dokumentacja. Wyślij ponownie z aktywnym Tax ID.",
    "admin.reject_dialog_help": "Kupujący zobaczy ten powód przy próbie logowania.",
    "nav.home": "Strona główna",
    "nav.marketplace": "Marketplace",
    "nav.tours": "Wizyty w gospodarstwach",
    "nav.about": "O nas",
    "nav.login": "Zaloguj się",
    "nav.register": "Zarejestruj się",
    "nav.dashboard": "Panel",
    "nav.logout": "Wyloguj",

    "common.bags": "worki",
    "common.region": "Region",
    "common.process": "Proces",
    "common.search": "Szukaj partii, gospodarstw, regionów...",
    "common.all": "Wszystkie",
    "common.cancel": "Anuluj",
    "common.confirm": "Potwierdź",
    "common.save": "Zapisz",
    "common.loading": "Ładowanie...",
    "common.send": "Wyślij",
    "common.edit": "Edytuj",
    "common.delete": "Usuń",
    "common.create": "Utwórz",
    "common.actions": "Działania",
    "common.status": "Status",
    "common.date": "Data",
    "common.optional": "opcjonalne",
    "common.back": "Wróć",
    "common.demo_creds": "Dane testowe",

    "hero.tagline": "KAFFA EXCHANGE · OBRÓT SUROWCAMI",
    "hero.title": "Globalny rynek kawy, w wersji cyfrowej.",
    "hero.subtitle": "Platforma B2B do negocjacji i eksportu, łącząca spółdzielnie producenckie z międzynarodowymi kupcami.",
    "hero.cta_explore": "Przeglądaj partie",
    "hero.cta_register": "Zarejestruj firmę",
    "hero.stat_bags": "Worki/miesiąc",
    "hero.stat_coops": "Spółdzielnie",
    "hero.stat_countries": "Kraje",
    "hero.live_market": "Rynek na żywo",

    "ticker.label": "RYNEK GLOBALNY",

    "pillar.verify.title": "Pełna weryfikacja",
    "pillar.verify.desc": "Każdy kupiec przechodzi ręczną akceptację backoffice.",
    "pillar.export.title": "Eksport globalny",
    "pillar.export.desc": "FOB Santos gotowy. Zintegrowana logistyka międzynarodowa.",
    "pillar.pricing.title": "Dynamiczne ceny",
    "pillar.pricing.desc": "Silnik przelicza ceny na podstawie globalnych wskaźników w czasie rzeczywistym.",
    "pillar.trace.title": "Identyfikowalność",
    "pillar.trace.desc": "Od producenta do filiżanki: gospodarstwo, wysokość, proces, SCA.",

    "mission.tagline": "Nasza misja",
    "mission.title": "Demokratyzować handel kawą, przekazując więcej pieniędzy producentom.",
    "mission.subtitle": "Łączymy bezpośrednio spółdzielnie, producentów i światowych kupców — eliminując pośredników, zwiększając identyfikowalność i zwracając sprawiedliwą wartość tym, którzy uprawiają kawę.",
    "mission.value1_title": "Sprawiedliwość ekonomiczna",
    "mission.value1_desc": "Bezpośredni handel zwracający większą marżę producentom.",
    "mission.value2_title": "Pełna identyfikowalność",
    "mission.value2_desc": "Każda partia ma udokumentowane pochodzenie, proces i historię.",
    "mission.value3_title": "Technologia w agro",
    "mission.value3_desc": "Silnik cenowy, globalne wskaźniki i nowoczesne dashboardy.",
    "mission.value4_title": "Zrównoważony rozwój",
    "mission.value4_desc": "Priorytet dla spółdzielni z certyfikatami środowiskowymi i społecznymi.",

    "lots.public_title": "Dostępne partie",
    "lots.public_subtitle": "Katalog publiczny — ceny i pełne dane odblokowane po akceptacji konta.",
    "lots.active": "aktywnych partii",
    "lots.locked": "Zaloguj się, aby zobaczyć ceny i pełne szczegóły",
    "lots.available": "Dostępne",
    "lots.price_label": "Worek 60kg",
    "lots.empty": "Brak partii spełniających filtry.",
    "lots.filter_type": "Typy",
    "lots.filter_process": "Procesy",
    "lots.filter_region": "Regiony",

    "auth.login_title": "Zaloguj się do Kaffa Exchange",
    "auth.register_title": "Utwórz konto biznesowe",
    "auth.email": "E-mail",
    "auth.password": "Hasło",
    "auth.razao_social": "Nazwa firmy",
    "auth.cnpj": "NIP / Tax ID",
    "auth.address": "Pełny adres",
    "auth.phone": "Telefon",
    "auth.country": "Kraj",
    "auth.commercial": "Kontakt handlowy",
    "auth.submit_login": "Zaloguj",
    "auth.submit_register": "Poproś o dostęp",
    "auth.no_account": "Nie masz jeszcze konta?",
    "auth.has_account": "Masz już konto?",
    "auth.request_signup": "Poproś o dostęp",
    "auth.signin": "Zaloguj się",

    "login.tagline": "Trading Desk · Kaffa Exchange",
    "login.banner_title": "Dostęp tylko dla zatwierdzonych operatorów.",
    "login.banner_subtitle": "Spółdzielnie, kupcy i administratorzy wchodzą na rynek tutaj.",
    "login.signin_label": "Sign In",

    "register.tagline": "Onboarding · B2B",
    "register.intro": "Rejestracja przeznaczona jest dla firm importujących i operatorów handlowych. Po wysłaniu nasz zespół weryfikuje dane przed odblokowaniem pełnego dostępu.",
    "register.verification": "Weryfikacja compliance",
    "register.verification_desc": "Firmowe KYC do 48h. Po zatwierdzeniu zobaczysz ceny, oceny SCA, certyfikaty i będziesz mógł składać oferty.",
    "register.success": "Rejestracja wysłana do weryfikacji",
    "register.placeholder_razao": "Müller Global Coffee Imports GmbH",
    "register.placeholder_cnpj": "0000000000",
    "register.placeholder_country": "Polska / Niemcy / USA...",
    "register.placeholder_address": "Ulica, numer, dzielnica, miasto, kod, kraj",
    "register.placeholder_phone": "+48 22 555 00 00",
    "register.placeholder_contact": "Imię i nazwisko osoby kontaktowej",
    "register.placeholder_email": "kontakt@firma.com",
    "register.placeholder_password": "Minimum 6 znaków",
    "register.submitting": "Wysyłanie...",

    "pending.tagline": "Status · W weryfikacji",
    "pending.message": "Twoja rejestracja została otrzymana i jest weryfikowana przez zespół Kaffa. Otrzymasz e-mail po zatwierdzeniu.",
    "pending.submitted_data": "Przesłane dane",
    "pending.step1": "Rejestracja otrzymana",
    "pending.step2": "W weryfikacji przez backoffice (do 48h)",
    "pending.step3": "Zatwierdzenie i odblokowanie dostępu",
    "pending.view_market": "Zobacz Marketplace",

    "alerts.label": "Alerty",
    "alerts.new": "nowych",
    "alerts.mark_read": "Oznacz przeczytane",
    "alerts.empty": "Brak alertów.",

    "footer.subtitle": "Platforma B2B handlu i eksportu kawy. Łączy spółdzielnie producenckie z międzynarodowymi kupcami w sposób przejrzysty i nowoczesny.",
    "footer.platform": "Platforma",
    "footer.contact": "Kontakt",

    "lot.tab_details": "Szczegóły",
    "lot.tab_certs": "Certyfikaty",
    "lot.tab_docs": "Dokumenty",
    "lot.tab_history": "Historia cen",
    "lot.origin": "Pochodzenie",
    "lot.cooperative": "Spółdzielnia",
    "lot.notes": "Notatki sensoryczne",
    "lot.altitude": "Wysokość",
    "lot.sieve": "Sito",
    "lot.crop": "Zbiór",
    "lot.humidity": "Wilgotność",
    "lot.blend": "Blend",
    "lot.fob": "FOB",
    "lot.demo_interest": "Wyraź zainteresowanie",
    "lot.demo_interest_short": "Zainteresowanie",
    "lot.propose": "Złóż ofertę",
    "lot.propose_short": "Oferta",
    "lot.propose_title": "Wyślij ofertę",
    "lot.interest_title": "Wyraź zainteresowanie",
    "lot.bags_qty": "Liczba (worki)",
    "lot.price_label": "Cena/worek",
    "lot.message_label": "Wiadomość",
    "lot.message_placeholder": "Warunki dostawy, daty, uwagi...",
    "lot.send_proposal": "Wyślij ofertę",
    "lot.send_interest": "Wyślij zainteresowanie",
    "lot.not_found": "Nie znaleziono partii",
    "lot.no_certs": "Brak zarejestrowanych certyfikatów.",
    "lot.no_docs": "Brak załączonych dokumentów.",
    "lot.no_history": "Brak historii cen. Włącz auto-pricing, aby śledzić zmiany.",
    "lot.proposal_sent": "Oferta wysłana do spółdzielni",
    "lot.interest_sent": "Zainteresowanie zarejestrowane",
    "lot.auto_priced": "AUTO-PRICED · Marża",
    "lot.total_volume": "Łączna objętość",
    "lot.available_qty": "Dostępne",
    "lot.bag_price": "Worek 60kg",

    "buyer.desk": "Biuro kupca",
    "buyer.title": "Panel kupca",
    "buyer.subtitle": "Pełen marketplace, Twoje oferty i zainteresowania.",
    "buyer.tab_market": "Rynek",
    "buyer.tab_proposals": "Moje oferty",
    "buyer.tab_interests": "Zainteresowania",
    "buyer.col_lot": "Partia",
    "buyer.col_proposed_price": "Cena oferty",
    "buyer.col_bags": "Worki",
    "buyer.col_counter": "Kontroferta",
    "buyer.no_proposals": "Brak wysłanych ofert.",
    "buyer.no_interests": "Brak zarejestrowanych zainteresowań.",

    "coop.desk": "Biuro spółdzielni",
    "coop.title": "Zarządzanie partiami",
    "coop.new_lot": "Nowa partia",
    "coop.kpi_active": "Aktywne partie",
    "coop.kpi_bags": "Razem worki",
    "coop.kpi_pending_props": "Oferty oczekujące",
    "coop.kpi_interests": "Zainteresowania",
    "coop.tab_lots": "Partie",
    "coop.tab_proposals": "Oferty",
    "coop.tab_interests": "Zainteresowania",
    "coop.col_lot": "Partia",
    "coop.col_type": "Typ",
    "coop.col_bags": "Worki",
    "coop.col_price": "Cena",
    "coop.col_auto": "Auto",
    "coop.col_buyer": "Kupiec",
    "coop.no_proposals": "Brak otrzymanych ofert.",
    "coop.no_interests": "Brak zainteresowań.",
    "coop.accept": "Zaakceptuj",
    "coop.reject": "Odrzuć",
    "coop.delete_confirm": "Usunąć tę partię?",
    "coop.lot_removed": "Partia usunięta",
    "coop.lot_updated": "Status zaktualizowany",
    "coop.price_recalc": "Cena przeliczona",
    "coop.lot_published": "Partia opublikowana",
    "coop.lot_edited": "Partia zaktualizowana",
    "coop.response_sent": "Odpowiedź wysłana",
    "coop.edit_lot": "Edytuj partię",
    "coop.create_lot": "Nowa partia",
    "coop.update": "Aktualizuj",
    "coop.publish": "Opublikuj partię",
    "coop.field_name": "Nazwa partii",
    "coop.field_quality": "Jakość",
    "coop.field_currency": "Waluta",
    "coop.field_sca": "Ocena SCA",
    "coop.field_farm": "Gospodarstwo",
    "coop.field_city": "Miasto",
    "coop.field_state": "Region/Stan",
    "coop.field_port": "Port FOB",
    "coop.field_images": "URL obrazu (oddziel przecinkami)",
    "coop.field_certs": "Certyfikaty (oddziel przecinkami)",
    "coop.field_notes": "Notatki",
    "coop.auto_title": "Automatyczna aktualizacja ceny",
    "coop.auto_desc": "Silnik przelicza cenę z globalnych wskaźników (NY Futures, USD/BRL, FOB, popyt).",
    "coop.margin": "Własna marża (%)",

    "admin.desk": "Backoffice · Centrum kontroli Admin",
    "admin.title": "Panel administratora",
    "admin.kpi_active_lots": "Aktywne partie",
    "admin.kpi_bags": "Worki/Rynek",
    "admin.kpi_buyers": "Aktywni kupcy",
    "admin.kpi_pending": "Oczekujące",
    "admin.kpi_coops": "Spółdzielnie",
    "admin.kpi_props": "Oferty",
    "admin.chart_region": "Wolumen wg regionu (worki)",
    "admin.chart_types": "Mix typów kawy",
    "admin.tab_approvals": "Zatwierdzenia",
    "admin.tab_users": "Użytkownicy",
    "admin.tab_coops": "Spółdzielnie",
    "admin.tab_lots": "Partie",
    "admin.tab_proposals": "Negocjacje",
    "admin.tab_indicators": "Wskaźniki",
    "admin.col_company": "Firma",
    "admin.col_name": "Nazwa",
    "admin.col_role": "Rola",
    "admin.no_pending": "Brak oczekujących zatwierdzeń.",
    "admin.approve": "Zatwierdź",
    "admin.reject": "Odrzuć",
    "admin.user_approved": "Kupiec zatwierdzony",
    "admin.user_rejected": "Kupiec odrzucony",
    "admin.coop_created": "Spółdzielnia utworzona",
    "admin.coop_user_created": "Użytkownik spółdzielni utworzony",
    "admin.indicator_updated": "Wskaźnik zaktualizowany",
    "admin.new_coop": "Nowa spółdzielnia",
    "admin.new_coop_user": "Nowy użytkownik spółdzielni",
    "admin.coop_descr_label": "Opis",
    "admin.indicators_help": "Wskaźniki zasilają silnik auto-pricing. Zmień wartości aby symulować scenariusze rynkowe.",
    "admin.select_coop": "Wybierz...",

    "status.pending": "Oczekujące",
    "status.approved": "Zatwierdzone",
    "status.rejected": "Odrzucona",
    "status.accepted": "Zaakceptowana",
    "status.counter": "Kontroferta",
    "status.closed": "Zamknięta",
    "status.new": "Nowy",
    "status.contacted": "Skontaktowano",
    "status.published": "Opublikowane",
    "status.paused": "Wstrzymane",
    "status.draft": "Wersja robocza",
    "status.sold": "Sprzedane",
    "status.expired": "Wygasłe",
    "status.active": "Aktywne",

    "login.welcome": "Witaj",

    "tours.public_title": "Odwiedź źródło. Zawieraj kontrakty bezpośrednio z producentem.",
    "tours.public_subtitle": "Prywatne wizyty techniczne w nagradzanych gospodarstwach, organizowane przez Kaffa Exchange dla kwalifikowanych kupców i importerów. Cupping SCA, due diligence operacyjne, spotkania z plantatorami i zawieranie kontraktów w terenie.",
    "tours.eyebrow": "Wizyty techniczne · Program B2B",
    "tours.benefit_cupping": "Stół do cuppingu SCA z producentami",
    "tours.benefit_producers": "Bezpośrednie spotkania z plantatorami",
    "tours.benefit_diligence": "Due diligence operacyjne + sample lab",
    "tours.benefit_logistics": "Nocleg, transfer i tłumacz w cenie",
    "tours.eligibility_note": "Program ekskluzywny dla kupców, importerów, head-buyerów i firm o kwalifikowanym wolumenie. Każda trasa jest weryfikowana przez nasz dział handlowy.",
    "tours.passenger_info_title": "Pasażerowie",
    "tours.passenger_info_subtitle": "Imię i nazwisko oraz dokument każdego pasażera — używane do rezerwacji i check-inu w gospodarstwach.",
    "tours.passenger_n": "Pasażer {n}",
    "tours.field_full_name": "Imię i nazwisko",
    "tours.field_doc_number": "Numer dokumentu",
    "tours.field_doc_country": "Kraj wydania (tylko paszport)",
    "tours.doc_passport": "Paszport",
    "tours.doc_cpf": "CPF (BR)",
    "tours.doc_rg": "RG (BR)",
    "tours.doc_other": "Inny",
    "tours.single_supplement_label": "Dopłata single · +50%",
    "tours.single_supplement_note": "Rezerwacje pojedyncze są obciążone dopłatą 50% do ceny/osobę, zgodnie ze standardem pakietów korporacyjnych.",
    "tours.subtotal": "Cena bazowa · 1 pax",
    "tours.supplement_line": "Dopłata single (+50%)",
    "tours.error_passenger_info": "Uzupełnij imię i dokument każdego pasażera.",
    "tours.cta": "Zobacz trasy",
    "tours.duration": "Czas trwania",
    "tours.from_price": "Od",
    "tours.per_person": "/ osoba",
    "tours.region": "Region",
    "tours.farms": "Gospodarstwa",
    "tours.farms_count": "gospodarstw",
    "tours.highlights": "Najważniejsze",
    "tours.includes": "W cenie",
    "tours.gallery": "Galeria",
    "tours.request_title": "Zarezerwuj tę wycieczkę",
    "tours.duration_days": "Czas wycieczki",
    "tours.days": "dni",
    "tours.airport": "Lotnisko początkowe",
    "tours.airport_help": "Odbierzemy Cię z wybranego lotniska (w obie strony).",
    "tours.passengers": "Osoby",
    "tours.start_date": "Preferowana data",
    "tours.notes": "Uwagi",
    "tours.notes_placeholder": "Ograniczenia żywieniowe, konkretne zainteresowania, alternatywne daty...",
    "tours.estimate": "Szacunkowa inwestycja",
    "tours.price_per_pax": "Za osobę",
    "tours.total_price": "Łączny koszt",
    "tours.submit": "Zarezerwuj wycieczkę",
    "tours.success": "Zgłoszenie wysłane! Skontaktujemy się wkrótce.",
    "tours.login_required": "Zaloguj się, aby zarezerwować",
    "tours.includes_title": "Wszystko w cenie wycieczki",
    "tours.see_route": "Zobacz trasę",
    "tours.best_season": "Najlepszy sezon",
    "tours.farms_visited": "Odwiedzane gospodarstwa",
    "tours.altitude": "Wysokość",
    "tours.specialty": "Specjalność",
    "tours.airports_supported": "Obsługiwane lotniska",
    "tours.summary": "Podsumowanie",

    "data.coffee.arabica": "Arabika",
    "data.coffee.conilon": "Conilon",
    "data.coffee.robusta": "Robusta",
    "data.coffee.especial": "Specjalna",
    "data.coffee.microlote": "Mikropartia",
    "data.coffee.gourmet": "Gourmet",
    "data.process.natural": "Naturalny",
    "data.process.washed": "Myty",
    "data.process.honey": "Honey",
    "data.process.pulped_natural": "Pulped Natural",
    "data.process.anaerobic": "Anaerobowy",
    "data.process.fermentado": "Fermentowany",
    "data.quality.commercial": "Komercyjna",
    "data.quality.premium": "Premium",
    "data.quality.specialty": "Specialty",
    "data.quality.microlot": "Mikropartia",
    "data.region.sul_de_minas": "Południowa Minas",
    "data.region.cerrado_mineiro": "Cerrado Mineiro",
    "data.region.alta_mogiana": "Alta Mogiana",
    "data.region.chapada_diamantina": "Chapada Diamantina",
    "data.region.espirito_santo": "Espírito Santo",

    "hero.live_arabica": "Arabika",
    "hero.live_ny_futures": "NY Futures",
    "home.experiences_label": "KAFFA EXPERIENCES · TRASY POCHODZENIA",
    "home.airport_pickup": "Transfer z lotniska",
    "home.translator": "Tłumacz (PT/EN/ES)",
    "home.sca_cupping": "Cupping SCA",

    "team.leadership": "KAFFA · LIDERSHIP",
    "team.photo_soon": "Zdjęcie · wkrótce",

    "tours.not_found": "Nie znaleziono wycieczki",
    "tours.contact_disclaimer": "Kaffa Exchange skontaktuje się z Tobą, aby potwierdzić dostępność, daty i końcowe szczegóły.",
    "tours.pax_short": "pax",

    "admin.live_label": "NA ŻYWO · Alpha Vantage",
    "admin.refresh_indicators": "Odśwież wskaźniki",
    "admin.refresh_done": "Wskaźniki zaktualizowane",
    "admin.refresh_partial": "Aktualizacja częściowa — niektóre wskaźniki używają poprzednich wartości",
    "admin.refresh_failed": "Nie udało się odświeżyć wskaźników",

    "coop.toast.lot_updated": "Partia zaktualizowana",
    "coop.toast.lot_published": "Partia opublikowana",
    "coop.toast.lot_removed": "Partia usunięta",
    "coop.toast.status_updated": "Status zaktualizowany",
    "coop.toast.price_recalc": "Cena przeliczona",
    "coop.toast.response_sent": "Odpowiedź wysłana",
    "coop.confirm_delete": "Usunąć tę partię?",
    "coop.no_proposals_received": "Brak otrzymanych propozycji.",
    "coop.accept_btn": "Akceptuj",
    "coop.reject_btn": "Odrzuć",

    "lot.interest_default_msg": "Proszę o wysłanie próbek i kompletnej karty technicznej.",
    "sample.request_btn": "Zamów próbkę",
    "sample.dialog_title": "Zamów fizyczną próbkę",
    "sample.dialog_subtitle": "Otrzymaj próbki partii pod swój adres do oceny sensorycznej.",
    "sample.shipping_title": "Adres dostawy",
    "sample.use_profile_address": "Użyj zapisanego adresu",
    "sample.use_new_address": "Podaj nowy adres",
    "sample.field_recipient": "Odbiorca",
    "sample.field_address": "Adres",
    "sample.field_address_placeholder": "Ulica, numer, lokal",
    "sample.field_city": "Miasto",
    "sample.field_state": "Województwo",
    "sample.field_country": "Kraj",
    "sample.field_postal": "Kod pocztowy",
    "sample.field_phone": "Telefon kontaktowy",
    "sample.field_notes": "Uwagi dla spółdzielni",
    "sample.field_notes_placeholder": "Np. priorytet, oczekiwana karta techniczna, termin...",
    "sample.send_btn": "Wyślij zgłoszenie",
    "sample.error_bags": "Podaj liczbę worków.",
    "sample.error_address": "Wypełnij adres, miasto i kraj.",
    "sample.success_toast": "Zamówienie próbki wysłane",
    "sample.success_description": "Spółdzielnia otrzyma powiadomienie i rozpocznie przygotowania. Możesz śledzić przesyłkę tutaj.",
    "samples.col_lot": "Partia",
    "samples.col_buyer": "Kupujący",
    "samples.col_bags": "Worki",
    "samples.col_shipping": "Dostawa",
    "samples.col_tracking": "Śledzenie",
    "samples.col_status": "Status",
    "samples.col_date": "Data",
    "samples.address_profile": "Adres z profilu",
    "samples.tracking_pending": "Oczekuje",
    "samples.status_new": "Nowa",
    "samples.status_preparing": "Przygotowanie",
    "samples.status_shipped": "Wysłana",
    "samples.status_delivered": "Dostarczona",
    "samples.status_unavailable": "Niedostępna",
    "samples.manage_btn": "Zarządzaj",
    "samples.manage_title": "Zarządzaj próbką",
    "samples.manage_subtitle": "Zaktualizuj status, numer śledzenia i przewoźnika.",
    "samples.field_status": "Status",
    "samples.field_tracking_number": "Numer śledzenia",
    "samples.field_tracking_carrier": "Przewoźnik",
    "samples.field_tracking_url": "URL śledzenia",
    "samples.field_internal_notes": "Notatki wewnętrzne",
    "samples.save_btn": "Zapisz",
    "samples.toast_updated": "Próbka zaktualizowana",
    "samples.no_samples": "Brak zarejestrowanych próbek.",
    "buyer.tab_samples": "Próbki",
    "buyer.no_samples": "Brak zamówionych próbek.",
    "coop.tab_samples": "Próbki",
    "coop.no_samples": "Brak zgłoszeń próbek.",
    "admin.tab_samples": "Próbki",
    "admin.no_samples": "Brak zarejestrowanych zgłoszeń próbek.",
    "lot.bags_unit": "kg łącznie",

    "footer.version": "v1.0 · Platforma B2B Kawy",
    "footer.location": "São Paulo · Brazylia",
    "footer.copyright": "© 2026 KAFFA EXCHANGE",

    "indicator.arabica_ny": "Arabika NY",
    "indicator.conilon_es": "Conilon ES",
    "indicator.usd_brl": "USD / BRL",
    "indicator.usd_eur": "USD / EUR",
    "indicator.fob_santos": "FOB Santos",
    "indicator.export_br": "Eksport Brazylii",
    "indicator.infl_br": "Inflacja Brazylii",
    "indicator.demand_global": "Globalny popyt",
    "settings.theme": "Motyw",

    "pwa.tagline": "KAFFA · APP",
    "pwa.install_title": "Zainstaluj aplikację Kaffa",
    "pwa.install_subtitle": "Szybki dostęp do partii, cen i wizyt z ekranu głównego.",
    "pwa.install_cta": "Zainstaluj",
    "pwa.dismiss": "Nie teraz",

    "admin.tab_visits": "Wizyty",
    "status.archived": "Zarchiwizowane",
    "status.confirmed": "Potwierdzone",
    "status.cancelled": "Anulowane",
    "status.completed": "Zakończone",
    "status.preparing": "Przygotowanie",
    "status.shipped": "Wysłana",
    "status.delivered": "Dostarczona",
    "status.unavailable": "Niedostępna",

    "admin_tours.subtab_packages": "Pakiety",
    "admin_tours.subtab_requests": "Zgłoszenia",
    "admin_tours.packages_help": "Twórz i zarządzaj pakietami wizyt na farmach widocznymi w /tours.",
    "admin_tours.requests_help": "Zgłoszenia z /tours. Potwierdź, anuluj lub oznacz jako zakończone.",
    "admin_tours.new_btn": "Nowy pakiet",
    "admin_tours.empty": "Brak pakietów.",
    "admin_tours.req_empty": "Brak zgłoszeń.",
    "admin_tours.col_name": "Nazwa",
    "admin_tours.col_base_price": "Cena bazowa",
    "admin_tours.col_status": "Status",
    "admin_tours.farms_count": "farmy",
    "admin_tours.publish": "Publikuj",
    "admin_tours.draft": "Wersja robocza",
    "admin_tours.dialog_new": "Nowy pakiet wizyty",
    "admin_tours.dialog_edit": "Edytuj pakiet",
    "admin_tours.form_required": "Wypełnij nazwę, region i opis (PT).",
    "admin_tours.field_name": "Nazwa",
    "admin_tours.field_country": "Kraj",
    "admin_tours.field_hero_image": "Główne zdjęcie (URL)",
    "admin_tours.field_gallery": "Galeria (URL)",
    "admin_tours.field_summary": "Opis",
    "admin_tours.field_highlights": "Atrakcje",
    "admin_tours.field_farms": "Farmy",
    "admin_tours.field_includes": "Co jest wliczone",
    "admin_tours.field_airports": "Obsługiwane lotniska",
    "admin_tours.field_seasons": "Najlepsze pory",
    "admin_tours.field_durations": "Czas trwania (dni)",
    "admin_tours.hint_one_per_line": "Jeden element na linię.",
    "admin_tours.hint_farms": "Jedna linia: Nazwa | Miasto | Wysokość | Specjalność",
    "admin_tours.hint_durations": "Lista oddzielona przecinkami (np. 7, 10, 15).",
    "admin_tours.status_draft": "Wersja robocza",
    "admin_tours.status_published": "Opublikowany",
    "admin_tours.status_archived": "Zarchiwizowany",
    "admin_tours.toast_created": "Pakiet utworzony",
    "admin_tours.toast_updated": "Pakiet zaktualizowany",
    "admin_tours.toast_status": "Status zaktualizowany",
    "admin_tours.toast_removed": "Pakiet usunięty",
    "admin_tours.req_toast_updated": "Zgłoszenie zaktualizowane",
    "admin_tours.confirm_delete": "Usunąć ten pakiet?",
    "admin_tours.save_btn": "Zapisz",
    "admin_tours.create_btn": "Utwórz",
    "admin_tours.req_buyer": "Kupujący",
    "admin_tours.req_tour": "Pakiet",
    "admin_tours.req_total": "Razem",
    "admin_tours.req_when": "Kiedy",
    "admin_tours.req_pending": "Oczekujące",
    "admin_tours.req_confirmed": "Potwierdzone",
    "admin_tours.req_cancelled": "Anulowane",
    "admin_tours.req_completed": "Zakończone",
    "admin_tours.confirm": "Potwierdź",
    "admin_tours.cancel": "Anuluj",
    "admin_tours.complete": "Zakończ",

    "admin_tours.col_days": "Dni",
    "admin_tours.col_seats": "Miejsca",
    "admin_tours.section_image": "Zdjęcie główne",
    "admin_tours.section_basic": "Informacje podstawowe",
    "admin_tours.section_pricing": "Cena i dostępność",
    "admin_tours.section_content": "Treść",
    "admin_tours.section_extras": "Dodatki",
    "admin_tours.hero_replace_help": "Możesz wgrać inne zdjęcie (JPG / PNG / WebP).",
    "admin_tours.replace_image": "Wymień zdjęcie",
    "admin_tours.remove_image": "Usuń",
    "admin_tours.image_uploading": "Wgrywanie…",
    "admin_tours.image_upload_cta": "Wgraj zdjęcie",
    "admin_tours.image_hint": "JPG / PNG / WebP · maks. {mb} MB",
    "admin_tours.field_duration_days": "Czas trwania (dni)",
    "admin_tours.duration_hint": "Stała liczba dni dla każdego pakietu (np. 7, 10, 15).",
    "admin_tours.field_price_per_person": "Cena za osobę (USD)",
    "admin_tours.price_hint": "Stała cena per-pakiet. Brak proporcjonalnego naliczania.",
    "admin_tours.field_dates_seats": "Daty wyjazdów i miejsca",
    "admin_tours.pick_dates": "Wybierz daty",
    "admin_tours.dates_empty": "Brak wybranych dat. Kliknij \"Wybierz daty\".",
    "admin_tours.seats_label": "Miejsca",
    "admin_tours.field_description": "Szczegółowy opis",
    "admin_tours.description_hint": "Obsługuje wieloakapitowy opis.",
    "admin_tours.summary_hint": "Krótkie streszczenie widoczne na listach i w wynikach.",
    "admin_tours.err_not_image": "Wybrany plik nie jest obrazem.",
    "admin_tours.err_image_too_big": "Obraz zbyt duży. Maks {mb} MB.",
    "admin_tours.err_image_read": "Nie udało się odczytać obrazu.",
    "tours.choose_date": "Wybierz datę wyjazdu",
    "tours.seats_left": "wolnych miejsc",
    "tours.pick_date_first": "Wybierz najpierw datę.",
    "tours.not_enough_seats": "Za mało miejsc na tę datę.",
    "tours.about_label": "O tej trasie",
  },

  "ar": {
    "checkout.unavailable_banner": "المدفوعات غير متاحة مؤقتًا",
    "checkout.unavailable_label": "قريبًا جدًا:",
    "checkout.unavailable_help": "سيتم تفعيل الدفع بالبطاقة قريبًا. في الوقت الحالي، تواصل مع فريقنا عبر trade@kaffaexchange.com لإكمال حجزك.",
    "checkout.error_payment_unavailable": "المدفوعات غير متاحة حاليًا. سنتواصل معك قريبًا.",
    "checkout.errors.card_declined": "تم رفض البطاقة. حاول بأخرى.",
    "checkout.errors.card_invalid": "رقم البطاقة غير صالح.",
    "checkout.errors.card_invalid_exp": "تاريخ انتهاء غير صالح (MM/YY).",
    "checkout.errors.card_invalid_cvv": "CVV غير صالح.",
    "checkout.errors.card_expired": "البطاقة منتهية.",
    "checkout.errors.date_unavailable": "التاريخ لم يعد متاحًا.",
    "checkout.errors.no_seats": "المقاعد غير كافية في هذا التاريخ.",
    "tours.pay_and_book": "ادفع واحجز",
    "checkout.title": "إكمال الحجز",
    "checkout.subtitle": "دفع آمن. حجزك مؤكد فورًا.",
    "checkout.demo_mode_banner": "وضع تجريبي · لن يتم تحصيل أي مبلغ فعلي",
    "checkout.summary_label": "ملخص الطلب",
    "checkout.row_tour": "الجولة",
    "checkout.row_date": "التاريخ",
    "checkout.row_passengers": "المسافرون",
    "checkout.row_duration": "المدة",
    "checkout.row_per_person": "للشخص",
    "checkout.row_airport": "المطار",
    "checkout.total": "الإجمالي",
    "checkout.security_note": "لا يتم تخزين بيانات البطاقة بصيغة واضحة. نحتفظ فقط بالعلامة وآخر 4 أرقام.",
    "checkout.card_label": "بيانات البطاقة",
    "checkout.card_number": "رقم البطاقة",
    "checkout.card_name": "الاسم على البطاقة",
    "checkout.card_name_placeholder": "كما هو في البطاقة",
    "checkout.card_exp": "تاريخ الانتهاء",
    "checkout.pay_button": "ادفع",
    "checkout.processing": "جاري معالجة الدفع…",
    "checkout.success_toast": "تمت الموافقة على الدفع",
    "checkout.error_invalid_card": "يرجى التحقق من بيانات البطاقة.",
    "checkout.test_cards_label": "بطاقات اختبار:",
    "checkout.test_success": "نجاح محاكى",
    "checkout.test_declined": "رفض محاكى",
    "receipt.title": "إيصال الدفع",
    "receipt.paid_stamp": "مدفوع",
    "receipt.tour": "الجولة",
    "receipt.date": "التاريخ",
    "receipt.passengers": "المسافرون",
    "receipt.airport": "المطار",
    "receipt.card": "البطاقة",
    "receipt.paid_at": "تاريخ الدفع",
    "receipt.total_paid": "إجمالي المدفوع",
    "receipt.email_sent": "تم إرسال الإيصال إلى {email}",
    "receipt.download_pdf": "تنزيل PDF",
    "receipt.close": "إغلاق",
    "receipt.admin_will_contact": "سيتواصل فريقنا خلال 24 ساعة لتأكيد الخطوات التالية.",
    "admin_tours.req_order": "الطلب",
    "admin_tours.req_payment": "الدفع",
    "admin_tours.payment_paid": "مدفوع",
    "admin_tours.payment_unpaid": "غير مدفوع",
    "pending.label": "قيد المراجعة",
    "pending.title": "الطلب قيد المراجعة",
    "pending.subtitle": "تم استلام طلبك ويتم مراجعته من قبل فريق Kaffa Exchange. ستتلقى بريدًا إلكترونيًا فور المعالجة.",
    "pending.rejected_label": "تم رفض الطلب",
    "pending.rejected_title": "تم رفض طلبك",
    "pending.rejected_subtitle": "لم تتم الموافقة على تسجيلك. يمكنك التواصل مع فريقنا أو إرسال طلب جديد بعد معالجة النقاط الموضحة.",
    "pending.rejection_reason_label": "سبب الرفض",
    "pending.contact_cta": "تواصل مع الفريق",
    "pending.email": "البريد الإلكتروني",
    "pending.company": "الشركة",
    "pending.country": "البلد",
    "pending.logout": "تسجيل الخروج",
    "admin.subtab_pending": "قيد الانتظار",
    "admin.subtab_rejected": "المرفوضة",
    "admin.no_rejected": "لا توجد تسجيلات مرفوضة.",
    "admin.col_rejection_reason": "السبب",
    "admin.col_rejected_at": "تاريخ الرفض",
    "admin.restore": "استعادة",
    "admin.user_restored": "تمت إعادة فتح التسجيل للمراجعة",
    "admin.reject_dialog_title": "رفض التسجيل",
    "admin.reject_dialog_reason": "سبب الرفض",
    "admin.reject_dialog_placeholder": "مثلاً: وثائق ناقصة. يرجى إعادة الإرسال برقم ضريبي ساري.",
    "admin.reject_dialog_help": "سيرى المشتري هذا السبب عند محاولة الدخول.",
    "nav.home": "الرئيسية",
    "nav.marketplace": "السوق",
    "nav.tours": "زيارات المزارع",
    "nav.about": "حول",
    "nav.login": "تسجيل الدخول",
    "nav.register": "تسجيل",
    "nav.dashboard": "لوحة التحكم",
    "nav.logout": "تسجيل الخروج",

    "common.bags": "أكياس",
    "common.region": "المنطقة",
    "common.process": "المعالجة",
    "common.search": "ابحث عن دفعات، مزارع، مناطق...",
    "common.all": "الكل",
    "common.cancel": "إلغاء",
    "common.confirm": "تأكيد",
    "common.save": "حفظ",
    "common.loading": "جارٍ التحميل...",
    "common.send": "إرسال",
    "common.edit": "تعديل",
    "common.delete": "حذف",
    "common.create": "إنشاء",
    "common.actions": "إجراءات",
    "common.status": "الحالة",
    "common.date": "التاريخ",
    "common.optional": "اختياري",
    "common.back": "رجوع",
    "common.demo_creds": "بيانات تجريبية",

    "hero.tagline": "كافا إكستشينج · تداول السلع",
    "hero.title": "سوق القهوة العالمي، مرقمن.",
    "hero.subtitle": "منصة B2B للتفاوض والتصدير تربط التعاونيات المنتجة بالمشترين الدوليين.",
    "hero.cta_explore": "استكشاف الدفعات",
    "hero.cta_register": "تسجيل الشركة",
    "hero.stat_bags": "كيس / شهر",
    "hero.stat_coops": "تعاونيات",
    "hero.stat_countries": "دول",
    "hero.live_market": "السوق المباشر",

    "ticker.label": "السوق العالمي",

    "pillar.verify.title": "تحقق كامل",
    "pillar.verify.desc": "كل مشترٍ يمرّ بموافقة يدوية من المكتب الخلفي.",
    "pillar.export.title": "تصدير عالمي",
    "pillar.export.desc": "FOB سانتوس جاهز. لوجستيات دولية متكاملة.",
    "pillar.pricing.title": "تسعير ديناميكي",
    "pillar.pricing.desc": "محرّك يعيد حساب الأسعار عبر مؤشرات عالمية في الوقت الفعلي.",
    "pillar.trace.title": "إمكانية التتبع",
    "pillar.trace.desc": "من المنتج إلى الفنجان: المزرعة، الارتفاع، المعالجة، تقييم SCA.",

    "mission.tagline": "مهمتنا",
    "mission.title": "إضفاء الطابع الديمقراطي على تجارة القهوة بإعادة المزيد من الأموال إلى المنتج.",
    "mission.subtitle": "نربط مباشرةً التعاونيات والمنتجين والمشترين العالميين — لتقليل الوسطاء وزيادة إمكانية التتبع وإعادة قيمة عادلة لمن يزرع.",
    "mission.value1_title": "العدالة الاقتصادية",
    "mission.value1_desc": "تجارة مباشرة تعيد هامشًا أكبر للمنتجين.",
    "mission.value2_title": "تتبع كامل",
    "mission.value2_desc": "كل دفعة لها أصل ومعالجة وقصة موثقة.",
    "mission.value3_title": "التكنولوجيا للزراعة",
    "mission.value3_desc": "محرّك تسعير، مؤشرات عالمية، ولوحات بيانات حديثة.",
    "mission.value4_title": "الاستدامة",
    "mission.value4_desc": "نعطي الأولوية للتعاونيات الحاصلة على شهادات بيئية واجتماعية.",

    "team.tagline": "خلف المنصّة",
    "team.title": "فريق Kaffa Exchange",
    "team.subtitle": "قانون، تكنولوجيا، استراتيجية وقهوة. أربعة قادة يربطون تقاليد قرن من زراعة القهوة بالبنية التحتية الرقمية للتجارة العالمية.",
    "team.member1_name": "غيلهرمي باربوسا",
    "team.member1_role": "الرئيس التنفيذي · قانون الأعمال الزراعية",
    "team.member1_bio": "محامٍ خريج كلية الحقوق بجامعة ساو باولو (Largo São Francisco)، متخصص في قانون الأعمال الزراعية بست سنوات من الممارسة، إضافة إلى قانون الشركات والضرائب. يمتلك تجربة شخصية مباشرة في زراعة القهوة عبر العمل العائلي — مزرعة قهوة في بوسوس دي كالداس تديرها عائلته منذ عام 1939.",
    "team.member2_name": "أليكس فيليبي",
    "team.member2_role": "مدير العمليات · العمليات والاستراتيجية",
    "team.member2_bio": "مؤسس Arcano Projetos de Tecnologia، شركة ناشئة نفّذت مشاريع ابتكار لشركات كبرى مثل BRF و CBA و ArcelorMittal، ومؤسس Rent a Squad للاستعانة الخارجية التقنية المالكة لمنهجية Torke®. عضو مجالس ومرشد ومُقيّم في برامج SEED MG و SEED MS و Capital Empreendedor و Vumbora Startups.",
    "team.member3_name": "سيليو ساليس",
    "team.member3_role": "المدير التقني · التكنولوجيا والابتكار",
    "team.member3_bio": "مستشار استراتيجي بخبرة في شركات متعددة الجنسيات مرموقة مثل Alcoa. يقود عمليات Kaffa Exchange بتركيز على التميّز اللوجستي والعمليات القابلة للتوسع والحوكمة المؤسسية.",
    "team.member4_name": "فالديسي ميغيل",
    "team.member4_role": "مدير الجودة · الجودة والقهوة",
    "team.member4_bio": "مدير أعمال بخبرة تتجاوز 30 عاماً في قطاع القهوة. يتقن عمليات المعالجة والتصدير وضبط الجودة وإدارة العملاء الاستراتيجيين — المرجع التقني للفريق.",

    "lots.public_title": "الدفعات المتاحة",
    "lots.public_subtitle": "كتالوج عام — الأسعار والتفاصيل الكاملة تُفتح بعد اعتماد الحساب.",
    "lots.active": "دفعات نشطة",
    "lots.locked": "سجّل الدخول لرؤية الأسعار والتفاصيل الكاملة",
    "lots.available": "متاح",
    "lots.price_label": "كيس 60 كجم",
    "lots.empty": "لا توجد دفعات تطابق الفلاتر.",
    "lots.filter_type": "الأنواع",
    "lots.filter_process": "المعالجات",
    "lots.filter_region": "المناطق",

    "auth.login_title": "تسجيل الدخول إلى Kaffa Exchange",
    "auth.register_title": "إنشاء حساب تجاري",
    "auth.email": "البريد الإلكتروني",
    "auth.password": "كلمة المرور",
    "auth.razao_social": "اسم الشركة القانوني",
    "auth.cnpj": "الرقم الضريبي",
    "auth.address": "العنوان الكامل",
    "auth.phone": "الهاتف",
    "auth.country": "البلد",
    "auth.commercial": "جهة الاتصال التجارية",
    "auth.submit_login": "تسجيل الدخول",
    "auth.submit_register": "طلب الوصول",
    "auth.no_account": "لا تملك حسابًا بعد؟",
    "auth.has_account": "هل لديك حساب بالفعل؟",
    "auth.request_signup": "طلب الوصول",
    "auth.signin": "تسجيل الدخول",

    "login.tagline": "مكتب التداول · Kaffa Exchange",
    "login.banner_title": "الوصول مقتصر على المشغّلين المعتمدين.",
    "login.banner_subtitle": "التعاونيات والمشترون والمدراء يدخلون إلى السوق من هنا.",
    "login.signin_label": "تسجيل الدخول",

    "register.tagline": "التسجيل · B2B",
    "register.intro": "التسجيل مخصص لشركات الاستيراد والمشغلين التجاريين. بعد الإرسال، يتحقق فريقنا من البيانات قبل فتح الوصول الكامل إلى السوق.",
    "register.verification": "التحقق من الامتثال",
    "register.verification_desc": "KYC للشركات خلال 48 ساعة. بعد الموافقة، تظهر الأسعار وتقييمات SCA والشهادات وإمكانية تقديم العروض.",
    "register.success": "تم إرسال التسجيل للمراجعة",
    "register.placeholder_razao": "Müller Global Coffee Imports GmbH",
    "register.placeholder_cnpj": "00.000.000/0001-00",
    "register.placeholder_country": "البرازيل / ألمانيا / الولايات المتحدة...",
    "register.placeholder_address": "الشارع، الرقم، الحي، المدينة، الرمز البريدي، البلد",
    "register.placeholder_phone": "+971 4 555 0000",
    "register.placeholder_contact": "اسم المسؤول",
    "register.placeholder_email": "contact@company.com",
    "register.placeholder_password": "الحد الأدنى 6 أحرف",
    "register.submitting": "جارٍ الإرسال...",

    "pending.tagline": "الحالة · قيد المراجعة",
    "pending.message": "تم استلام تسجيلك ويخضع للمراجعة من قبل فريق كافا. ستتلقى رسالة بريد إلكتروني فور الموافقة.",
    "pending.submitted_data": "البيانات المرسلة",
    "pending.step1": "تم استلام التسجيل",
    "pending.step2": "قيد المراجعة من المكتب الخلفي (حتى 48 ساعة)",
    "pending.step3": "الموافقة وفتح الوصول",
    "pending.view_market": "عرض السوق",

    "alerts.label": "التنبيهات",
    "alerts.new": "جديدة",
    "alerts.mark_read": "وضع علامة كمقروء",
    "alerts.empty": "لا توجد تنبيهات حاليًا.",

    "footer.subtitle": "منصة B2B لتداول وتصدير القهوة. تربط التعاونيات المنتجة بالمشترين الدوليين بتتبع وتكنولوجيا.",
    "footer.platform": "المنصة",
    "footer.contact": "اتصال",

    "lot.tab_details": "التفاصيل",
    "lot.tab_certs": "الشهادات",
    "lot.tab_docs": "المستندات",
    "lot.tab_history": "سجل الأسعار",
    "lot.origin": "الأصل",
    "lot.cooperative": "التعاونية",
    "lot.notes": "ملاحظات حسية",
    "lot.altitude": "الارتفاع",
    "lot.sieve": "المنخل",
    "lot.crop": "الحصاد",
    "lot.humidity": "الرطوبة",
    "lot.blend": "خلطة",
    "lot.fob": "FOB",
    "lot.demo_interest": "إبداء الاهتمام",
    "lot.demo_interest_short": "اهتمام",
    "lot.propose": "تقديم عرض",
    "lot.propose_short": "عرض",
    "lot.propose_title": "إرسال عرض",
    "lot.interest_title": "إبداء الاهتمام",
    "lot.bags_qty": "الكمية (أكياس)",
    "lot.price_label": "السعر / كيس",
    "lot.message_label": "رسالة",
    "lot.message_placeholder": "شروط التسليم، التواريخ، ملاحظات...",
    "lot.send_proposal": "إرسال العرض",
    "lot.send_interest": "إرسال الاهتمام",
    "lot.not_found": "الدفعة غير موجودة",
    "lot.no_certs": "لا توجد شهادات مسجلة.",
    "lot.no_docs": "لا توجد مستندات مرفقة.",
    "lot.no_history": "لا يوجد سجل أسعار. فعّل التسعير التلقائي لتتبع التغييرات.",
    "lot.proposal_sent": "تم إرسال العرض إلى التعاونية",
    "lot.interest_sent": "تم تسجيل الاهتمام",
    "lot.auto_priced": "تسعير تلقائي · الهامش",
    "lot.total_volume": "الحجم الإجمالي",
    "lot.available_qty": "متاح",
    "lot.bag_price": "كيس 60 كجم",

    "buyer.desk": "مكتب المشتري",
    "buyer.title": "لوحة المشتري",
    "buyer.subtitle": "السوق الكامل وعروضك واهتماماتك.",
    "buyer.tab_market": "السوق",
    "buyer.tab_proposals": "عروضي",
    "buyer.tab_interests": "اهتمامات",
    "buyer.col_lot": "الدفعة",
    "buyer.col_proposed_price": "السعر المقترح",
    "buyer.col_bags": "أكياس",
    "buyer.col_counter": "عرض مضاد",
    "buyer.no_proposals": "لم يتم إرسال عروض.",
    "buyer.no_interests": "لا توجد اهتمامات مسجلة.",

    "coop.desk": "مكتب التعاونية",
    "coop.title": "إدارة الدفعات",
    "coop.new_lot": "دفعة جديدة",
    "coop.kpi_active": "دفعات نشطة",
    "coop.kpi_bags": "إجمالي الأكياس",
    "coop.kpi_pending_props": "عروض قيد الانتظار",
    "coop.kpi_interests": "اهتمامات",
    "coop.tab_lots": "الدفعات",
    "coop.tab_proposals": "العروض",
    "coop.tab_interests": "الاهتمامات",
    "coop.col_lot": "الدفعة",
    "coop.col_type": "النوع",
    "coop.col_bags": "أكياس",
    "coop.col_price": "السعر",
    "coop.col_auto": "تلقائي",
    "coop.col_buyer": "المشتري",
    "coop.no_proposals": "لم يتم استلام عروض.",
    "coop.no_interests": "لا توجد اهتمامات.",
    "coop.accept": "قبول",
    "coop.reject": "رفض",
    "coop.delete_confirm": "هل تريد حذف هذه الدفعة؟",
    "coop.lot_removed": "تم حذف الدفعة",
    "coop.lot_updated": "تم تحديث الحالة",
    "coop.price_recalc": "تم إعادة حساب السعر",
    "coop.lot_published": "تم نشر الدفعة",
    "coop.lot_edited": "تم تحديث الدفعة",
    "coop.response_sent": "تم إرسال الرد",
    "coop.edit_lot": "تعديل الدفعة",
    "coop.create_lot": "دفعة جديدة",
    "coop.update": "تحديث",
    "coop.publish": "نشر الدفعة",
    "coop.field_name": "اسم الدفعة",
    "coop.field_quality": "الجودة",
    "coop.field_currency": "العملة",
    "coop.field_sca": "تقييم SCA",
    "coop.field_farm": "المزرعة",
    "coop.field_city": "المدينة",
    "coop.field_state": "المنطقة",
    "coop.field_port": "ميناء FOB",
    "coop.field_images": "روابط الصور (مفصولة بفاصلة)",
    "coop.field_certs": "الشهادات (مفصولة بفاصلة)",
    "coop.field_notes": "ملاحظات",
    "coop.auto_title": "تحديث السعر التلقائي",
    "coop.auto_desc": "يعيد المحرّك حساب السعر من المؤشرات العالمية (NY Futures, USD/BRL, FOB, الطلب).",
    "coop.margin": "الهامش الخاص (٪)",

    "admin.desk": "المكتب الخلفي · غرفة تحكم المدير",
    "admin.title": "لوحة الإدارة",
    "admin.kpi_active_lots": "دفعات نشطة",
    "admin.kpi_bags": "أكياس / السوق",
    "admin.kpi_buyers": "مشترون نشطون",
    "admin.kpi_pending": "قيد الانتظار",
    "admin.kpi_coops": "تعاونيات",
    "admin.kpi_props": "عروض",
    "admin.chart_region": "الحجم حسب المنطقة (أكياس)",
    "admin.chart_types": "مزيج أنواع القهوة",
    "admin.tab_approvals": "الموافقات",
    "admin.tab_users": "المستخدمون",
    "admin.tab_coops": "التعاونيات",
    "admin.tab_lots": "الدفعات",
    "admin.tab_proposals": "المفاوضات",
    "admin.tab_indicators": "المؤشرات",
    "admin.col_company": "الشركة",
    "admin.col_name": "الاسم",
    "admin.col_role": "الدور",
    "admin.no_pending": "لا توجد موافقات قيد الانتظار.",
    "admin.approve": "موافقة",
    "admin.reject": "رفض",
    "admin.user_approved": "تمت الموافقة على المشتري",
    "admin.user_rejected": "تم رفض المشتري",
    "admin.coop_created": "تم إنشاء التعاونية",
    "admin.coop_user_created": "تم إنشاء مستخدم التعاونية",
    "admin.indicator_updated": "تم تحديث المؤشر",
    "admin.new_coop": "تعاونية جديدة",
    "admin.new_coop_user": "مستخدم تعاونية جديد",
    "admin.coop_descr_label": "الوصف",
    "admin.indicators_help": "تغذّي المؤشرات محرّك التسعير التلقائي. عدّل القيم لمحاكاة سيناريوهات السوق.",
    "admin.select_coop": "اختر...",

    "status.pending": "قيد الانتظار",
    "status.approved": "معتمد",
    "status.rejected": "مرفوض",
    "status.accepted": "مقبول",
    "status.counter": "عرض مضاد",
    "status.closed": "مغلق",
    "status.new": "جديد",
    "status.contacted": "تم التواصل",
    "status.published": "منشور",
    "status.paused": "متوقف",
    "status.draft": "مسودة",
    "status.sold": "مباع",
    "status.expired": "منتهي",
    "status.active": "نشط",

    "login.welcome": "مرحبًا",

    "tours.public_title": "زر المصدر. أبرم العقود مباشرة مع المنتج.",
    "tours.public_subtitle": "زيارات فنية خاصة لمزارع حائزة على جوائز، تنظمها Kaffa Exchange للمشترين والمستوردين المؤهلين. كاب أوف SCA، تدقيق تشغيلي، اجتماعات مباشرة مع المنتجين وإبرام العقود في الموقع.",
    "tours.eyebrow": "زيارات فنية · برنامج B2B",
    "tours.benefit_cupping": "جلسة كاب أوف SCA مع المنتجين",
    "tours.benefit_producers": "لقاءات مباشرة مع المزارعين",
    "tours.benefit_diligence": "تدقيق تشغيلي + مختبر عينات",
    "tours.benefit_logistics": "إقامة ونقل ومترجم شاملة",
    "tours.eligibility_note": "برنامج حصري للمشترين والمستوردين وكبار المشترين والشركات ذات الحجم المؤهل. يتم اعتماد كل برنامج رحلة من قبل فريقنا التجاري.",
    "tours.passenger_info_title": "المسافرون",
    "tours.passenger_info_subtitle": "الاسم الكامل والوثيقة لكل مسافر — تستخدم للحجز وتسجيل الدخول في المزارع.",
    "tours.passenger_n": "المسافر {n}",
    "tours.field_full_name": "الاسم الكامل",
    "tours.field_doc_number": "رقم الوثيقة",
    "tours.field_doc_country": "بلد الإصدار (جواز السفر فقط)",
    "tours.doc_passport": "جواز السفر",
    "tours.doc_cpf": "CPF (البرازيل)",
    "tours.doc_rg": "RG (البرازيل)",
    "tours.doc_other": "أخرى",
    "tours.single_supplement_label": "ملحق المسافر الفردي · +50%",
    "tours.single_supplement_note": "تحمل الحجوزات الفردية رسومًا إضافية بنسبة 50٪ فوق سعر الشخص، تماشيًا مع ممارسات الباقات المؤسسية.",
    "tours.subtotal": "السعر الأساسي · 1 pax",
    "tours.supplement_line": "ملحق فردي (+50٪)",
    "tours.error_passenger_info": "يرجى إدخال الاسم والوثيقة لكل مسافر.",
    "tours.cta": "استكشاف المسارات",
    "tours.duration": "المدة",
    "tours.from_price": "ابتداءً من",
    "tours.per_person": "/ شخص",
    "tours.region": "المنطقة",
    "tours.farms": "المزارع",
    "tours.farms_count": "مزارع",
    "tours.highlights": "أبرز ما في الجولة",
    "tours.includes": "يشمل",
    "tours.gallery": "معرض الصور",
    "tours.request_title": "احجز هذه الجولة",
    "tours.duration_days": "مدة الجولة",
    "tours.days": "أيام",
    "tours.airport": "مطار المغادرة",
    "tours.airport_help": "سنستقبلكم في المطار المختار (ذهابًا وإيابًا).",
    "tours.passengers": "الأشخاص",
    "tours.start_date": "التاريخ المفضل",
    "tours.notes": "ملاحظات",
    "tours.notes_placeholder": "قيود غذائية، اهتمامات محددة، تواريخ بديلة...",
    "tours.estimate": "تقدير الاستثمار",
    "tours.price_per_pax": "للشخص الواحد",
    "tours.total_price": "الإجمالي التقديري",
    "tours.submit": "احجز الجولة",
    "tours.success": "تم إرسال الطلب! سنتواصل معك قريبًا.",
    "tours.login_required": "سجّل الدخول لحجز هذه الجولة",
    "tours.includes_title": "كل شيء مشمول في الجولة",
    "tours.see_route": "عرض المسار",
    "tours.best_season": "أفضل موسم",
    "tours.farms_visited": "المزارع المُزارة",
    "tours.altitude": "الارتفاع",
    "tours.specialty": "التخصص",
    "tours.airports_supported": "المطارات المدعومة",
    "tours.summary": "ملخص",

    "data.coffee.arabica": "أرابيكا",
    "data.coffee.conilon": "كونيلون",
    "data.coffee.robusta": "روبوستا",
    "data.coffee.especial": "مميّز",
    "data.coffee.microlote": "دفعة دقيقة",
    "data.coffee.gourmet": "غورميه",
    "data.process.natural": "طبيعي",
    "data.process.washed": "مغسول",
    "data.process.honey": "هاني",
    "data.process.pulped_natural": "هاني-طبيعي",
    "data.process.anaerobic": "لا هوائي",
    "data.process.fermentado": "مُخمَّر",
    "data.quality.commercial": "تجاري",
    "data.quality.premium": "بريميوم",
    "data.quality.specialty": "مميّز",
    "data.quality.microlot": "دفعة دقيقة",
    "data.region.sul_de_minas": "جنوب ميناس",
    "data.region.cerrado_mineiro": "سيرّادو ميناس",
    "data.region.alta_mogiana": "ألتا موجيانا",
    "data.region.chapada_diamantina": "تشابادا دياماتينا",
    "data.region.espirito_santo": "إسبيريتو سانتو",

    "hero.live_arabica": "أرابيكا",
    "hero.live_ny_futures": "عقود NY",
    "home.experiences_label": "KAFFA EXPERIENCES · مسارات المنشأ",
    "home.airport_pickup": "نقل من المطار",
    "home.translator": "مترجم (PT/EN/ES)",
    "home.sca_cupping": "تذوّق SCA",


    "admin_tours.col_days": "أيام",
    "admin_tours.col_seats": "مقاعد",
    "admin_tours.section_image": "صورة الغلاف",
    "admin_tours.section_basic": "المعلومات الأساسية",
    "admin_tours.section_pricing": "السعر والتوفر",
    "admin_tours.section_content": "المحتوى",
    "admin_tours.section_extras": "إضافات",
    "admin_tours.hero_replace_help": "يمكنك رفع صورة أخرى (JPG / PNG / WebP).",
    "admin_tours.replace_image": "استبدال الصورة",
    "admin_tours.remove_image": "إزالة",
    "admin_tours.image_uploading": "جاري التحميل…",
    "admin_tours.image_upload_cta": "تحميل صورة",
    "admin_tours.image_hint": "JPG / PNG / WebP · بحد أقصى {mb} ميجابايت",
    "admin_tours.field_duration_days": "المدة (أيام)",
    "admin_tours.duration_hint": "عدد أيام ثابت لكل باقة (مثلاً: 7, 10, 15).",
    "admin_tours.field_price_per_person": "السعر لكل شخص (USD)",
    "admin_tours.price_hint": "سعر ثابت لكل باقة. لم يعد يحسب تناسبيًا.",
    "admin_tours.field_dates_seats": "تواريخ المغادرة والمقاعد",
    "admin_tours.pick_dates": "اختر التواريخ",
    "admin_tours.dates_empty": "لم يتم اختيار تواريخ بعد. اضغط \"اختر التواريخ\".",
    "admin_tours.seats_label": "مقاعد",
    "admin_tours.field_description": "الوصف التفصيلي",
    "admin_tours.description_hint": "يدعم الفقرات المتعددة.",
    "admin_tours.summary_hint": "ملخص قصير يظهر في القوائم ونتائج البحث.",
    "admin_tours.err_not_image": "الملف المختار ليس صورة.",
    "admin_tours.err_image_too_big": "الصورة كبيرة جدًا. الحد {mb} ميجابايت.",
    "admin_tours.err_image_read": "فشل قراءة الصورة.",
    "tours.choose_date": "اختر تاريخ المغادرة",
    "tours.seats_left": "مقاعد متاحة",
    "tours.pick_date_first": "اختر تاريخًا أولاً.",
    "tours.not_enough_seats": "المقاعد غير كافية في هذا التاريخ.",
    "tours.about_label": "عن هذه الجولة",
    "team.leadership": "KAFFA · القيادة",
    "team.photo_soon": "الصورة · قريبًا",

    "tours.not_found": "الجولة غير موجودة",
    "tours.contact_disclaimer": "ستتواصل Kaffa Exchange معك لتأكيد التوفر والمواعيد والتعديلات النهائية.",
    "tours.pax_short": "شخص",

    "admin.live_label": "مباشر · Alpha Vantage",
    "admin.refresh_indicators": "تحديث المؤشرات",
    "admin.refresh_done": "تم تحديث المؤشرات",
    "admin.refresh_partial": "تحديث جزئي — قد تبقى بعض المؤشرات على القيم السابقة",
    "admin.refresh_failed": "فشل تحديث المؤشرات",

    "coop.toast.lot_updated": "تم تحديث الدفعة",
    "coop.toast.lot_published": "تم نشر الدفعة",
    "coop.toast.lot_removed": "تم حذف الدفعة",
    "coop.toast.status_updated": "تم تحديث الحالة",
    "coop.toast.price_recalc": "تمت إعادة حساب السعر",
    "coop.toast.response_sent": "تم إرسال الرد",
    "coop.confirm_delete": "هل تريد حذف هذه الدفعة؟",
    "coop.no_proposals_received": "لا توجد عروض مستلمة.",
    "coop.accept_btn": "قبول",
    "coop.reject_btn": "رفض",

    "lot.interest_default_msg": "يرجى إرسال عينات وبطاقة فنية كاملة.",
    "sample.request_btn": "طلب عينة",
    "sample.dialog_title": "طلب عينة فعلية",
    "sample.dialog_subtitle": "استلم عينات من هذه الدفعة على عنوانك للتقييم الحسي.",
    "sample.shipping_title": "عنوان الشحن",
    "sample.use_profile_address": "استخدام العنوان المسجل",
    "sample.use_new_address": "إدخال عنوان جديد",
    "sample.field_recipient": "المستلم",
    "sample.field_address": "العنوان",
    "sample.field_address_placeholder": "الشارع، الرقم، الشقة",
    "sample.field_city": "المدينة",
    "sample.field_state": "المحافظة / الولاية",
    "sample.field_country": "الدولة",
    "sample.field_postal": "الرمز البريدي",
    "sample.field_phone": "هاتف التواصل",
    "sample.field_notes": "ملاحظات للتعاونية",
    "sample.field_notes_placeholder": "مثال: الأولوية، البطاقة الفنية المطلوبة، الموعد...",
    "sample.send_btn": "إرسال الطلب",
    "sample.error_bags": "يرجى إدخال عدد الأكياس.",
    "sample.error_address": "املأ العنوان والمدينة والدولة.",
    "sample.success_toast": "تم إرسال طلب العينة",
    "sample.success_description": "ستتلقى التعاونية تنبيهًا وتبدأ التحضير. يمكنك متابعة الشحنة من هنا.",
    "samples.col_lot": "الدفعة",
    "samples.col_buyer": "المشتري",
    "samples.col_bags": "أكياس",
    "samples.col_shipping": "الشحن",
    "samples.col_tracking": "التتبع",
    "samples.col_status": "الحالة",
    "samples.col_date": "التاريخ",
    "samples.address_profile": "العنوان المسجل",
    "samples.tracking_pending": "قيد الانتظار",
    "samples.status_new": "جديدة",
    "samples.status_preparing": "قيد التحضير",
    "samples.status_shipped": "تم الشحن",
    "samples.status_delivered": "تم التسليم",
    "samples.status_unavailable": "غير متوفرة",
    "samples.manage_btn": "إدارة",
    "samples.manage_title": "إدارة العينة",
    "samples.manage_subtitle": "تحديث الحالة ورقم التتبع وشركة الشحن.",
    "samples.field_status": "الحالة",
    "samples.field_tracking_number": "رقم التتبع",
    "samples.field_tracking_carrier": "شركة الشحن",
    "samples.field_tracking_url": "رابط التتبع",
    "samples.field_internal_notes": "ملاحظات داخلية",
    "samples.save_btn": "حفظ",
    "samples.toast_updated": "تم تحديث العينة",
    "samples.no_samples": "لا توجد عينات مسجلة.",
    "buyer.tab_samples": "العينات",
    "buyer.no_samples": "لم تطلب أي عينات بعد.",
    "coop.tab_samples": "العينات",
    "coop.no_samples": "لا توجد طلبات عينات.",
    "admin.tab_samples": "العينات",
    "admin.no_samples": "لا توجد طلبات عينات مسجلة.",
    "lot.bags_unit": "كجم إجمالي",

    "footer.version": "v1.0 · منصة B2B للقهوة",
    "footer.location": "ساو باولو · البرازيل",
    "footer.copyright": "© 2026 KAFFA EXCHANGE",

    "indicator.arabica_ny": "أرابيكا NY",
    "indicator.conilon_es": "كونيلون ES",
    "indicator.usd_brl": "USD / BRL",
    "indicator.usd_eur": "USD / EUR",
    "indicator.fob_santos": "FOB سانتوس",
    "indicator.export_br": "صادرات البرازيل",
    "indicator.infl_br": "التضخم في البرازيل",
    "indicator.demand_global": "الطلب العالمي",
    "settings.theme": "السمة",

    "pwa.tagline": "KAFFA · تطبيق",
    "pwa.install_title": "ثبّت تطبيق Kaffa",
    "pwa.install_subtitle": "وصول سريع إلى الدفعات والأسعار والزيارات من شاشتك الرئيسية.",
    "pwa.install_cta": "تثبيت",
    "pwa.dismiss": "لاحقًا",

    "admin.tab_visits": "الزيارات",
    "status.archived": "مؤرشف",
    "status.confirmed": "مؤكد",
    "status.cancelled": "ملغى",
    "status.completed": "مكتمل",
    "status.preparing": "قيد التحضير",
    "status.shipped": "تم الشحن",
    "status.delivered": "تم التسليم",
    "status.unavailable": "غير متوفرة",

    "admin_tours.subtab_packages": "الباقات",
    "admin_tours.subtab_requests": "الطلبات",
    "admin_tours.packages_help": "أنشئ وأدر باقات زيارة المزارع المعروضة في /tours.",
    "admin_tours.requests_help": "الطلبات الواردة عبر /tours. يمكنك تأكيدها أو إلغاؤها أو إكمالها.",
    "admin_tours.new_btn": "باقة جديدة",
    "admin_tours.empty": "لا توجد باقات بعد.",
    "admin_tours.req_empty": "لا توجد طلبات بعد.",
    "admin_tours.col_name": "الاسم",
    "admin_tours.col_base_price": "السعر الأساسي",
    "admin_tours.col_status": "الحالة",
    "admin_tours.farms_count": "مزارع",
    "admin_tours.publish": "نشر",
    "admin_tours.draft": "مسودة",
    "admin_tours.dialog_new": "باقة زيارة جديدة",
    "admin_tours.dialog_edit": "تعديل الباقة",
    "admin_tours.form_required": "يرجى ملء الاسم والمنطقة والملخص (PT).",
    "admin_tours.field_name": "الاسم",
    "admin_tours.field_country": "البلد",
    "admin_tours.field_hero_image": "صورة الغلاف (URL)",
    "admin_tours.field_gallery": "المعرض (URLs)",
    "admin_tours.field_summary": "الملخص",
    "admin_tours.field_highlights": "أبرز النقاط",
    "admin_tours.field_farms": "المزارع",
    "admin_tours.field_includes": "ما هو مشمول",
    "admin_tours.field_airports": "المطارات المدعومة",
    "admin_tours.field_seasons": "أفضل المواسم",
    "admin_tours.field_durations": "المدد (أيام)",
    "admin_tours.hint_one_per_line": "عنصر واحد في كل سطر.",
    "admin_tours.hint_farms": "سطر لكل عنصر: الاسم | المدينة | الارتفاع | التخصص",
    "admin_tours.hint_durations": "قائمة مفصولة بفواصل (مثلاً: 7, 10, 15).",
    "admin_tours.status_draft": "مسودة",
    "admin_tours.status_published": "منشور",
    "admin_tours.status_archived": "مؤرشف",
    "admin_tours.toast_created": "تم إنشاء الباقة",
    "admin_tours.toast_updated": "تم تحديث الباقة",
    "admin_tours.toast_status": "تم تحديث الحالة",
    "admin_tours.toast_removed": "تم حذف الباقة",
    "admin_tours.req_toast_updated": "تم تحديث الطلب",
    "admin_tours.confirm_delete": "حذف هذه الباقة؟",
    "admin_tours.save_btn": "حفظ",
    "admin_tours.create_btn": "إنشاء",
    "admin_tours.req_buyer": "المشتري",
    "admin_tours.req_tour": "الباقة",
    "admin_tours.req_total": "الإجمالي",
    "admin_tours.req_when": "متى",
    "admin_tours.req_pending": "قيد الانتظار",
    "admin_tours.req_confirmed": "مؤكدة",
    "admin_tours.req_cancelled": "ملغاة",
    "admin_tours.req_completed": "مكتملة",
    "admin_tours.confirm": "تأكيد",
    "admin_tours.cancel": "إلغاء",
    "admin_tours.complete": "إكمال",
  },

  "zh": {
    "checkout.unavailable_banner": "支付暂时不可用",
    "checkout.unavailable_label": "即将上线：",
    "checkout.unavailable_help": "卡片付款功能即将上线。请先联系 trade@kaffaexchange.com 完成预订。",
    "checkout.error_payment_unavailable": "目前无法支付，我们将尽快与您联系。",
    "checkout.errors.card_declined": "卡片被拒绝。请尝试另一张。",
    "checkout.errors.card_invalid": "无效的卡号。",
    "checkout.errors.card_invalid_exp": "有效期格式错误 (MM/YY)。",
    "checkout.errors.card_invalid_cvv": "无效的 CVV。",
    "checkout.errors.card_expired": "卡片已过期。",
    "checkout.errors.date_unavailable": "该日期已不可用。",
    "checkout.errors.no_seats": "该日期名额不足。",
    "tours.pay_and_book": "支付并预订",
    "checkout.title": "完成预订",
    "checkout.subtitle": "安全支付，即时确认预订。",
    "checkout.demo_mode_banner": "演示模式 · 不会进行实际收费",
    "checkout.summary_label": "订单摘要",
    "checkout.row_tour": "行程",
    "checkout.row_date": "日期",
    "checkout.row_passengers": "乘客",
    "checkout.row_duration": "时长",
    "checkout.row_per_person": "每人",
    "checkout.row_airport": "机场",
    "checkout.total": "总计",
    "checkout.security_note": "信用卡数据不会以明文存储，仅保留卡品牌和后四位。",
    "checkout.card_label": "卡片信息",
    "checkout.card_number": "卡号",
    "checkout.card_name": "持卡人姓名",
    "checkout.card_name_placeholder": "请按卡面填写",
    "checkout.card_exp": "有效期",
    "checkout.pay_button": "支付",
    "checkout.processing": "正在处理付款…",
    "checkout.success_toast": "支付成功",
    "checkout.error_invalid_card": "请检查卡片信息。",
    "checkout.test_cards_label": "测试卡：",
    "checkout.test_success": "模拟成功",
    "checkout.test_declined": "模拟拒付",
    "receipt.title": "付款凭证",
    "receipt.paid_stamp": "已支付",
    "receipt.tour": "行程",
    "receipt.date": "日期",
    "receipt.passengers": "乘客",
    "receipt.airport": "机场",
    "receipt.card": "卡片",
    "receipt.paid_at": "支付时间",
    "receipt.total_paid": "已支付总额",
    "receipt.email_sent": "凭证已发送至 {email}",
    "receipt.download_pdf": "下载 PDF",
    "receipt.close": "关闭",
    "receipt.admin_will_contact": "我们的团队将在 24 小时内联系您以确认后续步骤。",
    "admin_tours.req_order": "订单",
    "admin_tours.req_payment": "付款",
    "admin_tours.payment_paid": "已付款",
    "admin_tours.payment_unpaid": "未付款",
    "pending.label": "审核中",
    "pending.title": "申请审核中",
    "pending.subtitle": "您的申请已收到，正在由 Kaffa Exchange 团队审核。完成后您将收到邮件通知。",
    "pending.rejected_label": "申请已拒绝",
    "pending.rejected_title": "您的申请已被拒绝",
    "pending.rejected_subtitle": "您的注册未通过本次审核。您可以联系我们的团队，或在解决以下问题后重新提交。",
    "pending.rejection_reason_label": "拒绝原因",
    "pending.contact_cta": "联系团队",
    "pending.email": "邮箱",
    "pending.company": "公司",
    "pending.country": "国家",
    "pending.logout": "退出",
    "admin.subtab_pending": "待处理",
    "admin.subtab_rejected": "已拒绝",
    "admin.no_rejected": "暂无被拒注册。",
    "admin.col_rejection_reason": "原因",
    "admin.col_rejected_at": "拒绝时间",
    "admin.restore": "恢复",
    "admin.user_restored": "注册已重新开启以供审核",
    "admin.reject_dialog_title": "拒绝注册",
    "admin.reject_dialog_reason": "拒绝原因",
    "admin.reject_dialog_placeholder": "例如：文件不完整。请使用有效税号重新提交。",
    "admin.reject_dialog_help": "买家在尝试登录时将看到此原因。",
    "nav.home": "首页",
    "nav.marketplace": "市场",
    "nav.tours": "庄园参观",
    "nav.about": "关于",
    "nav.login": "登录",
    "nav.register": "注册",
    "nav.dashboard": "控制台",
    "nav.logout": "退出",

    "common.bags": "袋",
    "common.region": "产区",
    "common.process": "处理法",
    "common.search": "搜索批次、庄园、产区...",
    "common.all": "全部",
    "common.cancel": "取消",
    "common.confirm": "确认",
    "common.save": "保存",
    "common.loading": "加载中...",
    "common.send": "发送",
    "common.edit": "编辑",
    "common.delete": "删除",
    "common.create": "创建",
    "common.actions": "操作",
    "common.status": "状态",
    "common.date": "日期",
    "common.optional": "可选",
    "common.back": "返回",
    "common.demo_creds": "演示账户",

    "hero.tagline": "KAFFA EXCHANGE · 大宗商品交易",
    "hero.title": "全球咖啡市场,数字化。",
    "hero.subtitle": "连接产区合作社与国际买家的B2B交易与出口平台。",
    "hero.cta_explore": "浏览批次",
    "hero.cta_register": "注册企业",
    "hero.stat_bags": "袋/月",
    "hero.stat_coops": "合作社",
    "hero.stat_countries": "国家",
    "hero.live_market": "实时市场",

    "ticker.label": "全球市场",

    "pillar.verify.title": "全面审核",
    "pillar.verify.desc": "所有买家均经过后台人工审核。",
    "pillar.export.title": "全球出口",
    "pillar.export.desc": "桑托斯FOB就绪,集成国际物流。",
    "pillar.pricing.title": "动态定价",
    "pillar.pricing.desc": "引擎依据全球指标实时重算价格。",
    "pillar.trace.title": "可追溯性",
    "pillar.trace.desc": "从农场到杯中:庄园、海拔、处理法、SCA评分。",

    "mission.tagline": "我们的使命",
    "mission.title": "让咖啡贸易民主化,把更多收入还给生产者。",
    "mission.subtitle": "我们直接连接合作社、生产者与全球买家——减少中间环节,提高可追溯性,把公正价值还给耕耘者。",
    "mission.value1_title": "经济公正",
    "mission.value1_desc": "直接交易,让生产者获得更高利润。",
    "mission.value2_title": "完整追溯",
    "mission.value2_desc": "每批次均有来源、处理与故事的完整记录。",
    "mission.value3_title": "农业科技",
    "mission.value3_desc": "定价引擎、全球指标、现代化仪表盘。",
    "mission.value4_title": "可持续性",
    "mission.value4_desc": "优先选择具有环境和社会认证的合作社。",

    "team.tagline": "平台背后",
    "team.title": "Kaffa Exchange 团队",
    "team.subtitle": "法律、科技、战略与咖啡。四位领导者将百年咖啡传统与全球贸易数字基础设施相结合。",
    "team.member1_name": "Guilherme Barbosa",
    "team.member1_role": "首席执行官 · 农业商法",
    "team.member1_bio": "毕业于圣保罗大学法学院(Largo São Francisco)的律师,农业商法专家,具有六年实务经验,同时精通公司法与税法。除法律经验外,他还深度参与家族咖啡事业——一座自1939年起由家族经营的波苏斯-迪卡尔达斯咖啡庄园。",
    "team.member2_name": "Alex Philippe",
    "team.member2_role": "首席运营官 · 运营与战略",
    "team.member2_bio": "Arcano Projetos de Tecnologia 创始人,该公司为 BRF、CBA 和 ArcelorMittal 等大型企业交付创新项目;同时也是 Rent a Squad 的创始人——拥有 Torke® 开发方法论的技术外包公司。SEED MG、SEED MS、Capital Empreendedor、Vumbora Startups 等项目的董事、导师及评审。",
    "team.member3_name": "Célio Sales",
    "team.member3_role": "首席技术官 · 技术与创新",
    "team.member3_bio": "战略咨询顾问,曾任职于 Alcoa 等知名跨国公司。带领 Kaffa Exchange 的运营,聚焦物流卓越、可扩展流程和公司治理。",
    "team.member4_name": "Valdeci Miguel",
    "team.member4_role": "首席质量官 · 品质与咖啡",
    "team.member4_bio": "商业管理专家,在咖啡行业拥有超过30年的经验。精通精加工流程、出口、品质控制与战略客户管理——团队的技术参考者。",

    "lots.public_title": "可售批次",
    "lots.public_subtitle": "公开目录——账户审核通过后开放价格与完整详情。",
    "lots.active": "活跃批次",
    "lots.locked": "登录后查看价格与详情",
    "lots.available": "可售",
    "lots.price_label": "60kg/袋",
    "lots.empty": "没有符合筛选条件的批次。",
    "lots.filter_type": "类型",
    "lots.filter_process": "处理法",
    "lots.filter_region": "产区",

    "auth.login_title": "登录 Kaffa Exchange",
    "auth.register_title": "创建企业账户",
    "auth.email": "邮箱",
    "auth.password": "密码",
    "auth.razao_social": "公司全称",
    "auth.cnpj": "税号 / Tax ID",
    "auth.address": "完整地址",
    "auth.phone": "电话",
    "auth.country": "国家",
    "auth.commercial": "商务联系人",
    "auth.submit_login": "登录",
    "auth.submit_register": "申请访问",
    "auth.no_account": "还没有账户?",
    "auth.has_account": "已经有账户了?",
    "auth.request_signup": "申请访问",
    "auth.signin": "登录",

    "login.tagline": "Trading Desk · Kaffa Exchange",
    "login.banner_title": "访问仅限通过审核的运营人员。",
    "login.banner_subtitle": "合作社、买家与管理员从此进入市场。",
    "login.signin_label": "登录",

    "register.tagline": "入驻 · B2B",
    "register.intro": "注册适用于进口企业和商业运营商。提交后,我们的团队会先验证数据,再开通完整市场访问权。",
    "register.verification": "合规审核",
    "register.verification_desc": "企业 KYC 最长48小时。通过后即可查看价格、SCA 评分、认证并提交报价。",
    "register.success": "注册已提交审核",
    "register.placeholder_razao": "Müller Global Coffee Imports GmbH",
    "register.placeholder_cnpj": "00.000.000/0001-00",
    "register.placeholder_country": "巴西 / 德国 / 美国...",
    "register.placeholder_address": "街道、门牌号、区、市、邮编、国家",
    "register.placeholder_phone": "+86 10 5555 0000",
    "register.placeholder_contact": "联系人姓名",
    "register.placeholder_email": "contact@company.com",
    "register.placeholder_password": "至少6个字符",
    "register.submitting": "发送中...",

    "pending.tagline": "状态 · 审核中",
    "pending.message": "您的注册已收到,正在由 Kaffa 团队审核。审核通过后您将收到邮件通知。",
    "pending.submitted_data": "已提交数据",
    "pending.step1": "已收到注册",
    "pending.step2": "由后台审核(最长48小时)",
    "pending.step3": "审核通过并开通访问",
    "pending.view_market": "查看市场",

    "alerts.label": "通知",
    "alerts.new": "新的",
    "alerts.mark_read": "全部标记已读",
    "alerts.empty": "暂无通知。",

    "footer.subtitle": "B2B 咖啡贸易与出口平台,以可追溯性与技术连接产区合作社与国际买家。",
    "footer.platform": "平台",
    "footer.contact": "联系",

    "lot.tab_details": "详情",
    "lot.tab_certs": "认证",
    "lot.tab_docs": "文档",
    "lot.tab_history": "价格历史",
    "lot.origin": "产地",
    "lot.cooperative": "合作社",
    "lot.notes": "风味描述",
    "lot.altitude": "海拔",
    "lot.sieve": "筛网",
    "lot.crop": "采收年份",
    "lot.humidity": "含水量",
    "lot.blend": "拼配",
    "lot.fob": "FOB",
    "lot.demo_interest": "表达兴趣",
    "lot.demo_interest_short": "兴趣",
    "lot.propose": "提交报价",
    "lot.propose_short": "报价",
    "lot.propose_title": "发送报价",
    "lot.interest_title": "表达兴趣",
    "lot.bags_qty": "数量(袋)",
    "lot.price_label": "单价/袋",
    "lot.message_label": "留言",
    "lot.message_placeholder": "交货条款、日期、备注...",
    "lot.send_proposal": "发送报价",
    "lot.send_interest": "发送兴趣",
    "lot.not_found": "未找到批次",
    "lot.no_certs": "无登记认证。",
    "lot.no_docs": "无附加文档。",
    "lot.no_history": "无价格历史记录。启用自动定价以追踪变更。",
    "lot.proposal_sent": "报价已发送至合作社",
    "lot.interest_sent": "兴趣已登记",
    "lot.auto_priced": "自动定价 · 利润率",
    "lot.total_volume": "总量",
    "lot.available_qty": "可售",
    "lot.bag_price": "60kg/袋",

    "buyer.desk": "买家工作台",
    "buyer.title": "买家控制台",
    "buyer.subtitle": "完整市场、您的报价与兴趣。",
    "buyer.tab_market": "市场",
    "buyer.tab_proposals": "我的报价",
    "buyer.tab_interests": "兴趣",
    "buyer.col_lot": "批次",
    "buyer.col_proposed_price": "报价",
    "buyer.col_bags": "袋数",
    "buyer.col_counter": "还价",
    "buyer.no_proposals": "尚未提交报价。",
    "buyer.no_interests": "尚未登记兴趣。",

    "coop.desk": "合作社工作台",
    "coop.title": "批次管理",
    "coop.new_lot": "新批次",
    "coop.kpi_active": "活跃批次",
    "coop.kpi_bags": "袋数合计",
    "coop.kpi_pending_props": "待处理报价",
    "coop.kpi_interests": "兴趣",
    "coop.tab_lots": "批次",
    "coop.tab_proposals": "报价",
    "coop.tab_interests": "兴趣",
    "coop.col_lot": "批次",
    "coop.col_type": "类型",
    "coop.col_bags": "袋数",
    "coop.col_price": "价格",
    "coop.col_auto": "自动",
    "coop.col_buyer": "买家",
    "coop.no_proposals": "尚未收到报价。",
    "coop.no_interests": "无兴趣。",
    "coop.accept": "接受",
    "coop.reject": "拒绝",
    "coop.delete_confirm": "删除此批次?",
    "coop.lot_removed": "批次已删除",
    "coop.lot_updated": "状态已更新",
    "coop.price_recalc": "价格已重算",
    "coop.lot_published": "批次已发布",
    "coop.lot_edited": "批次已更新",
    "coop.response_sent": "回复已发送",
    "coop.edit_lot": "编辑批次",
    "coop.create_lot": "新批次",
    "coop.update": "更新",
    "coop.publish": "发布批次",
    "coop.field_name": "批次名称",
    "coop.field_quality": "等级",
    "coop.field_currency": "货币",
    "coop.field_sca": "SCA 评分",
    "coop.field_farm": "庄园",
    "coop.field_city": "城市",
    "coop.field_state": "州/省",
    "coop.field_port": "FOB 港口",
    "coop.field_images": "图片URL(逗号分隔)",
    "coop.field_certs": "认证(逗号分隔)",
    "coop.field_notes": "备注",
    "coop.auto_title": "自动价格更新",
    "coop.auto_desc": "引擎根据全球指标(NY期货、USD/BRL、FOB、需求)重算价格。",
    "coop.margin": "自定义利润率(%)",

    "admin.desk": "后台 · 管理员控制中心",
    "admin.title": "管理员仪表板",
    "admin.kpi_active_lots": "活跃批次",
    "admin.kpi_bags": "市场袋数",
    "admin.kpi_buyers": "活跃买家",
    "admin.kpi_pending": "待处理",
    "admin.kpi_coops": "合作社",
    "admin.kpi_props": "报价",
    "admin.chart_region": "按产区销量(袋)",
    "admin.chart_types": "咖啡类型分布",
    "admin.tab_approvals": "审批",
    "admin.tab_users": "用户",
    "admin.tab_coops": "合作社",
    "admin.tab_lots": "批次",
    "admin.tab_proposals": "交易",
    "admin.tab_indicators": "指标",
    "admin.col_company": "公司",
    "admin.col_name": "姓名",
    "admin.col_role": "角色",
    "admin.no_pending": "无待处理审批。",
    "admin.approve": "批准",
    "admin.reject": "拒绝",
    "admin.user_approved": "买家已批准",
    "admin.user_rejected": "买家已拒绝",
    "admin.coop_created": "合作社已创建",
    "admin.coop_user_created": "合作社用户已创建",
    "admin.indicator_updated": "指标已更新",
    "admin.new_coop": "新合作社",
    "admin.new_coop_user": "新合作社用户",
    "admin.coop_descr_label": "描述",
    "admin.indicators_help": "指标为自动定价引擎提供数据。修改数值可模拟市场情景。",
    "admin.select_coop": "选择...",

    "status.pending": "待处理",
    "status.approved": "已批准",
    "status.rejected": "已拒绝",
    "status.accepted": "已接受",
    "status.counter": "还价",
    "status.closed": "已关闭",
    "status.new": "新",
    "status.contacted": "已联系",
    "status.published": "已发布",
    "status.paused": "已暂停",
    "status.draft": "草稿",
    "status.sold": "已售出",
    "status.expired": "已过期",
    "status.active": "活跃",

    "login.welcome": "欢迎",

    "tours.public_title": "走访产地。与生产者直接签约。",
    "tours.public_subtitle": "由 Kaffa Exchange 为合格买家与进口商定制的私人技术性庄园考察:SCA 杯测、运营尽调、与生产者直接洽谈、产地现场签约。",
    "tours.eyebrow": "技术性考察 · B2B 项目",
    "tours.benefit_cupping": "与生产者的 SCA 杯测桌",
    "tours.benefit_producers": "与种植者面对面",
    "tours.benefit_diligence": "运营尽调 + 样品实验室",
    "tours.benefit_logistics": "含住宿、接送与翻译",
    "tours.eligibility_note": "仅面向具备合格采购量的买家、进口商、首席采购及企业开放。每条行程均由我方贸易团队审核。",
    "tours.passenger_info_title": "随行人员",
    "tours.passenger_info_subtitle": "每位随行人员的完整姓名与证件号 — 用于预订与庄园入住登记。",
    "tours.passenger_n": "随行人 {n}",
    "tours.field_full_name": "完整姓名",
    "tours.field_doc_number": "证件号码",
    "tours.field_doc_country": "签发国家(仅限护照)",
    "tours.doc_passport": "护照",
    "tours.doc_cpf": "CPF(巴西)",
    "tours.doc_rg": "RG(巴西)",
    "tours.doc_other": "其他",
    "tours.single_supplement_label": "单人附加费 · +50%",
    "tours.single_supplement_note": "仅 1 人预订时,按企业商务套餐惯例,在人均价基础上加收 50%。",
    "tours.subtotal": "基础价 · 1 pax",
    "tours.supplement_line": "单人附加费(+50%)",
    "tours.error_passenger_info": "请填写每位随行人员的姓名与证件。",
    "tours.cta": "浏览路线",
    "tours.duration": "时长",
    "tours.from_price": "起价",
    "tours.per_person": "/人",

    "admin_tours.col_days": "天数",
    "admin_tours.col_seats": "名额",
    "admin_tours.section_image": "封面图片",
    "admin_tours.section_basic": "基本信息",
    "admin_tours.section_pricing": "价格与可用日期",
    "admin_tours.section_content": "内容",
    "admin_tours.section_extras": "其他信息",
    "admin_tours.hero_replace_help": "你可以上传其他图片 (JPG / PNG / WebP)。",
    "admin_tours.replace_image": "更换图片",
    "admin_tours.remove_image": "移除",
    "admin_tours.image_uploading": "上传中…",
    "admin_tours.image_upload_cta": "上传图片",
    "admin_tours.image_hint": "JPG / PNG / WebP · 最大 {mb} MB",
    "admin_tours.field_duration_days": "时长 (天)",
    "admin_tours.duration_hint": "每条路线的固定天数 (例: 7, 10, 15)。",
    "admin_tours.field_price_per_person": "每人价格 (USD)",
    "admin_tours.price_hint": "每条路线的固定价格。不再按时长比例计算。",
    "admin_tours.field_dates_seats": "出发日期与名额",
    "admin_tours.pick_dates": "选择日期",
    "admin_tours.dates_empty": "尚未选择日期。点击\"选择日期\"开始。",
    "admin_tours.seats_label": "名额",
    "admin_tours.field_description": "详细描述",
    "admin_tours.description_hint": "支持多段落详细描述。",
    "admin_tours.summary_hint": "在列表与搜索结果中显示的简短摘要。",
    "admin_tours.err_not_image": "选定的文件不是图片。",
    "admin_tours.err_image_too_big": "图片过大。最大 {mb} MB。",
    "admin_tours.err_image_read": "图片读取失败。",
    "tours.choose_date": "选择出发日期",
    "tours.seats_left": "剩余名额",
    "tours.pick_date_first": "请先选择一个出发日期。",
    "tours.not_enough_seats": "该日期名额不足。",
    "tours.about_label": "关于此路线",
    "tours.gallery": "图库",
    "tours.region": "产区",
    "tours.farms": "庄园",
    "tours.farms_count": "座庄园",
    "tours.highlights": "亮点",
    "tours.includes": "包含",
    "tours.request_title": "预订此行程",
    "tours.duration_days": "行程时长",
    "tours.days": "天",
    "tours.airport": "出发机场",
    "tours.airport_help": "我们将到您选择的机场接送(往返)。",
    "tours.passengers": "人数",
    "tours.start_date": "首选日期",
    "tours.notes": "备注",
    "tours.notes_placeholder": "饮食限制、特定兴趣、备选日期...",
    "tours.estimate": "投资估算",
    "tours.price_per_pax": "每人",
    "tours.total_price": "估算总价",
    "tours.submit": "预订行程",
    "tours.success": "申请已发送!我们将尽快与您联系。",
    "tours.login_required": "登录后可预订此行程",
    "tours.includes_title": "行程全部包含",
    "tours.see_route": "查看路线",
    "tours.best_season": "最佳季节",
    "tours.farms_visited": "参观庄园",
    "tours.altitude": "海拔",
    "tours.specialty": "专长",
    "tours.airports_supported": "支持的机场",
    "tours.summary": "摘要",

    "data.coffee.arabica": "阿拉比卡",
    "data.coffee.conilon": "科尼隆",
    "data.coffee.robusta": "罗布斯塔",
    "data.coffee.especial": "精品",
    "data.coffee.microlote": "微批次",
    "data.coffee.gourmet": "美食家",
    "data.process.natural": "日晒",
    "data.process.washed": "水洗",
    "data.process.honey": "蜜处理",
    "data.process.pulped_natural": "去皮日晒",
    "data.process.anaerobic": "厌氧发酵",
    "data.process.fermentado": "发酵",
    "data.quality.commercial": "商业级",
    "data.quality.premium": "精选",
    "data.quality.specialty": "精品",
    "data.quality.microlot": "微批次",

    "admin.tab_visits": "庄园参观",
    "status.archived": "已归档",
    "status.confirmed": "已确认",
    "status.cancelled": "已取消",
    "status.completed": "已完成",
    "status.preparing": "准备中",
    "status.shipped": "已发货",
    "status.delivered": "已送达",
    "status.unavailable": "不可用",

    "admin_tours.subtab_packages": "套餐",
    "admin_tours.subtab_requests": "请求",
    "admin_tours.packages_help": "创建并管理在 /tours 公开展示的庄园参观套餐。",
    "admin_tours.requests_help": "通过 /tours 收到的请求。可确认、取消或标记为已完成。",
    "admin_tours.new_btn": "新建套餐",
    "admin_tours.empty": "暂无套餐。",
    "admin_tours.req_empty": "暂无请求。",
    "admin_tours.col_name": "名称",
    "admin_tours.col_base_price": "基础价格",
    "admin_tours.col_status": "状态",
    "admin_tours.farms_count": "庄园",
    "admin_tours.publish": "发布",
    "admin_tours.draft": "草稿",
    "admin_tours.dialog_new": "新增参观套餐",
    "admin_tours.dialog_edit": "编辑套餐",
    "admin_tours.form_required": "请填写名称、产区与简介 (PT)。",
    "admin_tours.field_name": "名称",
    "admin_tours.field_country": "国家",
    "admin_tours.field_hero_image": "主图 (URL)",
    "admin_tours.field_gallery": "图库 (URL)",
    "admin_tours.field_summary": "简介",
    "admin_tours.field_highlights": "亮点",
    "admin_tours.field_farms": "庄园",
    "admin_tours.field_includes": "包含内容",
    "admin_tours.field_airports": "支持机场",
    "admin_tours.field_seasons": "最佳季节",
    "admin_tours.field_durations": "时长 (天)",
    "admin_tours.hint_one_per_line": "每行一项。",
    "admin_tours.hint_farms": "每行: 名称 | 城市 | 海拔 | 特色",
    "admin_tours.hint_durations": "用逗号分隔 (例: 7, 10, 15)。",
    "admin_tours.status_draft": "草稿",
    "admin_tours.status_published": "已发布",
    "admin_tours.status_archived": "已归档",
    "admin_tours.toast_created": "套餐已创建",
    "admin_tours.toast_updated": "套餐已更新",
    "admin_tours.toast_status": "状态已更新",
    "admin_tours.toast_removed": "套餐已删除",
    "admin_tours.req_toast_updated": "请求已更新",
    "admin_tours.confirm_delete": "删除此套餐?",
    "admin_tours.save_btn": "保存",
    "admin_tours.create_btn": "创建",
    "admin_tours.req_buyer": "买家",
    "admin_tours.req_tour": "套餐",
    "admin_tours.req_total": "总计",
    "admin_tours.req_when": "时间",
    "admin_tours.req_pending": "待处理",
    "admin_tours.req_confirmed": "已确认",
    "admin_tours.req_cancelled": "已取消",
    "admin_tours.req_completed": "已完成",
    "admin_tours.confirm": "确认",
    "admin_tours.cancel": "取消",
    "admin_tours.complete": "完成",
    "data.region.sul_de_minas": "南米纳斯",
    "data.region.cerrado_mineiro": "塞拉多·米纳斯",
    "data.region.alta_mogiana": "上莫吉亚纳",
    "data.region.chapada_diamantina": "查帕达·迪亚曼蒂纳",
    "data.region.espirito_santo": "圣埃斯皮里图",

    "hero.live_arabica": "阿拉比卡",
    "hero.live_ny_futures": "纽约期货",
    "home.experiences_label": "KAFFA EXPERIENCES · 产区路线",
    "home.airport_pickup": "机场接送",
    "home.translator": "翻译(PT/EN/ES)",
    "home.sca_cupping": "SCA 杯测",

    "team.leadership": "KAFFA · 领导力",
    "team.photo_soon": "照片 · 即将上传",

    "tours.not_found": "未找到该行程",
    "tours.contact_disclaimer": "Kaffa Exchange 将与您联系以确认可用性、日期与最终细节。",
    "tours.pax_short": "人",

    "admin.live_label": "实时 · Alpha Vantage",
    "admin.refresh_indicators": "刷新指标",
    "admin.refresh_done": "指标已更新",
    "admin.refresh_partial": "部分更新 — 某些指标仍使用之前的数值",
    "admin.refresh_failed": "更新指标失败",

    "coop.toast.lot_updated": "批次已更新",
    "coop.toast.lot_published": "批次已发布",
    "coop.toast.lot_removed": "批次已删除",
    "coop.toast.status_updated": "状态已更新",
    "coop.toast.price_recalc": "价格已重算",
    "coop.toast.response_sent": "回复已发送",
    "coop.confirm_delete": "删除此批次?",
    "coop.no_proposals_received": "暂无收到的报价。",
    "coop.accept_btn": "接受",
    "coop.reject_btn": "拒绝",

    "lot.interest_default_msg": "请发送样品与完整的技术资料。",
    "sample.request_btn": "申请样品",
    "sample.dialog_title": "申请实物样品",
    "sample.dialog_subtitle": "将该批次的样品寄送至您的地址,用于感官评估。",
    "sample.shipping_title": "收货地址",
    "sample.use_profile_address": "使用已登记的地址",
    "sample.use_new_address": "填写新地址",
    "sample.field_recipient": "收件人",
    "sample.field_address": "详细地址",
    "sample.field_address_placeholder": "街道、门牌号、套房",
    "sample.field_city": "城市",
    "sample.field_state": "省 / 州",
    "sample.field_country": "国家",
    "sample.field_postal": "邮政编码",
    "sample.field_phone": "联系电话",
    "sample.field_notes": "给合作社的备注",
    "sample.field_notes_placeholder": "例如:优先度、需要的技术资料、期限……",
    "sample.send_btn": "提交申请",
    "sample.error_bags": "请填写袋数。",
    "sample.error_address": "请填写地址、城市与国家。",
    "sample.success_toast": "样品申请已提交",
    "sample.success_description": "合作社将收到提醒并开始准备。您可以在这里跟踪运输状态。",
    "samples.col_lot": "批次",
    "samples.col_buyer": "买家",
    "samples.col_bags": "袋数",
    "samples.col_shipping": "收货",
    "samples.col_tracking": "物流",
    "samples.col_status": "状态",
    "samples.col_date": "日期",
    "samples.address_profile": "登记地址",
    "samples.tracking_pending": "待处理",
    "samples.status_new": "新建",
    "samples.status_preparing": "准备中",
    "samples.status_shipped": "已发货",
    "samples.status_delivered": "已送达",
    "samples.status_unavailable": "不可用",
    "samples.manage_btn": "管理",
    "samples.manage_title": "管理样品",
    "samples.manage_subtitle": "更新状态、物流单号与承运商。",
    "samples.field_status": "状态",
    "samples.field_tracking_number": "物流单号",
    "samples.field_tracking_carrier": "承运商",
    "samples.field_tracking_url": "物流链接",
    "samples.field_internal_notes": "内部备注",
    "samples.save_btn": "保存",
    "samples.toast_updated": "样品已更新",
    "samples.no_samples": "暂无样品记录。",
    "buyer.tab_samples": "样品",
    "buyer.no_samples": "尚未申请样品。",
    "coop.tab_samples": "样品",
    "coop.no_samples": "暂无样品申请。",
    "admin.tab_samples": "样品",
    "admin.no_samples": "暂无样品申请记录。",
    "lot.bags_unit": "公斤总量",

    "footer.version": "v1.0 · B2B 咖啡贸易",
    "footer.location": "圣保罗 · 巴西",
    "footer.copyright": "© 2026 KAFFA EXCHANGE",

    "indicator.arabica_ny": "阿拉比卡 NY",
    "indicator.conilon_es": "科尼隆 ES",
    "indicator.usd_brl": "美元 / 雷亚尔",
    "indicator.usd_eur": "美元 / 欧元",
    "indicator.fob_santos": "FOB 桑托斯",
    "indicator.export_br": "巴西出口",
    "indicator.infl_br": "巴西通胀",
    "indicator.demand_global": "全球需求",
    "settings.theme": "主题",

    "pwa.tagline": "KAFFA · 应用",
    "pwa.install_title": "安装 Kaffa 应用",
    "pwa.install_subtitle": "从主屏幕快速访问批次、价格和庄园参观。",
    "pwa.install_cta": "安装",
    "pwa.dismiss": "稍后",
  },

  "ja": {
    "checkout.unavailable_banner": "現在お支払いはご利用いただけません",
    "checkout.unavailable_label": "もうすぐです:",
    "checkout.unavailable_help": "カード決済は近日中に有効になります。当面は trade@kaffaexchange.com までご連絡いただき、ご予約を確定してください。",
    "checkout.error_payment_unavailable": "現在お支払いはご利用いただけません。後ほどご連絡いたします。",
    "checkout.errors.card_declined": "カードが拒否されました。別のカードをお試しください。",
    "checkout.errors.card_invalid": "カード番号が無効です。",
    "checkout.errors.card_invalid_exp": "有効期限が無効です (MM/YY)。",
    "checkout.errors.card_invalid_cvv": "CVV が無効です。",
    "checkout.errors.card_expired": "カードの有効期限が切れています。",
    "checkout.errors.date_unavailable": "この日付はご利用いただけません。",
    "checkout.errors.no_seats": "この日付は席が不足しています。",
    "tours.pay_and_book": "支払って予約",
    "checkout.title": "予約を完了",
    "checkout.subtitle": "安全な決済。予約は即時確定されます。",
    "checkout.demo_mode_banner": "デモモード · 実際の課金は発生しません",
    "checkout.summary_label": "注文概要",
    "checkout.row_tour": "ツアー",
    "checkout.row_date": "日付",
    "checkout.row_passengers": "乗客",
    "checkout.row_duration": "期間",
    "checkout.row_per_person": "1名様",
    "checkout.row_airport": "空港",
    "checkout.total": "合計",
    "checkout.security_note": "カード情報は平文では保存されません。ブランドと下4桁のみ保管します。",
    "checkout.card_label": "カード情報",
    "checkout.card_number": "カード番号",
    "checkout.card_name": "カード名義",
    "checkout.card_name_placeholder": "カード表記の通り",
    "checkout.card_exp": "有効期限",
    "checkout.pay_button": "支払う",
    "checkout.processing": "支払いを処理中…",
    "checkout.success_toast": "支払いが承認されました",
    "checkout.error_invalid_card": "カード情報をご確認ください。",
    "checkout.test_cards_label": "テストカード:",
    "checkout.test_success": "シミュレーション成功",
    "checkout.test_declined": "シミュレーション拒否",
    "receipt.title": "支払い領収書",
    "receipt.paid_stamp": "支払済",
    "receipt.tour": "ツアー",
    "receipt.date": "日付",
    "receipt.passengers": "乗客",
    "receipt.airport": "空港",
    "receipt.card": "カード",
    "receipt.paid_at": "支払日時",
    "receipt.total_paid": "支払総額",
    "receipt.email_sent": "領収書を {email} に送信しました",
    "receipt.download_pdf": "PDFをダウンロード",
    "receipt.close": "閉じる",
    "receipt.admin_will_contact": "24時間以内に当社チームより次のステップについてご連絡いたします。",
    "admin_tours.req_order": "注文",
    "admin_tours.req_payment": "支払",
    "admin_tours.payment_paid": "支払済",
    "admin_tours.payment_unpaid": "未払い",
    "pending.label": "審査中",
    "pending.title": "申請を審査中",
    "pending.subtitle": "申請を受領しました。Kaffa Exchange チームが審査中です。完了後にメールでお知らせします。",
    "pending.rejected_label": "申請が却下されました",
    "pending.rejected_title": "申請が却下されました",
    "pending.rejected_subtitle": "今回の審査では登録が承認されませんでした。チームへお問い合わせいただくか、指摘事項を修正後に新しい申請を送信してください。",
    "pending.rejection_reason_label": "却下理由",
    "pending.contact_cta": "チームに連絡",
    "pending.email": "メール",
    "pending.company": "会社",
    "pending.country": "国",
    "pending.logout": "ログアウト",
    "admin.subtab_pending": "保留中",
    "admin.subtab_rejected": "却下",
    "admin.no_rejected": "却下された登録はありません。",
    "admin.col_rejection_reason": "理由",
    "admin.col_rejected_at": "却下日時",
    "admin.restore": "復元",
    "admin.user_restored": "登録を再審査のため再オープンしました",
    "admin.reject_dialog_title": "登録を却下",
    "admin.reject_dialog_reason": "却下理由",
    "admin.reject_dialog_placeholder": "例: 書類不備。有効な税ID で再提出してください。",
    "admin.reject_dialog_help": "バイヤーはログイン時にこの理由を確認します。",
    "nav.home": "ホーム",
    "nav.marketplace": "マーケットプレイス",
    "nav.tours": "農園見学",
    "nav.about": "概要",
    "nav.login": "ログイン",
    "nav.register": "登録",
    "nav.dashboard": "ダッシュボード",
    "nav.logout": "ログアウト",

    "common.bags": "袋",
    "common.region": "産地",
    "common.process": "プロセス",
    "common.search": "ロット、農園、産地を検索...",
    "common.all": "すべて",
    "common.cancel": "キャンセル",
    "common.confirm": "確認",
    "common.save": "保存",
    "common.loading": "読み込み中...",
    "common.send": "送信",
    "common.edit": "編集",
    "common.delete": "削除",
    "common.create": "作成",
    "common.actions": "アクション",
    "common.status": "ステータス",
    "common.date": "日付",
    "common.optional": "任意",
    "common.back": "戻る",
    "common.demo_creds": "デモ認証情報",

    "hero.tagline": "KAFFA EXCHANGE · コモディティ取引",
    "hero.title": "グローバルコーヒー市場を、デジタル化。",
    "hero.subtitle": "生産者協同組合と国際バイヤーをつなぐB2B取引・輸出プラットフォーム。",
    "hero.cta_explore": "ロットを見る",
    "hero.cta_register": "企業登録",
    "hero.stat_bags": "袋/月",
    "hero.stat_coops": "協同組合",
    "hero.stat_countries": "国",
    "hero.live_market": "ライブマーケット",

    "ticker.label": "グローバル市場",

    "pillar.verify.title": "完全な審査",
    "pillar.verify.desc": "すべてのバイヤーはバックオフィスによる手動審査を経ます。",
    "pillar.export.title": "グローバル輸出",
    "pillar.export.desc": "サントスFOB対応、国際物流統合済み。",
    "pillar.pricing.title": "ダイナミックプライシング",
    "pillar.pricing.desc": "エンジンがグローバル指標でリアルタイムに価格を再計算。",
    "pillar.trace.title": "トレーサビリティ",
    "pillar.trace.desc": "生産者からカップまで:農園、標高、プロセス、SCAスコア。",

    "mission.tagline": "私たちのミッション",
    "mission.title": "コーヒー取引を民主化し、生産者により多くの利益を還元する。",
    "mission.subtitle": "協同組合、生産者、グローバルバイヤーを直接つなぎ、中間業者を減らし、トレーサビリティを高め、栽培者に公正な価値を返します。",
    "mission.value1_title": "経済的公正",
    "mission.value1_desc": "直接取引で生産者により大きなマージンを還元。",
    "mission.value2_title": "完全なトレーサビリティ",
    "mission.value2_desc": "各ロットに産地・プロセス・ストーリーが記録されています。",
    "mission.value3_title": "アグリテック",
    "mission.value3_desc": "プライシングエンジン、グローバル指標、モダンなダッシュボード。",
    "mission.value4_title": "サステナビリティ",
    "mission.value4_desc": "環境・社会認証を持つ協同組合を優先します。",

    "team.tagline": "プラットフォームの背景",
    "team.title": "Kaffa Exchange チーム",
    "team.subtitle": "法律、技術、戦略、そしてコーヒー。一世紀のコーヒー伝統とグローバル取引のデジタルインフラをつなぐ4人のリーダー。",
    "team.member1_name": "Guilherme Barbosa",
    "team.member1_role": "CEO · アグリビジネス法",
    "team.member1_bio": "サンパウロ大学法学部(Largo São Francisco)卒。6年の実務経験を持つアグリビジネス法専門弁護士で、企業法・税法にも精通。法律実務に加え、1939年から家族が経営するポソス・デ・カウダスのコーヒー農園を通じて、コーヒー栽培に直接的に関わっています。",
    "team.member2_name": "Alex Philippe",
    "team.member2_role": "COO · オペレーションと戦略",
    "team.member2_bio": "Arcano Projetos de Tecnologia の創業者。BRF、CBA、ArcelorMittal など大手企業向けのイノベーションプロジェクトを手がけました。また、Torke® 開発方法論を所有する技術アウトソーシング会社 Rent a Squad の創業者でもあります。SEED MG、SEED MS、Capital Empreendedor、Vumbora Startups などのプログラムで取締役、メンター、評価者を務めています。",
    "team.member3_name": "Célio Sales",
    "team.member3_role": "CTO · テクノロジーとイノベーション",
    "team.member3_bio": "Alcoa などの著名な多国籍企業での経験を持つ戦略コンサルタント。Kaffa Exchange の運営をリードし、物流の卓越性、スケーラブルなプロセス、コーポレートガバナンスに注力しています。",
    "team.member4_name": "Valdeci Miguel",
    "team.member4_role": "CQO · 品質とコーヒー",
    "team.member4_bio": "コーヒー業界で30年以上の経験を持つビジネス管理者。精製プロセス、輸出、品質管理、戦略的顧客管理を熟知—チームの技術的リファレンス。",

    "lots.public_title": "取扱ロット",
    "lots.public_subtitle": "公開カタログ — アカウント承認後に価格と詳細が開示されます。",
    "lots.active": "アクティブロット",
    "lots.locked": "価格と詳細を見るにはログインしてください",
    "lots.available": "在庫",
    "lots.price_label": "60kg/袋",
    "lots.empty": "フィルター条件に一致するロットはありません。",
    "lots.filter_type": "タイプ",
    "lots.filter_process": "プロセス",
    "lots.filter_region": "産地",

    "auth.login_title": "Kaffa Exchange にログイン",
    "auth.register_title": "ビジネスアカウントを作成",
    "auth.email": "メール",
    "auth.password": "パスワード",
    "auth.razao_social": "法人名",
    "auth.cnpj": "税ID",
    "auth.address": "完全な住所",
    "auth.phone": "電話",
    "auth.country": "国",
    "auth.commercial": "営業担当者",
    "auth.submit_login": "ログイン",
    "auth.submit_register": "アクセス申請",
    "auth.no_account": "アカウントをお持ちでない方は?",
    "auth.has_account": "すでにアカウントをお持ちの方は?",
    "auth.request_signup": "アクセス申請",
    "auth.signin": "ログイン",

    "login.tagline": "Trading Desk · Kaffa Exchange",
    "login.banner_title": "アクセスは承認済みオペレーターに限定。",
    "login.banner_subtitle": "協同組合、バイヤー、管理者はこちらから市場にアクセスします。",
    "login.signin_label": "サインイン",

    "register.tagline": "オンボーディング · B2B",
    "register.intro": "登録は輸入企業および商取引業者向けです。送信後、当チームがデータを確認してから市場への完全アクセスを開放します。",
    "register.verification": "コンプライアンス審査",
    "register.verification_desc": "企業 KYC は最大48時間以内に完了。承認後、価格、SCA スコア、認証を確認し、オファーを提出できます。",
    "register.success": "登録が審査に送信されました",
    "register.placeholder_razao": "Müller Global Coffee Imports GmbH",
    "register.placeholder_cnpj": "00.000.000/0001-00",
    "register.placeholder_country": "日本 / アメリカ / ドイツ...",
    "register.placeholder_address": "番地、町名、市、郵便番号、国",
    "register.placeholder_phone": "+81 3 5555 0000",
    "register.placeholder_contact": "担当者氏名",
    "register.placeholder_email": "contact@company.com",
    "register.placeholder_password": "6文字以上",
    "register.submitting": "送信中...",

    "pending.tagline": "ステータス · 審査中",
    "pending.message": "登録を受け付けました。Kaffa チームにより審査中です。承認され次第メールでお知らせします。",
    "pending.submitted_data": "送信されたデータ",
    "pending.step1": "登録を受領",
    "pending.step2": "バックオフィスにて審査中(最大48時間)",
    "pending.step3": "承認とアクセス開放",
    "pending.view_market": "マーケットプレイスを見る",

    "alerts.label": "アラート",
    "alerts.new": "新着",
    "alerts.mark_read": "すべて既読にする",
    "alerts.empty": "現在アラートはありません。",

    "footer.subtitle": "B2B コーヒー取引・輸出プラットフォーム。トレーサビリティとテクノロジーで生産者協同組合と国際バイヤーをつなぎます。",
    "footer.platform": "プラットフォーム",
    "footer.contact": "お問い合わせ",

    "lot.tab_details": "詳細",
    "lot.tab_certs": "認証",
    "lot.tab_docs": "ドキュメント",
    "lot.tab_history": "価格履歴",
    "lot.origin": "産地",
    "lot.cooperative": "協同組合",
    "lot.notes": "風味ノート",
    "lot.altitude": "標高",
    "lot.sieve": "スクリーン",
    "lot.crop": "収穫年",
    "lot.humidity": "水分",
    "lot.blend": "ブレンド",
    "lot.fob": "FOB",
    "lot.demo_interest": "興味を示す",
    "lot.demo_interest_short": "興味",
    "lot.propose": "オファー送信",
    "lot.propose_short": "オファー",
    "lot.propose_title": "オファーを送信",
    "lot.interest_title": "興味を示す",
    "lot.bags_qty": "数量(袋)",
    "lot.price_label": "価格/袋",
    "lot.message_label": "メッセージ",
    "lot.message_placeholder": "納期条件、日付、備考...",
    "lot.send_proposal": "オファーを送信",
    "lot.send_interest": "興味を送信",
    "lot.not_found": "ロットが見つかりません",
    "lot.no_certs": "認証は登録されていません。",
    "lot.no_docs": "添付ドキュメントはありません。",
    "lot.no_history": "価格履歴はありません。オートプライシングを有効にして変動を追跡してください。",
    "lot.proposal_sent": "オファーを協同組合に送信しました",
    "lot.interest_sent": "興味を登録しました",
    "lot.auto_priced": "オートプライス · マージン",
    "lot.total_volume": "総量",
    "lot.available_qty": "在庫",
    "lot.bag_price": "60kg/袋",

    "buyer.desk": "バイヤーデスク",
    "buyer.title": "バイヤーダッシュボード",
    "buyer.subtitle": "マーケットプレイス全体、オファーと興味の管理。",
    "buyer.tab_market": "マーケット",
    "buyer.tab_proposals": "マイオファー",
    "buyer.tab_interests": "興味",
    "buyer.col_lot": "ロット",
    "buyer.col_proposed_price": "提示価格",
    "buyer.col_bags": "袋数",
    "buyer.col_counter": "カウンターオファー",
    "buyer.no_proposals": "オファーはまだありません。",
    "buyer.no_interests": "興味の登録はまだありません。",

    "coop.desk": "協同組合デスク",
    "coop.title": "ロット管理",
    "coop.new_lot": "新規ロット",
    "coop.kpi_active": "アクティブロット",
    "coop.kpi_bags": "合計袋数",
    "coop.kpi_pending_props": "保留中オファー",
    "coop.kpi_interests": "興味",
    "coop.tab_lots": "ロット",
    "coop.tab_proposals": "オファー",
    "coop.tab_interests": "興味",
    "coop.col_lot": "ロット",
    "coop.col_type": "タイプ",
    "coop.col_bags": "袋数",
    "coop.col_price": "価格",
    "coop.col_auto": "自動",
    "coop.col_buyer": "バイヤー",
    "coop.no_proposals": "オファーの受信はまだありません。",
    "coop.no_interests": "興味の登録はまだありません。",
    "coop.accept": "承諾",
    "coop.reject": "拒否",
    "coop.delete_confirm": "このロットを削除しますか?",
    "coop.lot_removed": "ロットを削除しました",
    "coop.lot_updated": "ステータスを更新しました",
    "coop.price_recalc": "価格を再計算しました",
    "coop.lot_published": "ロットを公開しました",
    "coop.lot_edited": "ロットを更新しました",
    "coop.response_sent": "返答を送信しました",
    "coop.edit_lot": "ロットを編集",
    "coop.create_lot": "新規ロット",
    "coop.update": "更新",
    "coop.publish": "ロットを公開",
    "coop.field_name": "ロット名",
    "coop.field_quality": "品質",
    "coop.field_currency": "通貨",
    "coop.field_sca": "SCAスコア",
    "coop.field_farm": "農園",
    "coop.field_city": "市",
    "coop.field_state": "州/県",
    "coop.field_port": "FOB港",
    "coop.field_images": "画像URL(カンマ区切り)",
    "coop.field_certs": "認証(カンマ区切り)",
    "coop.field_notes": "備考",
    "coop.auto_title": "自動価格更新",
    "coop.auto_desc": "エンジンがグローバル指標(NY先物、USD/BRL、FOB、需要)に基づいて価格を再計算します。",
    "coop.margin": "独自マージン(%)",

    "admin.desk": "バックオフィス · 管理コントロールルーム",
    "admin.title": "管理ダッシュボード",
    "admin.kpi_active_lots": "アクティブロット",
    "admin.kpi_bags": "市場袋数",
    "admin.kpi_buyers": "アクティブバイヤー",
    "admin.kpi_pending": "保留中",
    "admin.kpi_coops": "協同組合",
    "admin.kpi_props": "オファー",
    "admin.chart_region": "産地別ボリューム(袋)",
    "admin.chart_types": "コーヒータイプ構成",
    "admin.tab_approvals": "承認",
    "admin.tab_users": "ユーザー",
    "admin.tab_coops": "協同組合",
    "admin.tab_lots": "ロット",
    "admin.tab_proposals": "交渉",
    "admin.tab_indicators": "指標",
    "admin.col_company": "会社",
    "admin.col_name": "名前",
    "admin.col_role": "ロール",
    "admin.no_pending": "保留中の承認はありません。",
    "admin.approve": "承認",
    "admin.reject": "拒否",
    "admin.user_approved": "バイヤーを承認しました",
    "admin.user_rejected": "バイヤーを拒否しました",
    "admin.coop_created": "協同組合を作成しました",
    "admin.coop_user_created": "協同組合ユーザーを作成しました",
    "admin.indicator_updated": "指標を更新しました",
    "admin.new_coop": "新規協同組合",
    "admin.new_coop_user": "新規協同組合ユーザー",
    "admin.coop_descr_label": "説明",
    "admin.indicators_help": "指標はオートプライシングエンジンに反映されます。値を変更して市場シナリオをシミュレーションできます。",
    "admin.select_coop": "選択...",

    "status.pending": "保留中",
    "status.approved": "承認済み",
    "status.rejected": "拒否",
    "status.accepted": "承諾",
    "status.counter": "カウンターオファー",
    "status.closed": "クローズ",
    "status.new": "新規",
    "status.contacted": "連絡済み",
    "status.published": "公開済み",
    "status.paused": "停止中",
    "status.draft": "下書き",
    "status.sold": "販売済み",
    "status.expired": "期限切れ",
    "status.active": "アクティブ",

    "login.welcome": "ようこそ",

    "tours.public_title": "産地を訪ねる。生産者と直接契約する。",
    "tours.public_subtitle": "Kaffa Exchange が認定バイヤーとインポーターのために設計する、受賞農園へのプライベートな技術視察。SCA カッピング、オペレーショナル・デューデリ、生産者との直接面談、産地での契約締結。",
    "tours.eyebrow": "技術視察 · B2B プログラム",
    "tours.benefit_cupping": "生産者との SCA カッピング",
    "tours.benefit_producers": "生産者との直接対話",
    "tours.benefit_diligence": "オペレーショナル DD + サンプルラボ",
    "tours.benefit_logistics": "宿泊・送迎・通訳込み",
    "tours.eligibility_note": "対象は認定ボリュームを持つバイヤー、インポーター、ヘッドバイヤー、企業のみ。各行程は弊社トレーディングデスクが審査します。",
    "tours.passenger_info_title": "ご参加者",
    "tours.passenger_info_subtitle": "各参加者のフルネームと身分証 — 予約と農園チェックインで使用します。",
    "tours.passenger_n": "参加者 {n}",
    "tours.field_full_name": "氏名(フルネーム)",
    "tours.field_doc_number": "身分証番号",
    "tours.field_doc_country": "発行国(パスポートのみ)",
    "tours.doc_passport": "パスポート",
    "tours.doc_cpf": "CPF(BR)",
    "tours.doc_rg": "RG(BR)",
    "tours.doc_other": "その他",
    "tours.single_supplement_label": "シングル参加追加料金 · +50%",
    "tours.single_supplement_note": "1名参加の場合、コーポレートパッケージ慣行に従い 1人あたり料金に 50% の追加料金を加算します。",
    "tours.subtotal": "ベース料金 · 1 pax",
    "tours.supplement_line": "シングル追加料金(+50%)",
    "tours.error_passenger_info": "全参加者の氏名と身分証を入力してください。",
    "tours.cta": "ルートを見る",
    "tours.duration": "期間",
    "tours.from_price": "から",
    "tours.per_person": "/ 1名",
    "tours.region": "産地",
    "tours.farms": "農園",
    "tours.farms_count": "農園",
    "tours.highlights": "ハイライト",
    "tours.includes": "含まれるもの",
    "tours.gallery": "ギャラリー",
    "tours.request_title": "このツアーを予約",
    "tours.duration_days": "ツアー期間",
    "tours.days": "日",
    "tours.airport": "出発空港",
    "tours.airport_help": "ご指定の空港でお迎えします(往復)。",
    "tours.passengers": "人数",
    "tours.start_date": "希望開始日",
    "tours.notes": "備考",
    "tours.notes_placeholder": "食事制限、特定の関心、代替日程...",
    "tours.estimate": "投資見積もり",
    "tours.price_per_pax": "1名あたり",
    "tours.total_price": "見積総額",
    "tours.submit": "ツアーを予約",
    "tours.success": "申請を送信しました!まもなくご連絡いたします。",
    "tours.login_required": "このツアーを予約するにはログインしてください",
    "tours.includes_title": "ツアーに含まれるすべて",
    "tours.see_route": "ルートを見る",
    "tours.best_season": "ベストシーズン",
    "tours.farms_visited": "訪問する農園",
    "tours.altitude": "標高",
    "tours.specialty": "専門",
    "tours.airports_supported": "対応空港",
    "tours.summary": "概要",

    "data.coffee.arabica": "アラビカ",
    "data.coffee.conilon": "コニロン",
    "data.coffee.robusta": "ロブスタ",
    "data.coffee.especial": "スペシャルティ",
    "data.coffee.microlote": "マイクロロット",
    "data.coffee.gourmet": "グルメ",
    "data.process.natural": "ナチュラル",
    "data.process.washed": "ウォッシュド",
    "data.process.honey": "ハニー",
    "data.process.pulped_natural": "パルプドナチュラル",
    "data.process.anaerobic": "アナエロビック",
    "data.process.fermentado": "ファーメンテッド",
    "data.quality.commercial": "コマーシャル",
    "data.quality.premium": "プレミアム",
    "data.quality.specialty": "スペシャルティ",
    "data.quality.microlot": "マイクロロット",
    "data.region.sul_de_minas": "ミナス南部",
    "data.region.cerrado_mineiro": "セラード・ミネイロ",
    "data.region.alta_mogiana": "アルタ・モジアナ",
    "data.region.chapada_diamantina": "シャパーダ・ジアマンチーナ",
    "data.region.espirito_santo": "エスピリト・サント",

    "hero.live_arabica": "アラビカ",
    "hero.live_ny_futures": "NY先物",
    "home.experiences_label": "KAFFA EXPERIENCES · 産地ルート",
    "home.airport_pickup": "空港送迎",
    "home.translator": "通訳(PT/EN/ES)",
    "home.sca_cupping": "SCA カッピング",


    "admin_tours.col_days": "日数",
    "admin_tours.col_seats": "席",
    "admin_tours.section_image": "メイン画像",
    "admin_tours.section_basic": "基本情報",
    "admin_tours.section_pricing": "価格と空き状況",
    "admin_tours.section_content": "内容",
    "admin_tours.section_extras": "オプション",
    "admin_tours.hero_replace_help": "別の画像をアップロードできます (JPG / PNG / WebP)。",
    "admin_tours.replace_image": "画像を差し替え",
    "admin_tours.remove_image": "削除",
    "admin_tours.image_uploading": "読み込み中…",
    "admin_tours.image_upload_cta": "画像をアップロード",
    "admin_tours.image_hint": "JPG / PNG / WebP · 最大 {mb} MB",
    "admin_tours.field_duration_days": "期間 (日数)",
    "admin_tours.duration_hint": "ツアーごとの固定日数 (例: 7, 10, 15)。",
    "admin_tours.field_price_per_person": "1名様あたりの料金 (USD)",
    "admin_tours.price_hint": "ツアーごとの固定価格。期間に応じて自動計算されません。",
    "admin_tours.field_dates_seats": "出発日と席数",
    "admin_tours.pick_dates": "日付を選択",
    "admin_tours.dates_empty": "まだ日付が選択されていません。「日付を選択」をクリックしてください。",
    "admin_tours.seats_label": "席",
    "admin_tours.field_description": "詳細説明",
    "admin_tours.description_hint": "詳細な複数段落の説明をサポート。",
    "admin_tours.summary_hint": "リストおよび検索結果に表示される簡潔な要約。",
    "admin_tours.err_not_image": "選択したファイルは画像ではありません。",
    "admin_tours.err_image_too_big": "画像が大きすぎます。最大 {mb} MB。",
    "admin_tours.err_image_read": "画像の読み取りに失敗しました。",
    "tours.choose_date": "出発日を選択",
    "tours.seats_left": "席空き",
    "tours.pick_date_first": "先に出発日を選択してください。",
    "tours.not_enough_seats": "この日付には空きが足りません。",
    "tours.about_label": "このルートについて",
    "team.leadership": "KAFFA · リーダーシップ",
    "team.photo_soon": "写真 · 近日公開",

    "tours.not_found": "ツアーが見つかりません",
    "tours.contact_disclaimer": "Kaffa Exchange より、空き状況、日程、最終調整についてご連絡いたします。",
    "tours.pax_short": "名",

    "admin.live_label": "ライブ · Alpha Vantage",
    "admin.refresh_indicators": "指標を更新",
    "admin.refresh_done": "指標を更新しました",
    "admin.refresh_partial": "部分更新 — 一部の指標は以前の値のままです",
    "admin.refresh_failed": "指標の更新に失敗しました",

    "coop.toast.lot_updated": "ロットを更新しました",
    "coop.toast.lot_published": "ロットを公開しました",
    "coop.toast.lot_removed": "ロットを削除しました",
    "coop.toast.status_updated": "ステータスを更新しました",
    "coop.toast.price_recalc": "価格を再計算しました",
    "coop.toast.response_sent": "返答を送信しました",
    "coop.confirm_delete": "このロットを削除しますか?",
    "coop.no_proposals_received": "受信したオファーはありません。",
    "coop.accept_btn": "承諾",
    "coop.reject_btn": "拒否",

    "lot.interest_default_msg": "サンプルと完全な仕様書の送付をお願いします。",
    "sample.request_btn": "サンプルを依頼",
    "sample.dialog_title": "実物サンプルを依頼する",
    "sample.dialog_subtitle": "ロットのサンプルをご指定の住所にお届けし、官能評価にご活用いただけます。",
    "sample.shipping_title": "配送先住所",
    "sample.use_profile_address": "登録済みの住所を使用",
    "sample.use_new_address": "別の住所を入力",
    "sample.field_recipient": "受取人",
    "sample.field_address": "住所",
    "sample.field_address_placeholder": "番地・建物名など",
    "sample.field_city": "市区町村",
    "sample.field_state": "都道府県 / 州",
    "sample.field_country": "国",
    "sample.field_postal": "郵便番号",
    "sample.field_phone": "連絡先電話番号",
    "sample.field_notes": "協同組合へのメモ",
    "sample.field_notes_placeholder": "例:優先度、希望する仕様書、納期...",
    "sample.send_btn": "依頼を送信",
    "sample.error_bags": "袋数を入力してください。",
    "sample.error_address": "住所・市区町村・国を入力してください。",
    "sample.success_toast": "サンプル依頼を送信しました",
    "sample.success_description": "協同組合に通知され、準備が始まります。配送状況はここから確認できます。",
    "samples.col_lot": "ロット",
    "samples.col_buyer": "バイヤー",
    "samples.col_bags": "袋数",
    "samples.col_shipping": "配送",
    "samples.col_tracking": "追跡",
    "samples.col_status": "ステータス",
    "samples.col_date": "日付",
    "samples.address_profile": "登録住所",
    "samples.tracking_pending": "未設定",
    "samples.status_new": "新規",
    "samples.status_preparing": "準備中",
    "samples.status_shipped": "発送済み",
    "samples.status_delivered": "配達済み",
    "samples.status_unavailable": "利用不可",
    "samples.manage_btn": "管理",
    "samples.manage_title": "サンプルを管理",
    "samples.manage_subtitle": "ステータス・追跡番号・配送業者を更新します。",
    "samples.field_status": "ステータス",
    "samples.field_tracking_number": "追跡番号",
    "samples.field_tracking_carrier": "配送業者",
    "samples.field_tracking_url": "追跡URL",
    "samples.field_internal_notes": "内部メモ",
    "samples.save_btn": "保存",
    "samples.toast_updated": "サンプルを更新しました",
    "samples.no_samples": "登録されたサンプルはありません。",
    "buyer.tab_samples": "サンプル",
    "buyer.no_samples": "サンプル依頼はまだありません。",
    "coop.tab_samples": "サンプル",
    "coop.no_samples": "サンプル依頼はありません。",
    "admin.tab_samples": "サンプル",
    "admin.no_samples": "登録されたサンプル依頼はありません。",
    "lot.bags_unit": "kg 合計",

    "footer.version": "v1.0 · B2B コーヒー取引",
    "footer.location": "サンパウロ · ブラジル",
    "footer.copyright": "© 2026 KAFFA EXCHANGE",

    "indicator.arabica_ny": "アラビカ NY",
    "indicator.conilon_es": "コニロン ES",
    "indicator.usd_brl": "USD / BRL",
    "indicator.usd_eur": "USD / EUR",
    "indicator.fob_santos": "FOB サントス",
    "indicator.export_br": "ブラジル輸出",
    "indicator.infl_br": "ブラジル インフレ",
    "indicator.demand_global": "世界需要",
    "settings.theme": "テーマ",

    "pwa.tagline": "KAFFA · アプリ",
    "pwa.install_title": "Kaffa アプリをインストール",
    "pwa.install_subtitle": "ロット、価格、農園訪問にホーム画面から素早くアクセス。",
    "pwa.install_cta": "インストール",
    "pwa.dismiss": "あとで",

    "admin.tab_visits": "訪問",
    "status.archived": "アーカイブ",
    "status.confirmed": "確認済み",
    "status.cancelled": "キャンセル",
    "status.completed": "完了",
    "status.preparing": "準備中",
    "status.shipped": "発送済み",
    "status.delivered": "配達済み",
    "status.unavailable": "利用不可",

    "admin_tours.subtab_packages": "パッケージ",
    "admin_tours.subtab_requests": "リクエスト",
    "admin_tours.packages_help": "/tours で公開される農園訪問パッケージを作成・管理します。",
    "admin_tours.requests_help": "/tours から受信したリクエスト。確認、キャンセル、完了の設定が可能です。",
    "admin_tours.new_btn": "新規パッケージ",
    "admin_tours.empty": "パッケージはまだありません。",
    "admin_tours.req_empty": "リクエストはまだありません。",
    "admin_tours.col_name": "名称",
    "admin_tours.col_base_price": "基本価格",
    "admin_tours.col_status": "ステータス",
    "admin_tours.farms_count": "農園",
    "admin_tours.publish": "公開",
    "admin_tours.draft": "下書き",
    "admin_tours.dialog_new": "新しい訪問パッケージ",
    "admin_tours.dialog_edit": "パッケージを編集",
    "admin_tours.form_required": "名前、地域、概要(PT)を入力してください。",
    "admin_tours.field_name": "名称",
    "admin_tours.field_country": "国",
    "admin_tours.field_hero_image": "メイン画像(URL)",
    "admin_tours.field_gallery": "ギャラリー(URL)",
    "admin_tours.field_summary": "概要",
    "admin_tours.field_highlights": "ハイライト",
    "admin_tours.field_farms": "農園",
    "admin_tours.field_includes": "含まれるもの",
    "admin_tours.field_airports": "対応空港",
    "admin_tours.field_seasons": "ベストシーズン",
    "admin_tours.field_durations": "期間(日数)",
    "admin_tours.hint_one_per_line": "1 行 1 項目。",
    "admin_tours.hint_farms": "1 行 1 件: 名称 | 都市 | 標高 | 専門",
    "admin_tours.hint_durations": "カンマ区切り(例: 7, 10, 15)。",
    "admin_tours.status_draft": "下書き",
    "admin_tours.status_published": "公開済み",
    "admin_tours.status_archived": "アーカイブ",
    "admin_tours.toast_created": "パッケージを作成しました",
    "admin_tours.toast_updated": "パッケージを更新しました",
    "admin_tours.toast_status": "ステータスを更新しました",
    "admin_tours.toast_removed": "パッケージを削除しました",
    "admin_tours.req_toast_updated": "リクエストを更新しました",
    "admin_tours.confirm_delete": "このパッケージを削除しますか?",
    "admin_tours.save_btn": "保存",
    "admin_tours.create_btn": "作成",
    "admin_tours.req_buyer": "バイヤー",
    "admin_tours.req_tour": "パッケージ",
    "admin_tours.req_total": "合計",
    "admin_tours.req_when": "日時",
    "admin_tours.req_pending": "保留中",
    "admin_tours.req_confirmed": "確認済み",
    "admin_tours.req_cancelled": "キャンセル",
    "admin_tours.req_completed": "完了",
    "admin_tours.confirm": "確認",
    "admin_tours.cancel": "キャンセル",
    "admin_tours.complete": "完了する",
  },
};

const LocaleContext = createContext(null);

// Supported app locales (kept in sync with TRANSLATIONS keys).
const SUPPORTED_LOCALES = ["pt-BR", "en", "es", "fr", "pl", "ar", "zh", "ja"];

// Detect the best initial locale from the visitor's browser preferences.
// Returns one of SUPPORTED_LOCALES, falling back to "en" when nothing matches.
const detectBrowserLocale = () => {
  if (typeof navigator === "undefined") return "en";
  const candidates = [
    ...(navigator.languages || []),
    navigator.language,
  ].filter(Boolean);
  for (const raw of candidates) {
    const lower = String(raw).toLowerCase();
    // Portuguese — any pt-* maps to pt-BR (only PT variant we ship).
    if (lower.startsWith("pt")) return "pt-BR";
    // Two-letter prefix match.
    const prefix = lower.split("-")[0];
    const match = SUPPORTED_LOCALES.find((l) => l === prefix || l.toLowerCase() === lower);
    if (match) return match;
  }
  return "en";
};

// Normalize a free-text value (DB or seed) to a translation key segment.
// Examples: "Sul de Minas" -> "sul_de_minas", "Pulped Natural" -> "pulped_natural"
const normalizeKey = (val = "") =>
  String(val)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // strip diacritics
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

export const LocaleProvider = ({ children }) => {
  const [locale, setLocale] = useState(() =>
    localStorage.getItem("kaffa-locale") || detectBrowserLocale()
  );
  const [currency, setCurrency] = useState(() => localStorage.getItem("kaffa-currency") || "USD");
  // FX rates loaded from /api/indicators — only USD_BRL & USD_EUR are used.
  const [fxRates, setFxRates] = useState({ USD_BRL: 5.15, USD_EUR: 0.92 });

  useEffect(() => { localStorage.setItem("kaffa-locale", locale); }, [locale]);
  useEffect(() => { localStorage.setItem("kaffa-currency", currency); }, [currency]);

  // RTL handling for Arabic
  useEffect(() => {
    const html = document.documentElement;
    if (locale === "ar") {
      html.setAttribute("dir", "rtl");
      html.setAttribute("lang", "ar");
    } else {
      html.setAttribute("dir", "ltr");
      html.setAttribute("lang", locale === "pt-BR" ? "pt-BR" : locale);
    }
  }, [locale]);

  // Fetch FX rates from backend indicators once (and refresh when currency changes — cheap).
  useEffect(() => {
    let mounted = true;
    const url = (process.env.REACT_APP_BACKEND_URL || "") + "/api/indicators";
    fetch(url, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : []))
      .then((list) => {
        if (!mounted || !Array.isArray(list)) return;
        const next = { USD_BRL: 5.15, USD_EUR: 0.92 };
        for (const ind of list) {
          if (ind.code === "USD_BRL" && typeof ind.value === "number") next.USD_BRL = ind.value;
          if (ind.code === "USD_EUR" && typeof ind.value === "number") next.USD_EUR = ind.value;
        }
        setFxRates(next);
      })
      .catch(() => {});
    return () => { mounted = false; };
  }, [currency]);

  const t = useMemo(() => (key) => {
    const dict = TRANSLATIONS[locale] || TRANSLATIONS["pt-BR"];
    return dict[key] || TRANSLATIONS["pt-BR"][key] || key;
  }, [locale]);

  // Translate a "data" value (coffee type, process, region, quality) to the active locale.
  // Falls back to the raw value when no translation exists.
  const tData = useMemo(() => (category, value) => {
    if (!value) return value;
    const key = `data.${category}.${normalizeKey(value)}`;
    const dict = TRANSLATIONS[locale] || TRANSLATIONS["pt-BR"];
    return dict[key] || TRANSLATIONS["pt-BR"][key] || value;
  }, [locale]);

  // Convert a numeric price from `fromCur` to the active `currency` (or override).
  const convertPrice = (value, fromCur = "USD", toCur = currency) => {
    if (value == null) return null;
    if (fromCur === toCur) return value;
    // first to USD
    let usd;
    if (fromCur === "USD") usd = value;
    else if (fromCur === "BRL") usd = value / (fxRates.USD_BRL || 5.15);
    else if (fromCur === "EUR") usd = value / (fxRates.USD_EUR || 0.92);
    else usd = value;
    // USD → target
    if (toCur === "USD") return usd;
    if (toCur === "BRL") return usd * (fxRates.USD_BRL || 5.15);
    if (toCur === "EUR") return usd * (fxRates.USD_EUR || 0.92);
    return usd;
  };

  const formatPrice = (value, cur = currency) => {
    if (value == null) return "—";
    const localeMap = { BRL: "pt-BR", USD: "en-US", EUR: "de-DE" };
    try {
      return new Intl.NumberFormat(localeMap[cur] || "en-US", {
        style: "currency", currency: cur, maximumFractionDigits: 2,
      }).format(value);
    } catch {
      return `${cur} ${Number(value).toFixed(2)}`;
    }
  };

  const formatDate = (value) => {
    if (!value) return "";
    const localeMap = {
      "pt-BR": "pt-BR",
      en: "en-US",
      es: "es-ES",
      fr: "fr-FR",
      pl: "pl-PL",
      ar: "ar",
      zh: "zh-CN",
      ja: "ja-JP",
    };
    try {
      return new Date(value).toLocaleDateString(localeMap[locale] || "pt-BR");
    } catch {
      return String(value);
    }
  };

  const formatDateTime = (value) => {
    if (!value) return "";
    const localeMap = {
      "pt-BR": "pt-BR", en: "en-US", es: "es-ES", fr: "fr-FR",
      pl: "pl-PL", ar: "ar", zh: "zh-CN", ja: "ja-JP",
    };
    try {
      return new Date(value).toLocaleString(localeMap[locale] || "pt-BR");
    } catch {
      return String(value);
    }
  };

  const isRtl = locale === "ar";

  return (
    <LocaleContext.Provider value={{
      locale, setLocale,
      currency, setCurrency,
      t, tData,
      formatPrice, formatDate, formatDateTime,
      convertPrice, fxRates,
      isRtl,
    }}>
      {children}
    </LocaleContext.Provider>
  );
};

export const useLocale = () => useContext(LocaleContext);
